import { ReactComponent as Tick } from "assets/Svgs/tick.svg";
import { ReactComponent as HandShanke } from "assets/Svgs/hi.svg";

import { ReactComponent as DashboardIcon } from "assets/Svgs/dashboard.svg";
import { ReactComponent as ReportsIcons } from "assets/Svgs/reports.svg";
import { ReactComponent as WerkeIcon } from "assets/Svgs/werke.svg";
import { ReactComponent as BackupIcon } from "assets/Svgs/backup.svg";
import { ReactComponent as SmallWerke } from "assets/Svgs/smallWerke.svg";

import {
  CalendarMonth,
  EqualizerSharp,
  MilitaryTechOutlined,
} from "@mui/icons-material";

import i18n from "i18n/i18n";

let lang = navigator?.language.split("-")[0]; // e.g "de" from de-DE 


const bannerJson = [
  {
    status: 0, // password reset
    icon: <Tick />,
    title: i18n(lang).assign_new_password,
    description: i18n(lang).register_now,
  },
  {
    status: 0, // initial password
    icon: <HandShanke />,
    title: "Hallo, Vorname nachname!",
    description:
      "Bitte vergeben Sie zunächst ein Passwort, um mit der Einrichtung Ihres Accounts abzuschließen.",
  },
  {
    status: 2, // logoed out
    icon: <Tick />,
    title: "Sie wurden erfolgreich ausgeloggt",
    description: "",
  },
];

const dashbaordMachineCardItem = [
  {
    id: 0,
    title: "METRON 01 CI",
    status: "Slicer",
    iconText: "Artikel 001",
    prodNo: "92843",
  },
  {
    id: 1,
    title: "METRON 02 CI",
    status: "Füllerei",
    iconText: "Artikel 002",
    prodNo: "88993",
  },
  {
    id: 2,
    title: "METRON 03 CI",
    status: "Füllerei",
    iconText: "Artikel 003",
    prodNo: "86354",
  },
  {
    id: 3,
    title: "METRON 04 CI",
    status: "Verpackung",
    iconText: "Artikel 004",
    prodNo: "09800",
  },
  {
    id: 4,
    title: "METRON 05 CI",
    status: "Füllerei",
    iconText: "Artikel 005",
    prodNo: "92843",
  },
  {
    id: 5,
    title: "METRON 06 CI",
    status: "Füllerei",
    iconText: "Artikel 006",
    prodNo: "10109",
  },
];

const backUpListing = [
  {
    _id: "6580a7f3d083c839c2e37cc5",
    name: "Maricela Puckett",
    area: "Lorraine Wong",
  },
  {
    _id: "6580a7f33bce60a47d8d622f",
    name: "Leonard Monroe",
    area: "Hubbard Fulton",
  },
  {
    _id: "6580a7f3b12e6b2c60efd65b",
    name: "Simon Gay",
    area: "Karen Moreno",
  },
  {
    _id: "6580a7f31482137fa1f6cf3b",
    name: "Christian Haynes",
    area: "Barrett Aguilar",
  },
  {
    _id: "6580a7f35bf813c27f609897",
    name: "Stefanie Thompson",
    area: "Jennie Clark",
  },
  {
    _id: "6580a7f3b8149448bd9ed12c",
    name: "Donna Shannon",
    area: "Susanna Morales",
  },
  {
    _id: "6580a7f38a9bbae8fddf78da",
    name: "Dale Carney",
    area: "Lidia Powell",
  },
  {
    _id: "6580a7f3160fd3bced9f5626",
    name: "Valentine Holder",
    area: "Jeannine Case",
  },
  {
    _id: "6580a7f38b91451c38d4b464",
    name: "Lena Mcpherson",
    area: "Herrera Hansen",
  },
  {
    _id: "6580a7f3a2709ad81f43dee4",
    name: "Chaney Weaver",
    area: "Betsy Pope",
  },
  {
    _id: "6580a7f378a11b5c002f1adb",
    name: "Allison Woods",
    area: "Claudia Gibbs",
  },
  {
    _id: "6580a7f320b53799c517264d",
    name: "Gaines Spears",
    area: "Joyner Cole",
  },
  {
    _id: "6580a7f30a07c9cbac78316d",
    name: "Cervantes Walter",
    area: "Roach Alvarado",
  },
  {
    _id: "6580a7f301a7b14eb599f62d",
    name: "Gardner Black",
    area: "Rene Keith",
  },
  {
    _id: "6580a7f326a823eb8e8103ed",
    name: "Delgado Gilmore",
    area: "Hatfield Swanson",
  },
  {
    _id: "6580a7f34492f6ebe1eea3e3",
    name: "Lori Le",
    area: "Flores Knox",
  },
  {
    _id: "6580a7f36e04416d7327d482",
    name: "Leticia Mcgowan",
    area: "Nikki Jones",
  },
  {
    _id: "6580a7f33ac96b054cf33e2d",
    name: "Tameka Bryan",
    area: "Wilkerson Reeves",
  },
  {
    _id: "6580a7f32ebbf37ba53f5db8",
    name: "Blanca Jefferson",
    area: "Rhonda Cardenas",
  },
  {
    _id: "6580a7f3e2e8dedea6a3f96d",
    name: "Cooke Christensen",
    area: "Trina Madden",
  },
  {
    _id: "6580a7f350d5cdc1b5818fc2",
    name: "Consuelo Oneil",
    area: "Jeri Vargas",
  },
  {
    _id: "6580a7f33291910de44a736d",
    name: "Tia Forbes",
    area: "Rita Craig",
  },
  {
    _id: "6580a7f3674b6d84234aed31",
    name: "Jeanne David",
    area: "Finch Ryan",
  },
  {
    _id: "6580a7f3812eb8aa2f48e5ae",
    name: "Conrad Riddle",
    area: "Payne Leblanc",
  },
  {
    _id: "6580a7f3d508521850a25c3a",
    name: "Vicki Jarvis",
    area: "Nolan Gilliam",
  },
  {
    _id: "6580a7f3667d20432002e48d",
    name: "Tammie Williamson",
    area: "Davis Acevedo",
  },
  {
    _id: "6580a7f3873eca85d4333b",
    name: "George Conley",
    area: "Maria Morse",
  },
  {
    _id: "6580a7f387385d433b63b",
    name: "George Conley",
    area: "Maria Morse 28",
  },
  {
    _id: "6a7f3873eca85d433b63b",
    name: "George Conley",
    area: "Maria Morse 29",
  },
  {
    _id: "6580a7f3eca85d433b63b",
    name: "George Conley",
    area: "Maria Morse 30",
  },
];

const faqData = [
  {
    id: 1,
    question: "This is a question 1?",
    answer:
      "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim.",
  },
  {
    id: 2,
    question: "This is a question 2?",
    answer:
      "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim.",
  },
  {
    id: 3,
    question: "This is a question 3?",
    answer:
      "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim.",
  },
  {
    id: 4,
    question: "This is a question 4?",
    answer:
      "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim.",
  },
  {
    id: 5,
    question: "This is a question 5?",
    answer:
      "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim.",
  },
];

const maintenanceData = [
  {
    maintenancetask: {
      title: {
        de: "Allgemeine Inspektion der Gesamtmaschine",
      },
      description: {},
      reminder: "2w",
      repetitioninterval: "3m",
      startingfrom: 1675638000000,
      specifier: null,
      created: 0,
      notificationstatus: 2,

      nodeid: "247fn://mesutronic.de/abc-maintenancetask1",
      hascategory: [
        {
          maintenancecategory: {
            name: {
              de: "Routineinspektion",
            },
            colorcode: "#1172d4",
            nodeid: "247fn://mesutronic.de/abc-maintenancecategory1",
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1619647200000,
            title: {},
            description: {},
            nodeid: "247fn://mesutronic.de/abc-workflow1",
            isworkflowof: [
              {
                notification: {
                  nodeid:
                    "247fn://mesutronic.de/4802720c-63e1-463f-bbfd-1da90442706e",
                },
              },
            ],
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 0,
                  title: {},
                  description: {
                    de: "1. Maschine ausschalten, Maschine öffnen und Verkleidungen abnehmen, Sichtkontrolle.\n2. Probelauf\n3. Dokumentation",
                  },
                  nodeid: "247fn://mesutronic.de/abc-workflowstep1",
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    maintenancetask: {
      title: {
        de: "Austausch Schmiermittel",
      },
      description: {},
      reminder: "2w",
      repetitioninterval: "1y",
      startingfrom: 1676847600000,
      specifier: null,
      created: 0,
      notificationstatus: 2,
      nodeid: "247fn://mesutronic.de/abc-maintenancetask2",
      hascategory: [
        {
          maintenancecategory: {
            name: {
              de: "Routinewartung",
            },
            colorcode: "#d40ee6",
            nodeid: "247fn://mesutronic.de/abc-maintenancecategory2",
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1619647200000,
            title: {},
            description: {},
            nodeid: "247fn://mesutronic.de/abc-workflow2",
            isworkflowof: [
              {
                notification: {
                  nodeid: "247fn://mesutronic.de/abc-notification5",
                },
              },
              {
                notification: {
                  nodeid:
                    "247fn://mesutronic.de/b40d6a3d-bb81-452b-8e0a-c03f5bfb05a4",
                },
              },
            ],
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 0,
                  title: {},
                  description: {
                    de: "1. Überprüfung Zustand Schmiermittel\n2. Entfernen den alten Schmiermittels\n3. Befüllung neues Schmiermittel\n4. Probelauf\n5. Dokumentstaion",
                  },
                  nodeid: "247fn://mesutronic.de/abc-workflowstep2",
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    maintenancetask: {
      title: {
        de: "DGUV V3 Prüfung elektrische Betriebsmittel",
      },
      description: {},
      reminder: "2w",
      repetitioninterval: "1y",
      startingfrom: 1676847600000,
      specifier: null,
      created: 0,
      notificationstatus: 2,
      nodeid: "247fn://mesutronic.de/abc-maintenancetask3",
      hascategory: [
        {
          maintenancecategory: {
            name: {
              de: "Routinewartung",
            },
            colorcode: "#d40ee6",
            nodeid: "247fn://mesutronic.de/abc-maintenancecategory2",
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1619647200000,
            title: {},
            description: {},
            nodeid: "247fn://mesutronic.de/abc-workflow3",
            isworkflowof: [
              {
                notification: {
                  nodeid: "247fn://mesutronic.de/abc-notification1",
                },
              },
              {
                notification: {
                  nodeid:
                    "247fn://mesutronic.de/66fa0b6f-79ec-4a71-bd93-3341535ed00a",
                },
              },
            ],
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 0,
                  title: {},
                  description: {
                    de: "1. Vorgehen gemäß Wartungsanleitung\n2. Dokumentation",
                  },
                  nodeid: "247fn://mesutronic.de/abc-workflowstep3",
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    maintenancetask: {
      title: {
        de: "Kundendienst - Jahreswartung",
      },
      description: {},
      reminder: "2w",
      repetitioninterval: "1y",
      startingfrom: 1676847600000,
      specifier: null,
      created: 0,
      notificationstatus: 2,
      nodeid: "247fn://mesutronic.de/abc-maintenancetask4",
      hascategory: [
        {
          maintenancecategory: {
            name: {
              de: "Kundendienst",
            },
            colorcode: "#e36a0e",
            nodeid: "247fn://mesutronic.de/abc-maintenancecategory3",
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1619647200000,
            title: {},
            description: {},
            nodeid: "247fn://mesutronic.de/abc-workflow4",
            isworkflowof: [
              {
                notification: {
                  nodeid: "247fn://mesutronic.de/abc-notification7",
                },
              },
              {
                notification: {
                  nodeid:
                    "247fn://mesutronic.de/de21c29a-72d4-4ee4-a02d-1af174c595f2",
                },
              },
            ],
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 0,
                  title: {},
                  description: {
                    de: "Durchführung durch Kundendienst",
                  },
                  nodeid: "247fn://mesutronic.de/abc-workflowstep4",
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    maintenancetask: {
      title: {
        de: "Allgemeine Inspektion der Gesamtmaschine",
      },
      description: {},
      reminder: "2w",
      repetitioninterval: "3m",
      startingfrom: 1675638000000,
      specifier: null,
      created: 0,
      notificationstatus: 0,

      nodeid: "247fn://mesutronic.de/abc-maintenancetask1",
      hascategory: [
        {
          maintenancecategory: {
            name: {
              de: "Routineinspektion",
            },
            colorcode: "#1172d4",
            nodeid: "247fn://mesutronic.de/abc-maintenancecategory1",
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1619647200000,
            title: {},
            description: {},
            nodeid: "247fn://mesutronic.de/abc-workflow1",
            isworkflowof: [
              {
                notification: {
                  nodeid:
                    "247fn://mesutronic.de/4802720c-63e1-463f-bbfd-1da90442706e",
                },
              },
            ],
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 0,
                  title: {},
                  description: {
                    de: "1. Maschine ausschalten, Maschine öffnen und Verkleidungen abnehmen, Sichtkontrolle.\n2. Probelauf\n3. Dokumentation",
                  },
                  nodeid: "247fn://mesutronic.de/abc-workflowstep1",
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    maintenancetask: {
      title: {
        de: "Austausch Schmiermittel",
      },
      description: {},
      reminder: "2w",
      repetitioninterval: "1y",
      startingfrom: 1676847600000,
      specifier: null,
      created: 0,
      notificationstatus: 0,
      nodeid: "247fn://mesutronic.de/abc-maintenancetask2",
      hascategory: [
        {
          maintenancecategory: {
            name: {
              de: "Routinewartung",
            },
            colorcode: "#d40ee6",
            nodeid: "247fn://mesutronic.de/abc-maintenancecategory2",
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1619647200000,
            title: {},
            description: {},
            nodeid: "247fn://mesutronic.de/abc-workflow2",
            isworkflowof: [
              {
                notification: {
                  nodeid: "247fn://mesutronic.de/abc-notification5",
                },
              },
              {
                notification: {
                  nodeid:
                    "247fn://mesutronic.de/b40d6a3d-bb81-452b-8e0a-c03f5bfb05a4",
                },
              },
            ],
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 0,
                  title: {},
                  description: {
                    de: "1. Überprüfung Zustand Schmiermittel\n2. Entfernen den alten Schmiermittels\n3. Befüllung neues Schmiermittel\n4. Probelauf\n5. Dokumentstaion",
                  },
                  nodeid: "247fn://mesutronic.de/abc-workflowstep2",
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    maintenancetask: {
      title: {
        de: "DGUV V3 Prüfung elektrische Betriebsmittel",
      },
      description: {},
      reminder: "2w",
      repetitioninterval: "1y",
      startingfrom: 1676847600000,
      specifier: null,
      created: 0,
      notificationstatus: 0,
      nodeid: "247fn://mesutronic.de/abc-maintenancetask3",
      hascategory: [
        {
          maintenancecategory: {
            name: {
              de: "Routinewartung",
            },
            colorcode: "#d40ee6",
            nodeid: "247fn://mesutronic.de/abc-maintenancecategory2",
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1619647200000,
            title: {},
            description: {},
            nodeid: "247fn://mesutronic.de/abc-workflow3",
            isworkflowof: [
              {
                notification: {
                  nodeid: "247fn://mesutronic.de/abc-notification1",
                },
              },
              {
                notification: {
                  nodeid:
                    "247fn://mesutronic.de/66fa0b6f-79ec-4a71-bd93-3341535ed00a",
                },
              },
            ],
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 0,
                  title: {},
                  description: {
                    de: "1. Vorgehen gemäß Wartungsanleitung\n2. Dokumentation",
                  },
                  nodeid: "247fn://mesutronic.de/abc-workflowstep3",
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    maintenancetask: {
      title: {
        de: "Kundendienst - Jahreswartung",
      },
      description: {},
      reminder: "2w",
      repetitioninterval: "1y",
      startingfrom: 1676847600000,
      specifier: null,
      created: 0,
      notificationstatus: 2,
      nodeid: "247fn://mesutronic.de/abc-maintenancetask4",
      hascategory: [
        {
          maintenancecategory: {
            name: {
              de: "Kundendienst",
            },
            colorcode: "#e36a0e",
            nodeid: "247fn://mesutronic.de/abc-maintenancecategory3",
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1619647200000,
            title: {},
            description: {},
            nodeid: "247fn://mesutronic.de/abc-workflow4",
            isworkflowof: [
              {
                notification: {
                  nodeid: "247fn://mesutronic.de/abc-notification7",
                },
              },
              {
                notification: {
                  nodeid:
                    "247fn://mesutronic.de/de21c29a-72d4-4ee4-a02d-1af174c595f2",
                },
              },
            ],
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 0,
                  title: {},
                  description: {
                    de: "Durchführung durch Kundendienst",
                  },
                  nodeid: "247fn://mesutronic.de/abc-workflowstep4",
                },
              },
            ],
          },
        },
      ],
    },
  },
];

const preImages = [
  {
    nodeid: "1",
    uuid: "u1",
    url: "https://images.pexels.com/photos/1145434/pexels-photo-1145434.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
  },
  {
    nodeid: "2",
    uuid: "u2",
    url: "https://media.istockphoto.com/id/887465766/photo/road-construction-machinery-on-the-construction-of-highway.jpg?s=612x612&w=0&k=20&c=75DpFIj4gUJ7gPodIGAcKkpS2JScsoeQLGcGRxFRgLg=",
  },
  {
    nodeid: "3",
    uuid: "u3",
    url: "https://images.unsplash.com/photo-1624880403473-4244deee045a?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8bWFjaGluZXxlbnwwfHwwfHx8MA%3D%3D",
  },
  {
    nodeid: "4",
    uuid: "u4",
    url: "https://img.freepik.com/free-photo/old-technology-new-using-computer-circuits-old-machine-cogs_587448-4802.jpg",
  },
];

const preVideos = [
  {
    uuid: "u1",
    description:
      "Big Buck Bunny tells the story of a giant rabbit with a heart bigger than himself. When one sunny day three rodents rudely harass him, something snaps... and the rabbit ain't no bunny anymore! In the typical cartoon tradition he prepares the nasty rodents a comical revenge.\n\nLicensed under the Creative Commons Attribution license\nhttp://www.bigbuckbunny.org",
    sources:
      "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",

    subtitle: "By Blender Foundation",
    thumb: "images/BigBuckBunny.jpg",
    title: "Big Buck Bunny",
  },
  {
    uuid: "u2",
    description: "The first Blender Open Movie from 2006",
    sources:
      "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4",
    subtitle: "By Blender Foundation",
    thumb: "images/ElephantsDream.jpg",
    title: "Elephant Dream",
  },
  {
    uuid: "u3",
    description:
      "HBO GO now works with Chromecast -- the easiest way to enjoy online video on your TV. For when you want to settle into your Iron Throne to watch the latest episodes. For $35.\nLearn how to use Chromecast with HBO GO and more at google.com/chromecast.",
    sources:
      "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4",
    subtitle: "By Google",
    thumb: "images/ForBiggerBlazes.jpg",
    title: "For Bigger Blazes",
  },
  {
    uuid: "u4",
    description:
      "Introducing Chromecast. The easiest way to enjoy online video and music on your TV—for when Batman's escapes aren't quite big enough. For $35. Learn how to use Chromecast with Google Play Movies and more at google.com/chromecast.",
    sources:
      "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4",
    subtitle: "By Google",
    thumb: "images/ForBiggerEscapes.jpg",
    title: "For Bigger Escape",
  },
];

const preDocs = [
  {
    title: "title 1",
    description: "description 1",
    nodeid: "1",
    uuid: "u1",
    url: "https://example-files.online-convert.com/document/txt/example.txt",
    mimetype: "text/plain",
  },
  {
    title: "title 2",
    description: "description 2",
    nodeid: "2",
    uuid: "u2",
    url: "https://example-files.online-convert.com/document/txt/example.txt",
    mimetype: "text/plain",
  },
  {
    title: "title 3",
    description: "description 3",
    nodeid: "3",
    uuid: "u3",
    url: "https://example-files.online-convert.com/document/txt/example.txt",
    mimetype: "text/plain",
  },
  {
    title: "title 4",
    description: "description 4",
    nodeid: "4",
    uuid: "u4",
    url: "https://example-files.online-convert.com/document/txt/example.txt",
    mimetype: "text/plain",
  },
];

const subscribedSites = JSON.parse(`{
  "247fn://247uptime.io/abc-site1": {
      "name": "Werk 1",
      "nodeid": "247fn://247uptime.io/abc-site1",
      "hasarea": [
          {
              "area": {
                  "name": "Gehäusefertigung",
                  "nodeid": "247fn://247uptime.io/abc-area1",
                  "hasequipment": [
                      {
                          "equipment": {
                              "name": "Nachbearbeitung Drehteile",
                              "equipmentid": "103",
                              "inventoryid": "i103",
                              "constructiondate": "2017",
                              "manufacturerserialnumber": "emco8765432",
                              "memo": "wird z.Zt. nur Spätschicht genutzt",
                              "image": {
                                  "fileid": "103a58a5-9aec-43df-9591-f8816014d542/103a58a5-9aec-43df-9591-f8816014d543.jpg",
                                  "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                                  "mimetype": "image/jpeg",
                                  "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq103/103a58a5-9aec-43df-9591-f8816014d542/103a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=ada55d7086a8fe45cfb975de421a25ca60b27c157d4b2fcc6d37445ce94e5e8f"
                              },
                              "nodeid": "247fn://247uptime.io/abc-eq103",
                              "hasmaintenancetask": [
                                  {
                                      "maintenancetask": {
                                          "title": "Allgemeine Inspektion der Gesamtmaschine",
                                          "description": null,
                                          "reminder": "2w",
                                          "repetitioninterval": "3m",
                                          "startingfrom": 1675638000000,
                                          "specifier": null,
                                          "created": 0,
                                          "nodeid": "247fn://247uptime.io/abc-maintenancetask1",
                                          "hascategory": [
                                              {
                                                  "maintenancecategory": {
                                                      "name": "Routineinspektion",
                                                      "colorcode": "#1172d4",
                                                      "nodeid": "247fn://247uptime.io/abc-maintenancecategory1"
                                                  }
                                              }
                                          ]
                                      }
                                  },
                                  {
                                      "maintenancetask": {
                                          "title": "Austausch Schmiermittel",
                                          "description": null,
                                          "reminder": "2w",
                                          "repetitioninterval": "1y",
                                          "startingfrom": 1676847600000,
                                          "specifier": null,
                                          "created": 0,
                                          "nodeid": "247fn://247uptime.io/abc-maintenancetask2",
                                          "hascategory": [
                                              {
                                                  "maintenancecategory": {
                                                      "name": "Routinewartung",
                                                      "colorcode": "#d40ee6",
                                                      "nodeid": "247fn://247uptime.io/abc-maintenancecategory2"
                                                  }
                                              }
                                          ]
                                      }
                                  },
                                  {
                                      "maintenancetask": {
                                          "title": "DGUV V3 Prüfung elektrische Betriebsmittel",
                                          "description": null,
                                          "reminder": "2w",
                                          "repetitioninterval": "1y",
                                          "startingfrom": 1676847600000,
                                          "specifier": null,
                                          "created": 0,
                                          "nodeid": "247fn://247uptime.io/abc-maintenancetask3",
                                          "hascategory": [
                                              {
                                                  "maintenancecategory": {
                                                      "name": "Routinewartung",
                                                      "colorcode": "#d40ee6",
                                                      "nodeid": "247fn://247uptime.io/abc-maintenancecategory2"
                                                  }
                                              }
                                          ]
                                      }
                                  },
                                  {
                                      "maintenancetask": {
                                          "title": "Kundendienst - Jahreswartung",
                                          "description": null,
                                          "reminder": "2w",
                                          "repetitioninterval": "1y",
                                          "startingfrom": 1676847600000,
                                          "specifier": null,
                                          "created": 0,
                                          "nodeid": "247fn://247uptime.io/abc-maintenancetask4",
                                          "hascategory": [
                                              {
                                                  "maintenancecategory": {
                                                      "name": "Kundendienst",
                                                      "colorcode": "#e36a0e",
                                                      "nodeid": "247fn://247uptime.io/abc-maintenancecategory3"
                                                  }
                                              }
                                          ]
                                      }
                                  },
                                  {
                                      "maintenancetask": {
                                          "title": "test 2111",
                                          "description": null,
                                          "reminder": "1w",
                                          "repetitioninterval": "1y",
                                          "startingfrom": 1705363200000,
                                          "specifier": null,
                                          "created": 0,
                                          "nodeid": "247fn://247uptime.io/d88a60e9-96b0-46e8-b2bb-93e902315c58",
                                          "hascategory": [
                                              {
                                                  "maintenancecategory": {
                                                      "name": "Kundendienst",
                                                      "colorcode": "#e36a0e",
                                                      "nodeid": "247fn://247uptime.io/abc-maintenancecategory3"
                                                  }
                                              }
                                          ]
                                      }
                                  },
                                  {
                                      "maintenancetask": {
                                          "title": "test maintenance task",
                                          "description": null,
                                          "reminder": "1w",
                                          "repetitioninterval": "3m",
                                          "startingfrom": 1705968000000,
                                          "specifier": null,
                                          "created": 0,
                                          "nodeid": "247fn://247uptime.io/461cedb8-6ed3-42e9-9ad1-3dcaefb9efdd",
                                          "hascategory": [
                                              {
                                                  "maintenancecategory": {
                                                      "name": "Kundendienst",
                                                      "colorcode": "#e36a0e",
                                                      "nodeid": "247fn://247uptime.io/abc-maintenancecategory3"
                                                  }
                                              }
                                          ]
                                      }
                                  },
                                  {
                                      "maintenancetask": {
                                          "title": "test maintenance tasks",
                                          "description": null,
                                          "reminder": "1w",
                                          "repetitioninterval": "3m",
                                          "startingfrom": 1705968000000,
                                          "specifier": null,
                                          "created": 0,
                                          "nodeid": "247fn://247uptime.io/599b98ec-57b4-42fe-92b8-0437a00f2e8b",
                                          "hascategory": [
                                              {
                                                  "maintenancecategory": {
                                                      "name": "Kundendienst",
                                                      "colorcode": "#e36a0e",
                                                      "nodeid": "247fn://247uptime.io/abc-maintenancecategory3"
                                                  }
                                              }
                                          ]
                                      }
                                  },
                                  {
                                      "maintenancetask": {
                                          "title": "test alpha 11222",
                                          "description": null,
                                          "reminder": "2w",
                                          "repetitioninterval": "6m",
                                          "startingfrom": 1706227200000,
                                          "specifier": null,
                                          "created": 0,
                                          "nodeid": "247fn://247uptime.io/f03e9745-c530-4ed8-b09f-0bfa3f741a89",
                                          "hascategory": [
                                              {
                                                  "maintenancecategory": {
                                                      "name": "Routineinspektion",
                                                      "colorcode": "#1172d4",
                                                      "nodeid": "247fn://247uptime.io/abc-maintenancecategory1"
                                                  }
                                              }
                                          ]
                                      }
                                  },
                                  {
                                      "maintenancetask": {
                                          "title": "testing new costs",
                                          "description": null,
                                          "reminder": "2w",
                                          "repetitioninterval": "6m",
                                          "startingfrom": 1706227200000,
                                          "specifier": null,
                                          "created": 0,
                                          "nodeid": "247fn://247uptime.io/3f4ef7e7-d161-46a5-ac2f-4506eab07968",
                                          "hascategory": [
                                              {
                                                  "maintenancecategory": {
                                                      "name": "Routinewartung",
                                                      "colorcode": "#d40ee6",
                                                      "nodeid": "247fn://247uptime.io/abc-maintenancecategory2"
                                                  }
                                              }
                                          ]
                                      }
                                  },
                                  {
                                      "maintenancetask": {
                                          "title": "new last test",
                                          "description": null,
                                          "reminder": "1w",
                                          "repetitioninterval": "6m",
                                          "startingfrom": 1706227200000,
                                          "specifier": null,
                                          "created": 0,
                                          "nodeid": "247fn://247uptime.io/c2671c17-a7ad-4286-a666-24dc4abead0a",
                                          "hascategory": [
                                              {
                                                  "maintenancecategory": {
                                                      "name": "Kundendienst",
                                                      "colorcode": "#e36a0e",
                                                      "nodeid": "247fn://247uptime.io/abc-maintenancecategory3"
                                                  }
                                              }
                                          ]
                                      }
                                  },
                                  {
                                      "maintenancetask": {
                                          "title": "gema cost test",
                                          "description": null,
                                          "reminder": "1w",
                                          "repetitioninterval": "6m",
                                          "startingfrom": 1706227200000,
                                          "specifier": null,
                                          "created": 0,
                                          "nodeid": "247fn://247uptime.io/a0650736-4c59-4c5f-ba1e-2d04b8cc7692",
                                          "hascategory": [
                                              {
                                                  "maintenancecategory": {
                                                      "name": "Kundendienst",
                                                      "colorcode": "#e36a0e",
                                                      "nodeid": "247fn://247uptime.io/abc-maintenancecategory3"
                                                  }
                                              }
                                          ]
                                      }
                                  },
                                  {
                                      "maintenancetask": {
                                          "title": "test44",
                                          "description": null,
                                          "reminder": "1w",
                                          "repetitioninterval": "3m",
                                          "startingfrom": 1706486400000,
                                          "specifier": null,
                                          "created": 0,
                                          "nodeid": "247fn://247uptime.io/f16ae4da-14a3-4699-9d2c-dfdf121cb06b",
                                          "hascategory": [
                                              {
                                                  "maintenancecategory": {
                                                      "name": "Kundendienst",
                                                      "colorcode": "#e36a0e",
                                                      "nodeid": "247fn://247uptime.io/abc-maintenancecategory3"
                                                  }
                                              }
                                          ]
                                      }
                                  }
                              ],
                              "hasnotification": [
                                  {
                                      "notification": {
                                          "created": 1675064430000,
                                          "progressstarted": 0,
                                          "closed": 0,
                                          "status": 0,
                                          "type": 1,
                                          "title": "Ungewöhnliches Geräusch an der Spindel",
                                          "description": "klingt wie ein schleifen, aber man erkennt keine beeinträchtigung. War gestern noch nicht",
                                          "nodeid": "247fn://247uptime.io/abc-notification3"
                                      }
                                  },
                                  {
                                      "notification": {
                                          "created": 1704848400142,
                                          "progressstarted": 0,
                                          "closed": 0,
                                          "status": 0,
                                          "type": 6,
                                          "title": "Austausch Schmiermittel",
                                          "description": "",
                                          "nodeid": "247fn://247uptime.io/b40d6a3d-bb81-452b-8e0a-c03f5bfb05a4"
                                      }
                                  },
                                  {
                                      "notification": {
                                          "created": 1704934800038,
                                          "progressstarted": 0,
                                          "closed": 0,
                                          "status": 0,
                                          "type": 6,
                                          "title": "DGUV V3 Prüfung elektrische Betriebsmittel",
                                          "description": "",
                                          "nodeid": "247fn://247uptime.io/66fa0b6f-79ec-4a71-bd93-3341535ed00a"
                                      }
                                  },
                                  {
                                      "notification": {
                                          "created": 1705021200003,
                                          "progressstarted": 0,
                                          "closed": 0,
                                          "status": 0,
                                          "type": 6,
                                          "title": "Allgemeine Inspektion der Gesamtmaschine",
                                          "description": "",
                                          "nodeid": "247fn://247uptime.io/4802720c-63e1-463f-bbfd-1da90442706e"
                                      }
                                  },
                                  {
                                      "notification": {
                                          "created": 1705422122176,
                                          "progressstarted": 0,
                                          "closed": 0,
                                          "status": 0,
                                          "type": 6,
                                          "title": "test 2",
                                          "description": "",
                                          "nodeid": "247fn://247uptime.io/c1744c58-96a8-487b-a912-d48749a5e4f0"
                                      }
                                  },
                                  {
                                      "notification": {
                                          "created": 1705577390403,
                                          "progressstarted": 0,
                                          "closed": 0,
                                          "status": 0,
                                          "type": 6,
                                          "title": "test maintenance task",
                                          "description": "",
                                          "nodeid": "247fn://247uptime.io/bd02a6ae-afb0-4085-aab8-5b6bffd4fea8"
                                      }
                                  },
                                  {
                                      "notification": {
                                          "created": 1705577437056,
                                          "progressstarted": 0,
                                          "closed": 0,
                                          "status": 0,
                                          "type": 6,
                                          "title": "test maintenance tasks",
                                          "description": "",
                                          "nodeid": "247fn://247uptime.io/d3c21b78-64ee-4bc8-9b99-00694864a9f0"
                                      }
                                  },
                                  {
                                      "notification": {
                                          "created": 1705971600075,
                                          "progressstarted": 0,
                                          "closed": 0,
                                          "status": 0,
                                          "type": 6,
                                          "title": "test maintenance task",
                                          "description": "",
                                          "nodeid": "247fn://247uptime.io/0f606789-9a27-42a0-86be-2ea17562263f"
                                      }
                                  },
                                  {
                                      "notification": {
                                          "created": 1706522889519,
                                          "progressstarted": 0,
                                          "closed": 0,
                                          "status": 0,
                                          "type": 6,
                                          "title": "test44",
                                          "description": "",
                                          "nodeid": "247fn://247uptime.io/bee6925c-2265-459b-afdd-feae88c5edb0"
                                      }
                                  }
                              ],
                              "hasequipmenttype": [
                                  {
                                      "equipmenttype": {
                                          "model": "Hyperturn 65",
                                          "nodeid": "247fn://247uptime.io/06d58ae8-274d-420f-b063-d3dd85533105",
                                          "isequipmenttypeof": [
                                              {
                                                  "brand": {
                                                      "name": "Emco",
                                                      "nodeid": "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091"
                                                  }
                                              }
                                          ],
                                          "hasequipmentclass": [
                                              {
                                                  "equipmentclass": {
                                                      "name": "Drehmaschine",
                                                      "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                                  }
                                              }
                                          ]
                                      }
                                  }
                              ]
                          }
                      },
                      {
                          "equipment": {
                              "name": "5Achs Bearbeitungszentrum",
                              "equipmentid": "101",
                              "inventoryid": "i101",
                              "constructiondate": "2017",
                              "manufacturerserialnumber": "dmg12345678",
                              "memo": "Die Maschine als Messemaschine gekauft",
                              "image": {
                                  "fileid": "101a58a5-9aec-43df-9591-f8816014d542/101a58a5-9aec-43df-9591-f8816014d543.jpg",
                                  "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                                  "mimetype": "image/jpeg",
                                  "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq101/101a58a5-9aec-43df-9591-f8816014d542/101a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=c183ec751193c6326b9bb0319cfc89837c1a38413cdde0990faeb6d27e4c51ed"
                              },
                              "nodeid": "247fn://247uptime.io/abc-eq101",
                              "hasmaintenancetask": [
                                  {
                                      "maintenancetask": {
                                          "title": "testing cost value",
                                          "description": null,
                                          "reminder": "1w",
                                          "repetitioninterval": "6m",
                                          "startingfrom": 1706227200000,
                                          "specifier": null,
                                          "created": 0,
                                          "nodeid": "247fn://247uptime.io/924c6953-61f8-4ff7-8168-d5977e5e46c7",
                                          "hascategory": [
                                              {
                                                  "maintenancecategory": {
                                                      "name": "Kundendienst",
                                                      "colorcode": "#e36a0e",
                                                      "nodeid": "247fn://247uptime.io/abc-maintenancecategory3"
                                                  }
                                              }
                                          ]
                                      }
                                  },
                                  {
                                      "maintenancetask": {
                                          "title": "test cost 99",
                                          "description": null,
                                          "reminder": "2w",
                                          "repetitioninterval": "6m",
                                          "startingfrom": 1706227200000,
                                          "specifier": null,
                                          "created": 0,
                                          "nodeid": "247fn://247uptime.io/cd67678c-f01d-4e74-ac64-5f251179e3c5",
                                          "hascategory": [
                                              {
                                                  "maintenancecategory": {
                                                      "name": "Routinewartung",
                                                      "colorcode": "#d40ee6",
                                                      "nodeid": "247fn://247uptime.io/abc-maintenancecategory2"
                                                  }
                                              }
                                          ]
                                      }
                                  }
                              ],
                              "hasequipmenttype": [
                                  {
                                      "equipmenttype": {
                                          "model": "DMU 100",
                                          "nodeid": "247fn://247uptime.io/0b7135e8-56e6-47a5-b891-9e1471d3a2c5",
                                          "isequipmenttypeof": [
                                              {
                                                  "brand": {
                                                      "name": "Deckel Maho",
                                                      "nodeid": "247fn://247uptime.io/2132d959-981e-468c-85fa-303ccbce3dd5"
                                                  }
                                              }
                                          ],
                                          "hasequipmentclass": [
                                              {
                                                  "equipmentclass": {
                                                      "name": "Drehmaschine",
                                                      "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                                  }
                                              }
                                          ]
                                      }
                                  }
                              ]
                          }
                      },
                      {
                          "equipment": {
                              "name": "5Achs Bearbeitungszentrum",
                              "equipmentid": "102",
                              "inventoryid": "i102",
                              "constructiondate": "2012",
                              "manufacturerserialnumber": "dmg87654321",
                              "memo": "Meine Notiz",
                              "image": {
                                  "fileid": "102a58a5-9aec-43df-9591-f8816014d542/102a58a5-9aec-43df-9591-f8816014d543.jpg",
                                  "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                                  "mimetype": "image/jpeg",
                                  "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq102/102a58a5-9aec-43df-9591-f8816014d542/102a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=9fcb192a5f8b64f34e88b34382b04c722afc2c595682f82a69ea98d73a6efa15"
                              },
                              "nodeid": "247fn://247uptime.io/abc-eq102",
                              "hasmaintenancetask": [
                                  {
                                      "maintenancetask": {
                                          "title": "test cost 8899",
                                          "description": null,
                                          "reminder": "2w",
                                          "repetitioninterval": "6m",
                                          "startingfrom": 1706227200000,
                                          "specifier": null,
                                          "created": 0,
                                          "nodeid": "247fn://247uptime.io/6d06837a-6ece-49d8-b472-d2c0c8f03922",
                                          "hascategory": [
                                              {
                                                  "maintenancecategory": {
                                                      "name": "Routineinspektion",
                                                      "colorcode": "#1172d4",
                                                      "nodeid": "247fn://247uptime.io/abc-maintenancecategory1"
                                                  }
                                              }
                                          ]
                                      }
                                  }
                              ],
                              "hasequipmenttype": [
                                  {
                                      "equipmenttype": {
                                          "model": "DMU 70",
                                          "nodeid": "247fn://247uptime.io/3a4ddeaa-83a5-4d58-a9e1-69fd7f3f102f",
                                          "isequipmenttypeof": [
                                              {
                                                  "brand": {
                                                      "name": "Deckel Maho",
                                                      "nodeid": "247fn://247uptime.io/2132d959-981e-468c-85fa-303ccbce3dd5"
                                                  }
                                              }
                                          ],
                                          "hasequipmentclass": [
                                              {
                                                  "equipmentclass": {
                                                      "name": "Drehmaschine",
                                                      "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                                  }
                                              }
                                          ]
                                      }
                                  }
                              ]
                          }
                      },
                      {
                          "equipment": {
                              "name": "Bolzenbearbeitung",
                              "equipmentid": "104",
                              "inventoryid": "i104",
                              "constructiondate": "2019",
                              "manufacturerserialnumber": "emco1234567",
                              "memo": "Meine Notiz",
                              "image": {
                                  "fileid": "104a58a5-9aec-43df-9591-f8816014d542/104a58a5-9aec-43df-9591-f8816014d543.jpg",
                                  "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                                  "mimetype": "image/jpeg",
                                  "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq104/104a58a5-9aec-43df-9591-f8816014d542/104a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=a2b6f293148cde6d12e7174ad024342b5d09f4658715706b8e9b9bc6129650b0"
                              },
                              "nodeid": "247fn://247uptime.io/abc-eq104",
                              "hasmaintenancetask": [
                                  {
                                      "maintenancetask": {
                                          "title": "new cost testing 1",
                                          "description": null,
                                          "reminder": "2w",
                                          "repetitioninterval": "6m",
                                          "startingfrom": 1706227200000,
                                          "specifier": null,
                                          "created": 0,
                                          "nodeid": "247fn://247uptime.io/c000677b-76fd-4320-bce7-23b6b6cf6f16",
                                          "hascategory": [
                                              {
                                                  "maintenancecategory": {
                                                      "name": "Kundendienst",
                                                      "colorcode": "#e36a0e",
                                                      "nodeid": "247fn://247uptime.io/abc-maintenancecategory3"
                                                  }
                                              }
                                          ]
                                      }
                                  },
                                  {
                                      "maintenancetask": {
                                          "title": "new cost testing 2",
                                          "description": null,
                                          "reminder": "2w",
                                          "repetitioninterval": "1y",
                                          "startingfrom": 1706227200000,
                                          "specifier": null,
                                          "created": 0,
                                          "nodeid": "247fn://247uptime.io/7c08cca6-e985-415a-8403-5b88c6d6342e",
                                          "hascategory": [
                                              {
                                                  "maintenancecategory": {
                                                      "name": "Routinewartung",
                                                      "colorcode": "#d40ee6",
                                                      "nodeid": "247fn://247uptime.io/abc-maintenancecategory2"
                                                  }
                                              }
                                          ]
                                      }
                                  }
                              ],
                              "hasequipmenttype": [
                                  {
                                      "equipmenttype": {
                                          "model": "Hyperturn 45",
                                          "nodeid": "247fn://247uptime.io/a7cea051-d8d5-4a48-8b8f-795fcb6519b5",
                                          "isequipmenttypeof": [
                                              {
                                                  "brand": {
                                                      "name": "Emco",
                                                      "nodeid": "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091"
                                                  }
                                              }
                                          ],
                                          "hasequipmentclass": [
                                              {
                                                  "equipmentclass": {
                                                      "name": "Drehmaschine",
                                                      "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                                  }
                                              }
                                          ]
                                      }
                                  }
                              ]
                          }
                      },
                      {
                          "equipment": {
                              "name": "Bearbeitungszentrum",
                              "equipmentid": "108",
                              "inventoryid": "i108",
                              "constructiondate": "2015",
                              "manufacturerserialnumber": "her2314",
                              "memo": "t",
                              "image": {
                                  "fileid": "108a58a5-9aec-43df-9591-f8816014d542/108a58a5-9aec-43df-9591-f8816014d543.jpg",
                                  "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                                  "mimetype": "image/jpeg",
                                  "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq108/108a58a5-9aec-43df-9591-f8816014d542/108a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=bfab1690e406a6f7fee4871d0aada9d1d7f6966a5fb18f575bf516dd996a7328"
                              },
                              "nodeid": "247fn://247uptime.io/abc-eq108",
                              "hasmaintenancetask": [
                                  {
                                      "maintenancetask": {
                                          "title": "test cost 22",
                                          "description": null,
                                          "reminder": "1w",
                                          "repetitioninterval": "6m",
                                          "startingfrom": 1706227200000,
                                          "specifier": null,
                                          "created": 0,
                                          "nodeid": "247fn://247uptime.io/7c2a49ba-6f19-4e97-a61d-b253c475fac5",
                                          "hascategory": [
                                              {
                                                  "maintenancecategory": {
                                                      "name": "Kundendienst",
                                                      "colorcode": "#e36a0e",
                                                      "nodeid": "247fn://247uptime.io/abc-maintenancecategory3"
                                                  }
                                              }
                                          ]
                                      }
                                  }
                              ],
                              "hasnotification": [
                                  {
                                      "notification": {
                                          "created": 1706278552820,
                                          "progressstarted": 0,
                                          "closed": 0,
                                          "status": 0,
                                          "type": 6,
                                          "title": "test cost 22",
                                          "description": "",
                                          "nodeid": "247fn://247uptime.io/301cfe24-7402-49de-95bc-7b69c469dd36"
                                      }
                                  }
                              ],
                              "hasequipmenttype": [
                                  {
                                      "equipmenttype": {
                                          "model": "C 400",
                                          "nodeid": "247fn://247uptime.io/96f02979-e47d-42a9-9be6-6985c0cac1b3",
                                          "isequipmenttypeof": [
                                              {
                                                  "brand": {
                                                      "name": "Hedelius",
                                                      "nodeid": "247fn://247uptime.io/994010e1-4167-4703-82a5-630040b548d6"
                                                  }
                                              }
                                          ],
                                          "hasequipmentclass": [
                                              {
                                                  "equipmentclass": {
                                                      "name": "Drehmaschine",
                                                      "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                                  }
                                              }
                                          ]
                                      }
                                  }
                              ]
                          }
                      },
                      {
                          "equipment": {
                              "name": "Prototypenbau",
                              "equipmentid": "110",
                              "inventoryid": "i110",
                              "constructiondate": "2010",
                              "manufacturerserialnumber": "weil12345",
                              "memo": "ehemals Lehrwerkstadt",
                              "image": {
                                  "fileid": "110a58a5-9aec-43df-9591-f8816014d542/110a58a5-9aec-43df-9591-f8816014d543.jpg",
                                  "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                                  "mimetype": "image/jpeg",
                                  "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq110/110a58a5-9aec-43df-9591-f8816014d542/110a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=55c11ef67dd0df4602fa053692da19b183c89a2f5b87410bef756400d0b54887"
                              },
                              "nodeid": "247fn://247uptime.io/abc-eq110",
                              "hasequipmenttype": [
                                  {
                                      "equipmenttype": {
                                          "model": "Condor 81",
                                          "nodeid": "247fn://247uptime.io/cc2347d2-8d19-49a2-b72a-0b09db902a82",
                                          "isequipmenttypeof": [
                                              {
                                                  "brand": {
                                                      "name": "Weiler",
                                                      "nodeid": "247fn://247uptime.io/6ac947df-48fe-4841-845f-1637e476ad54"
                                                  }
                                              }
                                          ],
                                          "hasequipmentclass": [
                                              {
                                                  "equipmentclass": {
                                                      "name": "Drehmaschine",
                                                      "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                                  }
                                              }
                                          ]
                                      }
                                  }
                              ]
                          }
                      }
                  ]
              }
          },
          {
              "area": {
                  "name": "Gehäusefertigung",
                  "nodeid": "247fn://247uptime.io/abc-area2",
                  "hasequipment": [
                      {
                          "equipment": {
                              "name": "Kegelradschleifen",
                              "equipmentid": "201",
                              "inventoryid": "i201",
                              "constructiondate": "2013",
                              "manufacturerserialnumber": "Kling12345",
                              "memo": "",
                              "image": {
                                  "fileid": "201a58a5-9aec-43df-9591-f8816014d542/201a58a5-9aec-43df-9591-f8816014d543.jpg",
                                  "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                                  "mimetype": "image/jpeg",
                                  "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq201/201a58a5-9aec-43df-9591-f8816014d542/201a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=233f2d02837b5a199c5dc5bc7de812d8fc84af7f006763424b16dc33daa11b6e"
                              },
                              "nodeid": "247fn://247uptime.io/abc-eq201",
                              "hasequipmenttype": [
                                  {
                                      "equipmenttype": {
                                          "model": "WNC 80",
                                          "nodeid": "247fn://247uptime.io/8dc7ec1b-f5fa-4548-8dee-b85d4a68c07d",
                                          "isequipmenttypeof": [
                                              {
                                                  "brand": {
                                                      "name": "Klingelnberg",
                                                      "nodeid": "247fn://247uptime.io/30da53b9-9580-4763-aa4e-f7aefe83c8f7"
                                                  }
                                              }
                                          ],
                                          "hasequipmentclass": [
                                              {
                                                  "equipmentclass": {
                                                      "name": "Drehmaschine",
                                                      "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                                  }
                                              }
                                          ]
                                      }
                                  }
                              ]
                          }
                      },
                      {
                          "equipment": {
                              "name": "Zahnradfräsen",
                              "equipmentid": "202",
                              "inventoryid": "i202",
                              "constructiondate": "2012",
                              "manufacturerserialnumber": "Lieb123456",
                              "memo": "",
                              "image": {
                                  "fileid": "202a58a5-9aec-43df-9591-f8816014d542/202a58a5-9aec-43df-9591-f8816014d543.jpg",
                                  "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                                  "mimetype": "image/jpeg",
                                  "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq202/202a58a5-9aec-43df-9591-f8816014d542/202a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=1014c27613e091be616e5069188f42505bf520ea78558d379152b1ffec556ff6"
                              },
                              "nodeid": "247fn://247uptime.io/abc-eq202",
                              "hasequipmenttype": [
                                  {
                                      "equipmenttype": {
                                          "model": "LC502",
                                          "nodeid": "247fn://247uptime.io/259b5267-3cd7-4b32-9e21-1959b0522888",
                                          "isequipmenttypeof": [
                                              {
                                                  "brand": {
                                                      "name": "Liebherr",
                                                      "nodeid": "247fn://247uptime.io/1569942f-e445-4571-b75e-4da84e5fb993"
                                                  }
                                              }
                                          ],
                                          "hasequipmentclass": [
                                              {
                                                  "equipmentclass": {
                                                      "name": "Drehmaschine",
                                                      "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                                  }
                                              }
                                          ]
                                      }
                                  }
                              ]
                          }
                      },
                      {
                          "equipment": {
                              "name": "Kegelradfräsen",
                              "equipmentid": "203",
                              "inventoryid": "i203",
                              "constructiondate": "2002",
                              "manufacturerserialnumber": "gle1234567",
                              "memo": "",
                              "image": {
                                  "fileid": "203a58a5-9aec-43df-9591-f8816014d542/203a58a5-9aec-43df-9591-f8816014d543.jpg",
                                  "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                                  "mimetype": "image/jpeg",
                                  "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq203/203a58a5-9aec-43df-9591-f8816014d542/203a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=8f64bd99b0567e97fe568919c0dc0757ad7862243848ef04a912c115460528f4"
                              },
                              "nodeid": "247fn://247uptime.io/abc-eq203",
                              "hasequipmenttype": [
                                  {
                                      "equipmenttype": {
                                          "model": "114",
                                          "nodeid": "247fn://247uptime.io/d0ce0d59-d70d-4ccd-8fa4-29358127c201",
                                          "isequipmenttypeof": [
                                              {
                                                  "brand": {
                                                      "name": "Gleason",
                                                      "nodeid": "247fn://247uptime.io/2728a232-fe86-4c21-81eb-a47c6651c1e9"
                                                  }
                                              }
                                          ],
                                          "hasequipmentclass": [
                                              {
                                                  "equipmentclass": {
                                                      "name": "Drehmaschine",
                                                      "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                                  }
                                              }
                                          ]
                                      }
                                  }
                              ]
                          }
                      }
                  ]
              }
          }
      ]
  },
  "247fn://247uptime.io/abc-site2": {
      "name": "Werk 2",
      "nodeid": "247fn://247uptime.io/abc-site2",
      "hasarea": [
          {
              "area": {
                  "name": "Gehäusefertigung",
                  "nodeid": "247fn://247uptime.io/abc-area3",
                  "hasequipment": [
                      {
                          "equipment": {
                              "name": "Deckelbearbeitung 1",
                              "equipmentid": "105",
                              "inventoryid": "i105",
                              "constructiondate": "2019",
                              "manufacturerserialnumber": "hell12345",
                              "memo": "",
                              "image": {
                                  "fileid": "105a58a5-9aec-43df-9591-f8816014d542/105a58a5-9aec-43df-9591-f8816014d543.jpg",
                                  "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                                  "mimetype": "image/jpeg",
                                  "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq105/105a58a5-9aec-43df-9591-f8816014d542/105a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=29e1eb13e8e34f12c2bd91dea7bb5b872d4a0ec0c16b93775988b11089b148e0"
                              },
                              "nodeid": "247fn://247uptime.io/abc-eq105",
                              "hasequipmenttype": [
                                  {
                                      "equipmenttype": {
                                          "model": "H2000",
                                          "nodeid": "247fn://247uptime.io/74c53868-a29e-45e5-b0ef-a7441c60d787",
                                          "isequipmenttypeof": [
                                              {
                                                  "brand": {
                                                      "name": "Heller",
                                                      "nodeid": "247fn://247uptime.io/c61cbcf2-b7c9-4365-a1b9-77ccd6f8a3c0"
                                                  }
                                              }
                                          ],
                                          "hasequipmentclass": [
                                              {
                                                  "equipmentclass": {
                                                      "name": "Drehmaschine",
                                                      "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                                  }
                                              }
                                          ]
                                      }
                                  }
                              ]
                          }
                      },
                      {
                          "equipment": {
                              "name": "Gehäusedeckel",
                              "equipmentid": "106",
                              "inventoryid": "i106",
                              "constructiondate": "2019",
                              "manufacturerserialnumber": "hell98765",
                              "memo": "",
                              "image": {
                                  "fileid": "106a58a5-9aec-43df-9591-f8816014d542/106a58a5-9aec-43df-9591-f8816014d543.jpg",
                                  "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                                  "mimetype": "image/jpeg",
                                  "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq106/106a58a5-9aec-43df-9591-f8816014d542/106a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=e78b5614be4fe1232b149df860aa7491cda298f40aa98d7cfcb4f5eed17a46b6"
                              },
                              "nodeid": "247fn://247uptime.io/abc-eq106",
                              "hasequipmenttype": [
                                  {
                                      "equipmenttype": {
                                          "model": "H2000",
                                          "nodeid": "247fn://247uptime.io/74c53868-a29e-45e5-b0ef-a7441c60d787",
                                          "isequipmenttypeof": [
                                              {
                                                  "brand": {
                                                      "name": "Heller",
                                                      "nodeid": "247fn://247uptime.io/c61cbcf2-b7c9-4365-a1b9-77ccd6f8a3c0"
                                                  }
                                              }
                                          ],
                                          "hasequipmentclass": [
                                              {
                                                  "equipmentclass": {
                                                      "name": "Drehmaschine",
                                                      "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                                  }
                                              }
                                          ]
                                      }
                                  }
                              ]
                          }
                      },
                      {
                          "equipment": {
                              "name": "Fräsmaschine",
                              "equipmentid": "107",
                              "inventoryid": "i107",
                              "constructiondate": "2017",
                              "manufacturerserialnumber": "Grob54321",
                              "memo": "wird z.Zt. nur Spätschicht genutzt",
                              "image": {
                                  "fileid": "107a58a5-9aec-43df-9591-f8816014d542/107a58a5-9aec-43df-9591-f8816014d543.jpg",
                                  "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                                  "mimetype": "image/jpeg",
                                  "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq107/107a58a5-9aec-43df-9591-f8816014d542/107a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=bfc6e9cc701292e0b9e80cec69cc91c3a0840960911c644f5c68c60103b64f0b"
                              },
                              "nodeid": "247fn://247uptime.io/abc-eq107",
                              "hasequipmenttype": [
                                  {
                                      "equipmenttype": {
                                          "model": "G350",
                                          "nodeid": "247fn://247uptime.io/58ff6083-739d-4871-88d6-56d52eb97e40",
                                          "isequipmenttypeof": [
                                              {
                                                  "brand": {
                                                      "name": "Grob",
                                                      "nodeid": "247fn://247uptime.io/b787211a-80ea-4861-a4c3-efab55106cf0"
                                                  }
                                              }
                                          ],
                                          "hasequipmentclass": [
                                              {
                                                  "equipmentclass": {
                                                      "name": "Drehmaschine",
                                                      "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                                  }
                                              }
                                          ]
                                      }
                                  }
                              ]
                          }
                      },
                      {
                          "equipment": {
                              "name": "Nachbearbeitung",
                              "equipmentid": "109",
                              "inventoryid": "i109",
                              "constructiondate": "2013",
                              "manufacturerserialnumber": "hed12345",
                              "memo": "zur Nachbarbeit",
                              "image": {
                                  "fileid": "109a58a5-9aec-43df-9591-f8816014d542/109a58a5-9aec-43df-9591-f8816014d543.jpg",
                                  "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                                  "mimetype": "image/jpeg",
                                  "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq109/109a58a5-9aec-43df-9591-f8816014d542/109a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=6f976082ff72834a2188dbb56546bb45b9836904cde2e69e7d5307f7d4c7eb6b"
                              },
                              "nodeid": "247fn://247uptime.io/abc-eq109",
                              "hasequipmenttype": [
                                  {
                                      "equipmenttype": {
                                          "model": "Forte 50",
                                          "nodeid": "247fn://247uptime.io/7199a3aa-9390-45b5-9c67-c6b998722052",
                                          "isequipmenttypeof": [
                                              {
                                                  "brand": {
                                                      "name": "Hedelius",
                                                      "nodeid": "247fn://247uptime.io/994010e1-4167-4703-82a5-630040b548d6"
                                                  }
                                              }
                                          ],
                                          "hasequipmentclass": [
                                              {
                                                  "equipmentclass": {
                                                      "name": "Drehmaschine",
                                                      "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                                  }
                                              }
                                          ]
                                      }
                                  }
                              ]
                          }
                      }
                  ]
              }
          }
      ]
  }
}`);

const subscribedAreas = JSON.parse(`{
  "247fn://247uptime.io/abc-area1": {
      "name": "Gehäusefertigung",
      "nodeid": "247fn://247uptime.io/abc-area1",
      "hasequipment": [
          {
              "equipment": {
                  "name": "Nachbearbeitung Drehteile",
                  "equipmentid": "103",
                  "inventoryid": "i103",
                  "constructiondate": "2017",
                  "manufacturerserialnumber": "emco8765432",
                  "memo": "wird z.Zt. nur Spätschicht genutzt",
                  "image": {
                      "fileid": "103a58a5-9aec-43df-9591-f8816014d542/103a58a5-9aec-43df-9591-f8816014d543.jpg",
                      "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                      "mimetype": "image/jpeg",
                      "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq103/103a58a5-9aec-43df-9591-f8816014d542/103a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=ada55d7086a8fe45cfb975de421a25ca60b27c157d4b2fcc6d37445ce94e5e8f"
                  },
                  "nodeid": "247fn://247uptime.io/abc-eq103",
                  "hasmaintenancetask": [
                      {
                          "maintenancetask": {
                              "title": "Allgemeine Inspektion der Gesamtmaschine",
                              "description": null,
                              "reminder": "2w",
                              "repetitioninterval": "3m",
                              "startingfrom": 1675638000000,
                              "specifier": null,
                              "created": 0,
                              "nodeid": "247fn://247uptime.io/abc-maintenancetask1",
                              "hascategory": [
                                  {
                                      "maintenancecategory": {
                                          "name": "Routineinspektion",
                                          "colorcode": "#1172d4",
                                          "nodeid": "247fn://247uptime.io/abc-maintenancecategory1"
                                      }
                                  }
                              ]
                          }
                      },
                      {
                          "maintenancetask": {
                              "title": "Austausch Schmiermittel",
                              "description": null,
                              "reminder": "2w",
                              "repetitioninterval": "1y",
                              "startingfrom": 1676847600000,
                              "specifier": null,
                              "created": 0,
                              "nodeid": "247fn://247uptime.io/abc-maintenancetask2",
                              "hascategory": [
                                  {
                                      "maintenancecategory": {
                                          "name": "Routinewartung",
                                          "colorcode": "#d40ee6",
                                          "nodeid": "247fn://247uptime.io/abc-maintenancecategory2"
                                      }
                                  }
                              ]
                          }
                      },
                      {
                          "maintenancetask": {
                              "title": "DGUV V3 Prüfung elektrische Betriebsmittel",
                              "description": null,
                              "reminder": "2w",
                              "repetitioninterval": "1y",
                              "startingfrom": 1676847600000,
                              "specifier": null,
                              "created": 0,
                              "nodeid": "247fn://247uptime.io/abc-maintenancetask3",
                              "hascategory": [
                                  {
                                      "maintenancecategory": {
                                          "name": "Routinewartung",
                                          "colorcode": "#d40ee6",
                                          "nodeid": "247fn://247uptime.io/abc-maintenancecategory2"
                                      }
                                  }
                              ]
                          }
                      },
                      {
                          "maintenancetask": {
                              "title": "Kundendienst - Jahreswartung",
                              "description": null,
                              "reminder": "2w",
                              "repetitioninterval": "1y",
                              "startingfrom": 1676847600000,
                              "specifier": null,
                              "created": 0,
                              "nodeid": "247fn://247uptime.io/abc-maintenancetask4",
                              "hascategory": [
                                  {
                                      "maintenancecategory": {
                                          "name": "Kundendienst",
                                          "colorcode": "#e36a0e",
                                          "nodeid": "247fn://247uptime.io/abc-maintenancecategory3"
                                      }
                                  }
                              ]
                          }
                      },
                      {
                          "maintenancetask": {
                              "title": "test 2111",
                              "description": null,
                              "reminder": "1w",
                              "repetitioninterval": "1y",
                              "startingfrom": 1705363200000,
                              "specifier": null,
                              "created": 0,
                              "nodeid": "247fn://247uptime.io/d88a60e9-96b0-46e8-b2bb-93e902315c58",
                              "hascategory": [
                                  {
                                      "maintenancecategory": {
                                          "name": "Kundendienst",
                                          "colorcode": "#e36a0e",
                                          "nodeid": "247fn://247uptime.io/abc-maintenancecategory3"
                                      }
                                  }
                              ]
                          }
                      },
                      {
                          "maintenancetask": {
                              "title": "test maintenance task",
                              "description": null,
                              "reminder": "1w",
                              "repetitioninterval": "3m",
                              "startingfrom": 1705968000000,
                              "specifier": null,
                              "created": 0,
                              "nodeid": "247fn://247uptime.io/461cedb8-6ed3-42e9-9ad1-3dcaefb9efdd",
                              "hascategory": [
                                  {
                                      "maintenancecategory": {
                                          "name": "Kundendienst",
                                          "colorcode": "#e36a0e",
                                          "nodeid": "247fn://247uptime.io/abc-maintenancecategory3"
                                      }
                                  }
                              ]
                          }
                      },
                      {
                          "maintenancetask": {
                              "title": "test maintenance tasks",
                              "description": null,
                              "reminder": "1w",
                              "repetitioninterval": "3m",
                              "startingfrom": 1705968000000,
                              "specifier": null,
                              "created": 0,
                              "nodeid": "247fn://247uptime.io/599b98ec-57b4-42fe-92b8-0437a00f2e8b",
                              "hascategory": [
                                  {
                                      "maintenancecategory": {
                                          "name": "Kundendienst",
                                          "colorcode": "#e36a0e",
                                          "nodeid": "247fn://247uptime.io/abc-maintenancecategory3"
                                      }
                                  }
                              ]
                          }
                      },
                      {
                          "maintenancetask": {
                              "title": "test alpha 11222",
                              "description": null,
                              "reminder": "2w",
                              "repetitioninterval": "6m",
                              "startingfrom": 1706227200000,
                              "specifier": null,
                              "created": 0,
                              "nodeid": "247fn://247uptime.io/f03e9745-c530-4ed8-b09f-0bfa3f741a89",
                              "hascategory": [
                                  {
                                      "maintenancecategory": {
                                          "name": "Routineinspektion",
                                          "colorcode": "#1172d4",
                                          "nodeid": "247fn://247uptime.io/abc-maintenancecategory1"
                                      }
                                  }
                              ]
                          }
                      },
                      {
                          "maintenancetask": {
                              "title": "testing new costs",
                              "description": null,
                              "reminder": "2w",
                              "repetitioninterval": "6m",
                              "startingfrom": 1706227200000,
                              "specifier": null,
                              "created": 0,
                              "nodeid": "247fn://247uptime.io/3f4ef7e7-d161-46a5-ac2f-4506eab07968",
                              "hascategory": [
                                  {
                                      "maintenancecategory": {
                                          "name": "Routinewartung",
                                          "colorcode": "#d40ee6",
                                          "nodeid": "247fn://247uptime.io/abc-maintenancecategory2"
                                      }
                                  }
                              ]
                          }
                      },
                      {
                          "maintenancetask": {
                              "title": "new last test",
                              "description": null,
                              "reminder": "1w",
                              "repetitioninterval": "6m",
                              "startingfrom": 1706227200000,
                              "specifier": null,
                              "created": 0,
                              "nodeid": "247fn://247uptime.io/c2671c17-a7ad-4286-a666-24dc4abead0a",
                              "hascategory": [
                                  {
                                      "maintenancecategory": {
                                          "name": "Kundendienst",
                                          "colorcode": "#e36a0e",
                                          "nodeid": "247fn://247uptime.io/abc-maintenancecategory3"
                                      }
                                  }
                              ]
                          }
                      },
                      {
                          "maintenancetask": {
                              "title": "gema cost test",
                              "description": null,
                              "reminder": "1w",
                              "repetitioninterval": "6m",
                              "startingfrom": 1706227200000,
                              "specifier": null,
                              "created": 0,
                              "nodeid": "247fn://247uptime.io/a0650736-4c59-4c5f-ba1e-2d04b8cc7692",
                              "hascategory": [
                                  {
                                      "maintenancecategory": {
                                          "name": "Kundendienst",
                                          "colorcode": "#e36a0e",
                                          "nodeid": "247fn://247uptime.io/abc-maintenancecategory3"
                                      }
                                  }
                              ]
                          }
                      },
                      {
                          "maintenancetask": {
                              "title": "test44",
                              "description": null,
                              "reminder": "1w",
                              "repetitioninterval": "3m",
                              "startingfrom": 1706486400000,
                              "specifier": null,
                              "created": 0,
                              "nodeid": "247fn://247uptime.io/f16ae4da-14a3-4699-9d2c-dfdf121cb06b",
                              "hascategory": [
                                  {
                                      "maintenancecategory": {
                                          "name": "Kundendienst",
                                          "colorcode": "#e36a0e",
                                          "nodeid": "247fn://247uptime.io/abc-maintenancecategory3"
                                      }
                                  }
                              ]
                          }
                      }
                  ],
                  "hasnotification": [
                      {
                          "notification": {
                              "created": 1675064430000,
                              "progressstarted": 0,
                              "closed": 0,
                              "status": 0,
                              "type": 1,
                              "title": "Ungewöhnliches Geräusch an der Spindel",
                              "description": "klingt wie ein schleifen, aber man erkennt keine beeinträchtigung. War gestern noch nicht",
                              "nodeid": "247fn://247uptime.io/abc-notification3"
                          }
                      },
                      {
                          "notification": {
                              "created": 1704848400142,
                              "progressstarted": 0,
                              "closed": 0,
                              "status": 0,
                              "type": 6,
                              "title": "Austausch Schmiermittel",
                              "description": "",
                              "nodeid": "247fn://247uptime.io/b40d6a3d-bb81-452b-8e0a-c03f5bfb05a4"
                          }
                      },
                      {
                          "notification": {
                              "created": 1704934800038,
                              "progressstarted": 0,
                              "closed": 0,
                              "status": 0,
                              "type": 6,
                              "title": "DGUV V3 Prüfung elektrische Betriebsmittel",
                              "description": "",
                              "nodeid": "247fn://247uptime.io/66fa0b6f-79ec-4a71-bd93-3341535ed00a"
                          }
                      },
                      {
                          "notification": {
                              "created": 1705021200003,
                              "progressstarted": 0,
                              "closed": 0,
                              "status": 0,
                              "type": 6,
                              "title": "Allgemeine Inspektion der Gesamtmaschine",
                              "description": "",
                              "nodeid": "247fn://247uptime.io/4802720c-63e1-463f-bbfd-1da90442706e"
                          }
                      },
                      {
                          "notification": {
                              "created": 1705422122176,
                              "progressstarted": 0,
                              "closed": 0,
                              "status": 0,
                              "type": 6,
                              "title": "test 2",
                              "description": "",
                              "nodeid": "247fn://247uptime.io/c1744c58-96a8-487b-a912-d48749a5e4f0"
                          }
                      },
                      {
                          "notification": {
                              "created": 1705577390403,
                              "progressstarted": 0,
                              "closed": 0,
                              "status": 0,
                              "type": 6,
                              "title": "test maintenance task",
                              "description": "",
                              "nodeid": "247fn://247uptime.io/bd02a6ae-afb0-4085-aab8-5b6bffd4fea8"
                          }
                      },
                      {
                          "notification": {
                              "created": 1705577437056,
                              "progressstarted": 0,
                              "closed": 0,
                              "status": 0,
                              "type": 6,
                              "title": "test maintenance tasks",
                              "description": "",
                              "nodeid": "247fn://247uptime.io/d3c21b78-64ee-4bc8-9b99-00694864a9f0"
                          }
                      },
                      {
                          "notification": {
                              "created": 1705971600075,
                              "progressstarted": 0,
                              "closed": 0,
                              "status": 0,
                              "type": 6,
                              "title": "test maintenance task",
                              "description": "",
                              "nodeid": "247fn://247uptime.io/0f606789-9a27-42a0-86be-2ea17562263f"
                          }
                      },
                      {
                          "notification": {
                              "created": 1706522889519,
                              "progressstarted": 0,
                              "closed": 0,
                              "status": 0,
                              "type": 6,
                              "title": "test44",
                              "description": "",
                              "nodeid": "247fn://247uptime.io/bee6925c-2265-459b-afdd-feae88c5edb0"
                          }
                      }
                  ],
                  "hasequipmenttype": [
                      {
                          "equipmenttype": {
                              "model": "Hyperturn 65",
                              "nodeid": "247fn://247uptime.io/06d58ae8-274d-420f-b063-d3dd85533105",
                              "isequipmenttypeof": [
                                  {
                                      "brand": {
                                          "name": "Emco",
                                          "nodeid": "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091"
                                      }
                                  }
                              ],
                              "hasequipmentclass": [
                                  {
                                      "equipmentclass": {
                                          "name": "Drehmaschine",
                                          "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                      }
                                  }
                              ]
                          }
                      }
                  ]
              }
          },
          {
              "equipment": {
                  "name": "5Achs Bearbeitungszentrum",
                  "equipmentid": "101",
                  "inventoryid": "i101",
                  "constructiondate": "2017",
                  "manufacturerserialnumber": "dmg12345678",
                  "memo": "Die Maschine als Messemaschine gekauft",
                  "image": {
                      "fileid": "101a58a5-9aec-43df-9591-f8816014d542/101a58a5-9aec-43df-9591-f8816014d543.jpg",
                      "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                      "mimetype": "image/jpeg",
                      "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq101/101a58a5-9aec-43df-9591-f8816014d542/101a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=c183ec751193c6326b9bb0319cfc89837c1a38413cdde0990faeb6d27e4c51ed"
                  },
                  "nodeid": "247fn://247uptime.io/abc-eq101",
                  "hasmaintenancetask": [
                      {
                          "maintenancetask": {
                              "title": "testing cost value",
                              "description": null,
                              "reminder": "1w",
                              "repetitioninterval": "6m",
                              "startingfrom": 1706227200000,
                              "specifier": null,
                              "created": 0,
                              "nodeid": "247fn://247uptime.io/924c6953-61f8-4ff7-8168-d5977e5e46c7",
                              "hascategory": [
                                  {
                                      "maintenancecategory": {
                                          "name": "Kundendienst",
                                          "colorcode": "#e36a0e",
                                          "nodeid": "247fn://247uptime.io/abc-maintenancecategory3"
                                      }
                                  }
                              ]
                          }
                      },
                      {
                          "maintenancetask": {
                              "title": "test cost 99",
                              "description": null,
                              "reminder": "2w",
                              "repetitioninterval": "6m",
                              "startingfrom": 1706227200000,
                              "specifier": null,
                              "created": 0,
                              "nodeid": "247fn://247uptime.io/cd67678c-f01d-4e74-ac64-5f251179e3c5",
                              "hascategory": [
                                  {
                                      "maintenancecategory": {
                                          "name": "Routinewartung",
                                          "colorcode": "#d40ee6",
                                          "nodeid": "247fn://247uptime.io/abc-maintenancecategory2"
                                      }
                                  }
                              ]
                          }
                      }
                  ],
                  "hasequipmenttype": [
                      {
                          "equipmenttype": {
                              "model": "DMU 100",
                              "nodeid": "247fn://247uptime.io/0b7135e8-56e6-47a5-b891-9e1471d3a2c5",
                              "isequipmenttypeof": [
                                  {
                                      "brand": {
                                          "name": "Deckel Maho",
                                          "nodeid": "247fn://247uptime.io/2132d959-981e-468c-85fa-303ccbce3dd5"
                                      }
                                  }
                              ],
                              "hasequipmentclass": [
                                  {
                                      "equipmentclass": {
                                          "name": "Drehmaschine",
                                          "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                      }
                                  }
                              ]
                          }
                      }
                  ]
              }
          },
          {
              "equipment": {
                  "name": "5Achs Bearbeitungszentrum",
                  "equipmentid": "102",
                  "inventoryid": "i102",
                  "constructiondate": "2012",
                  "manufacturerserialnumber": "dmg87654321",
                  "memo": "Meine Notiz",
                  "image": {
                      "fileid": "102a58a5-9aec-43df-9591-f8816014d542/102a58a5-9aec-43df-9591-f8816014d543.jpg",
                      "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                      "mimetype": "image/jpeg",
                      "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq102/102a58a5-9aec-43df-9591-f8816014d542/102a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=9fcb192a5f8b64f34e88b34382b04c722afc2c595682f82a69ea98d73a6efa15"
                  },
                  "nodeid": "247fn://247uptime.io/abc-eq102",
                  "hasmaintenancetask": [
                      {
                          "maintenancetask": {
                              "title": "test cost 8899",
                              "description": null,
                              "reminder": "2w",
                              "repetitioninterval": "6m",
                              "startingfrom": 1706227200000,
                              "specifier": null,
                              "created": 0,
                              "nodeid": "247fn://247uptime.io/6d06837a-6ece-49d8-b472-d2c0c8f03922",
                              "hascategory": [
                                  {
                                      "maintenancecategory": {
                                          "name": "Routineinspektion",
                                          "colorcode": "#1172d4",
                                          "nodeid": "247fn://247uptime.io/abc-maintenancecategory1"
                                      }
                                  }
                              ]
                          }
                      }
                  ],
                  "hasequipmenttype": [
                      {
                          "equipmenttype": {
                              "model": "DMU 70",
                              "nodeid": "247fn://247uptime.io/3a4ddeaa-83a5-4d58-a9e1-69fd7f3f102f",
                              "isequipmenttypeof": [
                                  {
                                      "brand": {
                                          "name": "Deckel Maho",
                                          "nodeid": "247fn://247uptime.io/2132d959-981e-468c-85fa-303ccbce3dd5"
                                      }
                                  }
                              ],
                              "hasequipmentclass": [
                                  {
                                      "equipmentclass": {
                                          "name": "Drehmaschine",
                                          "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                      }
                                  }
                              ]
                          }
                      }
                  ]
              }
          },
          {
              "equipment": {
                  "name": "Bolzenbearbeitung",
                  "equipmentid": "104",
                  "inventoryid": "i104",
                  "constructiondate": "2019",
                  "manufacturerserialnumber": "emco1234567",
                  "memo": "Meine Notiz",
                  "image": {
                      "fileid": "104a58a5-9aec-43df-9591-f8816014d542/104a58a5-9aec-43df-9591-f8816014d543.jpg",
                      "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                      "mimetype": "image/jpeg",
                      "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq104/104a58a5-9aec-43df-9591-f8816014d542/104a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=a2b6f293148cde6d12e7174ad024342b5d09f4658715706b8e9b9bc6129650b0"
                  },
                  "nodeid": "247fn://247uptime.io/abc-eq104",
                  "hasmaintenancetask": [
                      {
                          "maintenancetask": {
                              "title": "new cost testing 1",
                              "description": null,
                              "reminder": "2w",
                              "repetitioninterval": "6m",
                              "startingfrom": 1706227200000,
                              "specifier": null,
                              "created": 0,
                              "nodeid": "247fn://247uptime.io/c000677b-76fd-4320-bce7-23b6b6cf6f16",
                              "hascategory": [
                                  {
                                      "maintenancecategory": {
                                          "name": "Kundendienst",
                                          "colorcode": "#e36a0e",
                                          "nodeid": "247fn://247uptime.io/abc-maintenancecategory3"
                                      }
                                  }
                              ]
                          }
                      },
                      {
                          "maintenancetask": {
                              "title": "new cost testing 2",
                              "description": null,
                              "reminder": "2w",
                              "repetitioninterval": "1y",
                              "startingfrom": 1706227200000,
                              "specifier": null,
                              "created": 0,
                              "nodeid": "247fn://247uptime.io/7c08cca6-e985-415a-8403-5b88c6d6342e",
                              "hascategory": [
                                  {
                                      "maintenancecategory": {
                                          "name": "Routinewartung",
                                          "colorcode": "#d40ee6",
                                          "nodeid": "247fn://247uptime.io/abc-maintenancecategory2"
                                      }
                                  }
                              ]
                          }
                      }
                  ],
                  "hasequipmenttype": [
                      {
                          "equipmenttype": {
                              "model": "Hyperturn 45",
                              "nodeid": "247fn://247uptime.io/a7cea051-d8d5-4a48-8b8f-795fcb6519b5",
                              "isequipmenttypeof": [
                                  {
                                      "brand": {
                                          "name": "Emco",
                                          "nodeid": "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091"
                                      }
                                  }
                              ],
                              "hasequipmentclass": [
                                  {
                                      "equipmentclass": {
                                          "name": "Drehmaschine",
                                          "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                      }
                                  }
                              ]
                          }
                      }
                  ]
              }
          },
          {
              "equipment": {
                  "name": "Bearbeitungszentrum",
                  "equipmentid": "108",
                  "inventoryid": "i108",
                  "constructiondate": "2015",
                  "manufacturerserialnumber": "her2314",
                  "memo": "t",
                  "image": {
                      "fileid": "108a58a5-9aec-43df-9591-f8816014d542/108a58a5-9aec-43df-9591-f8816014d543.jpg",
                      "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                      "mimetype": "image/jpeg",
                      "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq108/108a58a5-9aec-43df-9591-f8816014d542/108a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=bfab1690e406a6f7fee4871d0aada9d1d7f6966a5fb18f575bf516dd996a7328"
                  },
                  "nodeid": "247fn://247uptime.io/abc-eq108",
                  "hasmaintenancetask": [
                      {
                          "maintenancetask": {
                              "title": "test cost 22",
                              "description": null,
                              "reminder": "1w",
                              "repetitioninterval": "6m",
                              "startingfrom": 1706227200000,
                              "specifier": null,
                              "created": 0,
                              "nodeid": "247fn://247uptime.io/7c2a49ba-6f19-4e97-a61d-b253c475fac5",
                              "hascategory": [
                                  {
                                      "maintenancecategory": {
                                          "name": "Kundendienst",
                                          "colorcode": "#e36a0e",
                                          "nodeid": "247fn://247uptime.io/abc-maintenancecategory3"
                                      }
                                  }
                              ]
                          }
                      }
                  ],
                  "hasnotification": [
                      {
                          "notification": {
                              "created": 1706278552820,
                              "progressstarted": 0,
                              "closed": 0,
                              "status": 0,
                              "type": 6,
                              "title": "test cost 22",
                              "description": "",
                              "nodeid": "247fn://247uptime.io/301cfe24-7402-49de-95bc-7b69c469dd36"
                          }
                      }
                  ],
                  "hasequipmenttype": [
                      {
                          "equipmenttype": {
                              "model": "C 400",
                              "nodeid": "247fn://247uptime.io/96f02979-e47d-42a9-9be6-6985c0cac1b3",
                              "isequipmenttypeof": [
                                  {
                                      "brand": {
                                          "name": "Hedelius",
                                          "nodeid": "247fn://247uptime.io/994010e1-4167-4703-82a5-630040b548d6"
                                      }
                                  }
                              ],
                              "hasequipmentclass": [
                                  {
                                      "equipmentclass": {
                                          "name": "Drehmaschine",
                                          "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                      }
                                  }
                              ]
                          }
                      }
                  ]
              }
          },
          {
              "equipment": {
                  "name": "Prototypenbau",
                  "equipmentid": "110",
                  "inventoryid": "i110",
                  "constructiondate": "2010",
                  "manufacturerserialnumber": "weil12345",
                  "memo": "ehemals Lehrwerkstadt",
                  "image": {
                      "fileid": "110a58a5-9aec-43df-9591-f8816014d542/110a58a5-9aec-43df-9591-f8816014d543.jpg",
                      "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                      "mimetype": "image/jpeg",
                      "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq110/110a58a5-9aec-43df-9591-f8816014d542/110a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=55c11ef67dd0df4602fa053692da19b183c89a2f5b87410bef756400d0b54887"
                  },
                  "nodeid": "247fn://247uptime.io/abc-eq110",
                  "hasequipmenttype": [
                      {
                          "equipmenttype": {
                              "model": "Condor 81",
                              "nodeid": "247fn://247uptime.io/cc2347d2-8d19-49a2-b72a-0b09db902a82",
                              "isequipmenttypeof": [
                                  {
                                      "brand": {
                                          "name": "Weiler",
                                          "nodeid": "247fn://247uptime.io/6ac947df-48fe-4841-845f-1637e476ad54"
                                      }
                                  }
                              ],
                              "hasequipmentclass": [
                                  {
                                      "equipmentclass": {
                                          "name": "Drehmaschine",
                                          "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                      }
                                  }
                              ]
                          }
                      }
                  ]
              }
          }
      ]
  },
  "247fn://247uptime.io/abc-area2": {
      "name": "Gehäusefertigung",
      "nodeid": "247fn://247uptime.io/abc-area2",
      "hasequipment": [
          {
              "equipment": {
                  "name": "Kegelradschleifen",
                  "equipmentid": "201",
                  "inventoryid": "i201",
                  "constructiondate": "2013",
                  "manufacturerserialnumber": "Kling12345",
                  "memo": "",
                  "image": {
                      "fileid": "201a58a5-9aec-43df-9591-f8816014d542/201a58a5-9aec-43df-9591-f8816014d543.jpg",
                      "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                      "mimetype": "image/jpeg",
                      "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq201/201a58a5-9aec-43df-9591-f8816014d542/201a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=233f2d02837b5a199c5dc5bc7de812d8fc84af7f006763424b16dc33daa11b6e"
                  },
                  "nodeid": "247fn://247uptime.io/abc-eq201",
                  "hasequipmenttype": [
                      {
                          "equipmenttype": {
                              "model": "WNC 80",
                              "nodeid": "247fn://247uptime.io/8dc7ec1b-f5fa-4548-8dee-b85d4a68c07d",
                              "isequipmenttypeof": [
                                  {
                                      "brand": {
                                          "name": "Klingelnberg",
                                          "nodeid": "247fn://247uptime.io/30da53b9-9580-4763-aa4e-f7aefe83c8f7"
                                      }
                                  }
                              ],
                              "hasequipmentclass": [
                                  {
                                      "equipmentclass": {
                                          "name": "Drehmaschine",
                                          "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                      }
                                  }
                              ]
                          }
                      }
                  ]
              }
          },
          {
              "equipment": {
                  "name": "Zahnradfräsen",
                  "equipmentid": "202",
                  "inventoryid": "i202",
                  "constructiondate": "2012",
                  "manufacturerserialnumber": "Lieb123456",
                  "memo": "",
                  "image": {
                      "fileid": "202a58a5-9aec-43df-9591-f8816014d542/202a58a5-9aec-43df-9591-f8816014d543.jpg",
                      "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                      "mimetype": "image/jpeg",
                      "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq202/202a58a5-9aec-43df-9591-f8816014d542/202a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=1014c27613e091be616e5069188f42505bf520ea78558d379152b1ffec556ff6"
                  },
                  "nodeid": "247fn://247uptime.io/abc-eq202",
                  "hasequipmenttype": [
                      {
                          "equipmenttype": {
                              "model": "LC502",
                              "nodeid": "247fn://247uptime.io/259b5267-3cd7-4b32-9e21-1959b0522888",
                              "isequipmenttypeof": [
                                  {
                                      "brand": {
                                          "name": "Liebherr",
                                          "nodeid": "247fn://247uptime.io/1569942f-e445-4571-b75e-4da84e5fb993"
                                      }
                                  }
                              ],
                              "hasequipmentclass": [
                                  {
                                      "equipmentclass": {
                                          "name": "Drehmaschine",
                                          "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                      }
                                  }
                              ]
                          }
                      }
                  ]
              }
          },
          {
              "equipment": {
                  "name": "Kegelradfräsen",
                  "equipmentid": "203",
                  "inventoryid": "i203",
                  "constructiondate": "2002",
                  "manufacturerserialnumber": "gle1234567",
                  "memo": "",
                  "image": {
                      "fileid": "203a58a5-9aec-43df-9591-f8816014d542/203a58a5-9aec-43df-9591-f8816014d543.jpg",
                      "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                      "mimetype": "image/jpeg",
                      "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq203/203a58a5-9aec-43df-9591-f8816014d542/203a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=8f64bd99b0567e97fe568919c0dc0757ad7862243848ef04a912c115460528f4"
                  },
                  "nodeid": "247fn://247uptime.io/abc-eq203",
                  "hasequipmenttype": [
                      {
                          "equipmenttype": {
                              "model": "114",
                              "nodeid": "247fn://247uptime.io/d0ce0d59-d70d-4ccd-8fa4-29358127c201",
                              "isequipmenttypeof": [
                                  {
                                      "brand": {
                                          "name": "Gleason",
                                          "nodeid": "247fn://247uptime.io/2728a232-fe86-4c21-81eb-a47c6651c1e9"
                                      }
                                  }
                              ],
                              "hasequipmentclass": [
                                  {
                                      "equipmentclass": {
                                          "name": "Drehmaschine",
                                          "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                      }
                                  }
                              ]
                          }
                      }
                  ]
              }
          }
      ]
  },
  "247fn://247uptime.io/abc-area3": {
      "name": "Gehäusefertigung",
      "nodeid": "247fn://247uptime.io/abc-area3",
      "hasequipment": [
          {
              "equipment": {
                  "name": "Deckelbearbeitung 1",
                  "equipmentid": "105",
                  "inventoryid": "i105",
                  "constructiondate": "2019",
                  "manufacturerserialnumber": "hell12345",
                  "memo": "",
                  "image": {
                      "fileid": "105a58a5-9aec-43df-9591-f8816014d542/105a58a5-9aec-43df-9591-f8816014d543.jpg",
                      "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                      "mimetype": "image/jpeg",
                      "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq105/105a58a5-9aec-43df-9591-f8816014d542/105a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=29e1eb13e8e34f12c2bd91dea7bb5b872d4a0ec0c16b93775988b11089b148e0"
                  },
                  "nodeid": "247fn://247uptime.io/abc-eq105",
                  "hasequipmenttype": [
                      {
                          "equipmenttype": {
                              "model": "H2000",
                              "nodeid": "247fn://247uptime.io/74c53868-a29e-45e5-b0ef-a7441c60d787",
                              "isequipmenttypeof": [
                                  {
                                      "brand": {
                                          "name": "Heller",
                                          "nodeid": "247fn://247uptime.io/c61cbcf2-b7c9-4365-a1b9-77ccd6f8a3c0"
                                      }
                                  }
                              ],
                              "hasequipmentclass": [
                                  {
                                      "equipmentclass": {
                                          "name": "Drehmaschine",
                                          "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                      }
                                  }
                              ]
                          }
                      }
                  ]
              }
          },
          {
              "equipment": {
                  "name": "Gehäusedeckel",
                  "equipmentid": "106",
                  "inventoryid": "i106",
                  "constructiondate": "2019",
                  "manufacturerserialnumber": "hell98765",
                  "memo": "",
                  "image": {
                      "fileid": "106a58a5-9aec-43df-9591-f8816014d542/106a58a5-9aec-43df-9591-f8816014d543.jpg",
                      "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                      "mimetype": "image/jpeg",
                      "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq106/106a58a5-9aec-43df-9591-f8816014d542/106a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=e78b5614be4fe1232b149df860aa7491cda298f40aa98d7cfcb4f5eed17a46b6"
                  },
                  "nodeid": "247fn://247uptime.io/abc-eq106",
                  "hasequipmenttype": [
                      {
                          "equipmenttype": {
                              "model": "H2000",
                              "nodeid": "247fn://247uptime.io/74c53868-a29e-45e5-b0ef-a7441c60d787",
                              "isequipmenttypeof": [
                                  {
                                      "brand": {
                                          "name": "Heller",
                                          "nodeid": "247fn://247uptime.io/c61cbcf2-b7c9-4365-a1b9-77ccd6f8a3c0"
                                      }
                                  }
                              ],
                              "hasequipmentclass": [
                                  {
                                      "equipmentclass": {
                                          "name": "Drehmaschine",
                                          "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                      }
                                  }
                              ]
                          }
                      }
                  ]
              }
          },
          {
              "equipment": {
                  "name": "Fräsmaschine",
                  "equipmentid": "107",
                  "inventoryid": "i107",
                  "constructiondate": "2017",
                  "manufacturerserialnumber": "Grob54321",
                  "memo": "wird z.Zt. nur Spätschicht genutzt",
                  "image": {
                      "fileid": "107a58a5-9aec-43df-9591-f8816014d542/107a58a5-9aec-43df-9591-f8816014d543.jpg",
                      "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                      "mimetype": "image/jpeg",
                      "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq107/107a58a5-9aec-43df-9591-f8816014d542/107a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=bfc6e9cc701292e0b9e80cec69cc91c3a0840960911c644f5c68c60103b64f0b"
                  },
                  "nodeid": "247fn://247uptime.io/abc-eq107",
                  "hasequipmenttype": [
                      {
                          "equipmenttype": {
                              "model": "G350",
                              "nodeid": "247fn://247uptime.io/58ff6083-739d-4871-88d6-56d52eb97e40",
                              "isequipmenttypeof": [
                                  {
                                      "brand": {
                                          "name": "Grob",
                                          "nodeid": "247fn://247uptime.io/b787211a-80ea-4861-a4c3-efab55106cf0"
                                      }
                                  }
                              ],
                              "hasequipmentclass": [
                                  {
                                      "equipmentclass": {
                                          "name": "Drehmaschine",
                                          "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                      }
                                  }
                              ]
                          }
                      }
                  ]
              }
          },
          {
              "equipment": {
                  "name": "Nachbearbeitung",
                  "equipmentid": "109",
                  "inventoryid": "i109",
                  "constructiondate": "2013",
                  "manufacturerserialnumber": "hed12345",
                  "memo": "zur Nachbarbeit",
                  "image": {
                      "fileid": "109a58a5-9aec-43df-9591-f8816014d542/109a58a5-9aec-43df-9591-f8816014d543.jpg",
                      "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                      "mimetype": "image/jpeg",
                      "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq109/109a58a5-9aec-43df-9591-f8816014d542/109a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=6f976082ff72834a2188dbb56546bb45b9836904cde2e69e7d5307f7d4c7eb6b"
                  },
                  "nodeid": "247fn://247uptime.io/abc-eq109",
                  "hasequipmenttype": [
                      {
                          "equipmenttype": {
                              "model": "Forte 50",
                              "nodeid": "247fn://247uptime.io/7199a3aa-9390-45b5-9c67-c6b998722052",
                              "isequipmenttypeof": [
                                  {
                                      "brand": {
                                          "name": "Hedelius",
                                          "nodeid": "247fn://247uptime.io/994010e1-4167-4703-82a5-630040b548d6"
                                      }
                                  }
                              ],
                              "hasequipmentclass": [
                                  {
                                      "equipmentclass": {
                                          "name": "Drehmaschine",
                                          "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                      }
                                  }
                              ]
                          }
                      }
                  ]
              }
          }
      ]
  }
}`);

const subscribedEquipmentpools = JSON.parse(`{
    "247fn://247uptime.io/abc-equipmentpool1": {
        "name": "Zerspanung",
        "nodeid": "247fn://247uptime.io/abc-equipmentpool1",
        "hasequipment": [
            {
                "equipment": {
                    "name": "Nachbearbeitung Drehteile",
                    "equipmentid": "103",
                    "inventoryid": "i103",
                    "constructiondate": "2017",
                    "manufacturerserialnumber": "emco8765432",
                    "memo": "wird z.Zt. nur Spätschicht genutzt",
                    "image": {
                        "fileid": "103a58a5-9aec-43df-9591-f8816014d542/103a58a5-9aec-43df-9591-f8816014d543.jpg",
                        "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                        "mimetype": "image/jpeg",
                        "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq103/103a58a5-9aec-43df-9591-f8816014d542/103a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=ada55d7086a8fe45cfb975de421a25ca60b27c157d4b2fcc6d37445ce94e5e8f"
                    },
                    "nodeid": "247fn://247uptime.io/abc-eq103",
                    "hasmaintenancetask": [
                        {
                            "maintenancetask": {
                                "title": "Allgemeine Inspektion der Gesamtmaschine",
                                "description": null,
                                "reminder": "2w",
                                "repetitioninterval": "3m",
                                "startingfrom": 1675638000000,
                                "specifier": null,
                                "created": 0,
                                "nodeid": "247fn://247uptime.io/abc-maintenancetask1",
                                "hascategory": [
                                    {
                                        "maintenancecategory": {
                                            "name": "Routineinspektion",
                                            "colorcode": "#1172d4",
                                            "nodeid": "247fn://247uptime.io/abc-maintenancecategory1"
                                        }
                                    }
                                ]
                            }
                        },
                        {
                            "maintenancetask": {
                                "title": "Austausch Schmiermittel",
                                "description": null,
                                "reminder": "2w",
                                "repetitioninterval": "1y",
                                "startingfrom": 1676847600000,
                                "specifier": null,
                                "created": 0,
                                "nodeid": "247fn://247uptime.io/abc-maintenancetask2",
                                "hascategory": [
                                    {
                                        "maintenancecategory": {
                                            "name": "Routinewartung",
                                            "colorcode": "#d40ee6",
                                            "nodeid": "247fn://247uptime.io/abc-maintenancecategory2"
                                        }
                                    }
                                ]
                            }
                        },
                        {
                            "maintenancetask": {
                                "title": "DGUV V3 Prüfung elektrische Betriebsmittel",
                                "description": null,
                                "reminder": "2w",
                                "repetitioninterval": "1y",
                                "startingfrom": 1676847600000,
                                "specifier": null,
                                "created": 0,
                                "nodeid": "247fn://247uptime.io/abc-maintenancetask3",
                                "hascategory": [
                                    {
                                        "maintenancecategory": {
                                            "name": "Routinewartung",
                                            "colorcode": "#d40ee6",
                                            "nodeid": "247fn://247uptime.io/abc-maintenancecategory2"
                                        }
                                    }
                                ]
                            }
                        },
                        {
                            "maintenancetask": {
                                "title": "Kundendienst - Jahreswartung",
                                "description": null,
                                "reminder": "2w",
                                "repetitioninterval": "1y",
                                "startingfrom": 1676847600000,
                                "specifier": null,
                                "created": 0,
                                "nodeid": "247fn://247uptime.io/abc-maintenancetask4",
                                "hascategory": [
                                    {
                                        "maintenancecategory": {
                                            "name": "Kundendienst",
                                            "colorcode": "#e36a0e",
                                            "nodeid": "247fn://247uptime.io/abc-maintenancecategory3"
                                        }
                                    }
                                ]
                            }
                        },
                        {
                            "maintenancetask": {
                                "title": "test 2111",
                                "description": null,
                                "reminder": "1w",
                                "repetitioninterval": "1y",
                                "startingfrom": 1705363200000,
                                "specifier": null,
                                "created": 0,
                                "nodeid": "247fn://247uptime.io/d88a60e9-96b0-46e8-b2bb-93e902315c58",
                                "hascategory": [
                                    {
                                        "maintenancecategory": {
                                            "name": "Kundendienst",
                                            "colorcode": "#e36a0e",
                                            "nodeid": "247fn://247uptime.io/abc-maintenancecategory3"
                                        }
                                    }
                                ]
                            }
                        },
                        {
                            "maintenancetask": {
                                "title": "test maintenance task",
                                "description": null,
                                "reminder": "1w",
                                "repetitioninterval": "3m",
                                "startingfrom": 1705968000000,
                                "specifier": null,
                                "created": 0,
                                "nodeid": "247fn://247uptime.io/461cedb8-6ed3-42e9-9ad1-3dcaefb9efdd",
                                "hascategory": [
                                    {
                                        "maintenancecategory": {
                                            "name": "Kundendienst",
                                            "colorcode": "#e36a0e",
                                            "nodeid": "247fn://247uptime.io/abc-maintenancecategory3"
                                        }
                                    }
                                ]
                            }
                        },
                        {
                            "maintenancetask": {
                                "title": "test maintenance tasks",
                                "description": null,
                                "reminder": "1w",
                                "repetitioninterval": "3m",
                                "startingfrom": 1705968000000,
                                "specifier": null,
                                "created": 0,
                                "nodeid": "247fn://247uptime.io/599b98ec-57b4-42fe-92b8-0437a00f2e8b",
                                "hascategory": [
                                    {
                                        "maintenancecategory": {
                                            "name": "Kundendienst",
                                            "colorcode": "#e36a0e",
                                            "nodeid": "247fn://247uptime.io/abc-maintenancecategory3"
                                        }
                                    }
                                ]
                            }
                        },
                        {
                            "maintenancetask": {
                                "title": "test alpha 11222",
                                "description": null,
                                "reminder": "2w",
                                "repetitioninterval": "6m",
                                "startingfrom": 1706227200000,
                                "specifier": null,
                                "created": 0,
                                "nodeid": "247fn://247uptime.io/f03e9745-c530-4ed8-b09f-0bfa3f741a89",
                                "hascategory": [
                                    {
                                        "maintenancecategory": {
                                            "name": "Routineinspektion",
                                            "colorcode": "#1172d4",
                                            "nodeid": "247fn://247uptime.io/abc-maintenancecategory1"
                                        }
                                    }
                                ]
                            }
                        },
                        {
                            "maintenancetask": {
                                "title": "testing new costs",
                                "description": null,
                                "reminder": "2w",
                                "repetitioninterval": "6m",
                                "startingfrom": 1706227200000,
                                "specifier": null,
                                "created": 0,
                                "nodeid": "247fn://247uptime.io/3f4ef7e7-d161-46a5-ac2f-4506eab07968",
                                "hascategory": [
                                    {
                                        "maintenancecategory": {
                                            "name": "Routinewartung",
                                            "colorcode": "#d40ee6",
                                            "nodeid": "247fn://247uptime.io/abc-maintenancecategory2"
                                        }
                                    }
                                ]
                            }
                        },
                        {
                            "maintenancetask": {
                                "title": "new last test",
                                "description": null,
                                "reminder": "1w",
                                "repetitioninterval": "6m",
                                "startingfrom": 1706227200000,
                                "specifier": null,
                                "created": 0,
                                "nodeid": "247fn://247uptime.io/c2671c17-a7ad-4286-a666-24dc4abead0a",
                                "hascategory": [
                                    {
                                        "maintenancecategory": {
                                            "name": "Kundendienst",
                                            "colorcode": "#e36a0e",
                                            "nodeid": "247fn://247uptime.io/abc-maintenancecategory3"
                                        }
                                    }
                                ]
                            }
                        },
                        {
                            "maintenancetask": {
                                "title": "gema cost test",
                                "description": null,
                                "reminder": "1w",
                                "repetitioninterval": "6m",
                                "startingfrom": 1706227200000,
                                "specifier": null,
                                "created": 0,
                                "nodeid": "247fn://247uptime.io/a0650736-4c59-4c5f-ba1e-2d04b8cc7692",
                                "hascategory": [
                                    {
                                        "maintenancecategory": {
                                            "name": "Kundendienst",
                                            "colorcode": "#e36a0e",
                                            "nodeid": "247fn://247uptime.io/abc-maintenancecategory3"
                                        }
                                    }
                                ]
                            }
                        },
                        {
                            "maintenancetask": {
                                "title": "test44",
                                "description": null,
                                "reminder": "1w",
                                "repetitioninterval": "3m",
                                "startingfrom": 1706486400000,
                                "specifier": null,
                                "created": 0,
                                "nodeid": "247fn://247uptime.io/f16ae4da-14a3-4699-9d2c-dfdf121cb06b",
                                "hascategory": [
                                    {
                                        "maintenancecategory": {
                                            "name": "Kundendienst",
                                            "colorcode": "#e36a0e",
                                            "nodeid": "247fn://247uptime.io/abc-maintenancecategory3"
                                        }
                                    }
                                ]
                            }
                        }
                    ],
                    "hasnotification": [
                        {
                            "notification": {
                                "created": 1675064430000,
                                "progressstarted": 0,
                                "closed": 0,
                                "status": 0,
                                "type": 1,
                                "title": "Ungewöhnliches Geräusch an der Spindel",
                                "description": "klingt wie ein schleifen, aber man erkennt keine beeinträchtigung. War gestern noch nicht",
                                "nodeid": "247fn://247uptime.io/abc-notification3"
                            }
                        },
                        {
                            "notification": {
                                "created": 1704848400142,
                                "progressstarted": 0,
                                "closed": 0,
                                "status": 0,
                                "type": 6,
                                "title": "Austausch Schmiermittel",
                                "description": "",
                                "nodeid": "247fn://247uptime.io/b40d6a3d-bb81-452b-8e0a-c03f5bfb05a4"
                            }
                        },
                        {
                            "notification": {
                                "created": 1704934800038,
                                "progressstarted": 0,
                                "closed": 0,
                                "status": 0,
                                "type": 6,
                                "title": "DGUV V3 Prüfung elektrische Betriebsmittel",
                                "description": "",
                                "nodeid": "247fn://247uptime.io/66fa0b6f-79ec-4a71-bd93-3341535ed00a"
                            }
                        },
                        {
                            "notification": {
                                "created": 1705021200003,
                                "progressstarted": 0,
                                "closed": 0,
                                "status": 0,
                                "type": 6,
                                "title": "Allgemeine Inspektion der Gesamtmaschine",
                                "description": "",
                                "nodeid": "247fn://247uptime.io/4802720c-63e1-463f-bbfd-1da90442706e"
                            }
                        },
                        {
                            "notification": {
                                "created": 1705422122176,
                                "progressstarted": 0,
                                "closed": 0,
                                "status": 0,
                                "type": 6,
                                "title": "test 2",
                                "description": "",
                                "nodeid": "247fn://247uptime.io/c1744c58-96a8-487b-a912-d48749a5e4f0"
                            }
                        },
                        {
                            "notification": {
                                "created": 1705577390403,
                                "progressstarted": 0,
                                "closed": 0,
                                "status": 0,
                                "type": 6,
                                "title": "test maintenance task",
                                "description": "",
                                "nodeid": "247fn://247uptime.io/bd02a6ae-afb0-4085-aab8-5b6bffd4fea8"
                            }
                        },
                        {
                            "notification": {
                                "created": 1705577437056,
                                "progressstarted": 0,
                                "closed": 0,
                                "status": 0,
                                "type": 6,
                                "title": "test maintenance tasks",
                                "description": "",
                                "nodeid": "247fn://247uptime.io/d3c21b78-64ee-4bc8-9b99-00694864a9f0"
                            }
                        },
                        {
                            "notification": {
                                "created": 1705971600075,
                                "progressstarted": 0,
                                "closed": 0,
                                "status": 0,
                                "type": 6,
                                "title": "test maintenance task",
                                "description": "",
                                "nodeid": "247fn://247uptime.io/0f606789-9a27-42a0-86be-2ea17562263f"
                            }
                        },
                        {
                            "notification": {
                                "created": 1706522889519,
                                "progressstarted": 0,
                                "closed": 0,
                                "status": 0,
                                "type": 6,
                                "title": "test44",
                                "description": "",
                                "nodeid": "247fn://247uptime.io/bee6925c-2265-459b-afdd-feae88c5edb0"
                            }
                        }
                    ],
                    "hasequipmenttype": [
                        {
                            "equipmenttype": {
                                "model": "Hyperturn 65",
                                "nodeid": "247fn://247uptime.io/06d58ae8-274d-420f-b063-d3dd85533105",
                                "isequipmenttypeof": [
                                    {
                                        "brand": {
                                            "name": "Emco",
                                            "nodeid": "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091"
                                        }
                                    }
                                ],
                                "hasequipmentclass": [
                                    {
                                        "equipmentclass": {
                                            "name": "Drehmaschine",
                                            "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                        }
                                    }
                                ]
                            }
                        }
                    ]
                }
            },
            {
                "equipment": {
                    "name": "5Achs Bearbeitungszentrum",
                    "equipmentid": "102",
                    "inventoryid": "i102",
                    "constructiondate": "2012",
                    "manufacturerserialnumber": "dmg87654321",
                    "memo": "Meine Notiz",
                    "image": {
                        "fileid": "102a58a5-9aec-43df-9591-f8816014d542/102a58a5-9aec-43df-9591-f8816014d543.jpg",
                        "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                        "mimetype": "image/jpeg",
                        "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq102/102a58a5-9aec-43df-9591-f8816014d542/102a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=9fcb192a5f8b64f34e88b34382b04c722afc2c595682f82a69ea98d73a6efa15"
                    },
                    "nodeid": "247fn://247uptime.io/abc-eq102",
                    "hasmaintenancetask": [
                        {
                            "maintenancetask": {
                                "title": "test cost 8899",
                                "description": null,
                                "reminder": "2w",
                                "repetitioninterval": "6m",
                                "startingfrom": 1706227200000,
                                "specifier": null,
                                "created": 0,
                                "nodeid": "247fn://247uptime.io/6d06837a-6ece-49d8-b472-d2c0c8f03922",
                                "hascategory": [
                                    {
                                        "maintenancecategory": {
                                            "name": "Routineinspektion",
                                            "colorcode": "#1172d4",
                                            "nodeid": "247fn://247uptime.io/abc-maintenancecategory1"
                                        }
                                    }
                                ]
                            }
                        }
                    ],
                    "hasequipmenttype": [
                        {
                            "equipmenttype": {
                                "model": "DMU 70",
                                "nodeid": "247fn://247uptime.io/3a4ddeaa-83a5-4d58-a9e1-69fd7f3f102f",
                                "isequipmenttypeof": [
                                    {
                                        "brand": {
                                            "name": "Deckel Maho",
                                            "nodeid": "247fn://247uptime.io/2132d959-981e-468c-85fa-303ccbce3dd5"
                                        }
                                    }
                                ],
                                "hasequipmentclass": [
                                    {
                                        "equipmentclass": {
                                            "name": "Drehmaschine",
                                            "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                        }
                                    }
                                ]
                            }
                        }
                    ]
                }
            },
            {
                "equipment": {
                    "name": "5Achs Bearbeitungszentrum",
                    "equipmentid": "101",
                    "inventoryid": "i101",
                    "constructiondate": "2017",
                    "manufacturerserialnumber": "dmg12345678",
                    "memo": "Die Maschine als Messemaschine gekauft",
                    "image": {
                        "fileid": "101a58a5-9aec-43df-9591-f8816014d542/101a58a5-9aec-43df-9591-f8816014d543.jpg",
                        "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                        "mimetype": "image/jpeg",
                        "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq101/101a58a5-9aec-43df-9591-f8816014d542/101a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=c183ec751193c6326b9bb0319cfc89837c1a38413cdde0990faeb6d27e4c51ed"
                    },
                    "nodeid": "247fn://247uptime.io/abc-eq101",
                    "hasmaintenancetask": [
                        {
                            "maintenancetask": {
                                "title": "testing cost value",
                                "description": null,
                                "reminder": "1w",
                                "repetitioninterval": "6m",
                                "startingfrom": 1706227200000,
                                "specifier": null,
                                "created": 0,
                                "nodeid": "247fn://247uptime.io/924c6953-61f8-4ff7-8168-d5977e5e46c7",
                                "hascategory": [
                                    {
                                        "maintenancecategory": {
                                            "name": "Kundendienst",
                                            "colorcode": "#e36a0e",
                                            "nodeid": "247fn://247uptime.io/abc-maintenancecategory3"
                                        }
                                    }
                                ]
                            }
                        },
                        {
                            "maintenancetask": {
                                "title": "test cost 99",
                                "description": null,
                                "reminder": "2w",
                                "repetitioninterval": "6m",
                                "startingfrom": 1706227200000,
                                "specifier": null,
                                "created": 0,
                                "nodeid": "247fn://247uptime.io/cd67678c-f01d-4e74-ac64-5f251179e3c5",
                                "hascategory": [
                                    {
                                        "maintenancecategory": {
                                            "name": "Routinewartung",
                                            "colorcode": "#d40ee6",
                                            "nodeid": "247fn://247uptime.io/abc-maintenancecategory2"
                                        }
                                    }
                                ]
                            }
                        }
                    ],
                    "hasequipmenttype": [
                        {
                            "equipmenttype": {
                                "model": "DMU 100",
                                "nodeid": "247fn://247uptime.io/0b7135e8-56e6-47a5-b891-9e1471d3a2c5",
                                "isequipmenttypeof": [
                                    {
                                        "brand": {
                                            "name": "Deckel Maho",
                                            "nodeid": "247fn://247uptime.io/2132d959-981e-468c-85fa-303ccbce3dd5"
                                        }
                                    }
                                ],
                                "hasequipmentclass": [
                                    {
                                        "equipmentclass": {
                                            "name": "Drehmaschine",
                                            "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                        }
                                    }
                                ]
                            }
                        }
                    ]
                }
            },
            {
                "equipment": {
                    "name": "Bolzenbearbeitung",
                    "equipmentid": "104",
                    "inventoryid": "i104",
                    "constructiondate": "2019",
                    "manufacturerserialnumber": "emco1234567",
                    "memo": "Meine Notiz",
                    "image": {
                        "fileid": "104a58a5-9aec-43df-9591-f8816014d542/104a58a5-9aec-43df-9591-f8816014d543.jpg",
                        "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                        "mimetype": "image/jpeg",
                        "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq104/104a58a5-9aec-43df-9591-f8816014d542/104a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=a2b6f293148cde6d12e7174ad024342b5d09f4658715706b8e9b9bc6129650b0"
                    },
                    "nodeid": "247fn://247uptime.io/abc-eq104",
                    "hasmaintenancetask": [
                        {
                            "maintenancetask": {
                                "title": "new cost testing 1",
                                "description": null,
                                "reminder": "2w",
                                "repetitioninterval": "6m",
                                "startingfrom": 1706227200000,
                                "specifier": null,
                                "created": 0,
                                "nodeid": "247fn://247uptime.io/c000677b-76fd-4320-bce7-23b6b6cf6f16",
                                "hascategory": [
                                    {
                                        "maintenancecategory": {
                                            "name": "Kundendienst",
                                            "colorcode": "#e36a0e",
                                            "nodeid": "247fn://247uptime.io/abc-maintenancecategory3"
                                        }
                                    }
                                ]
                            }
                        },
                        {
                            "maintenancetask": {
                                "title": "new cost testing 2",
                                "description": null,
                                "reminder": "2w",
                                "repetitioninterval": "1y",
                                "startingfrom": 1706227200000,
                                "specifier": null,
                                "created": 0,
                                "nodeid": "247fn://247uptime.io/7c08cca6-e985-415a-8403-5b88c6d6342e",
                                "hascategory": [
                                    {
                                        "maintenancecategory": {
                                            "name": "Routinewartung",
                                            "colorcode": "#d40ee6",
                                            "nodeid": "247fn://247uptime.io/abc-maintenancecategory2"
                                        }
                                    }
                                ]
                            }
                        }
                    ],
                    "hasequipmenttype": [
                        {
                            "equipmenttype": {
                                "model": "Hyperturn 45",
                                "nodeid": "247fn://247uptime.io/a7cea051-d8d5-4a48-8b8f-795fcb6519b5",
                                "isequipmenttypeof": [
                                    {
                                        "brand": {
                                            "name": "Emco",
                                            "nodeid": "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091"
                                        }
                                    }
                                ],
                                "hasequipmentclass": [
                                    {
                                        "equipmentclass": {
                                            "name": "Drehmaschine",
                                            "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                        }
                                    }
                                ]
                            }
                        }
                    ]
                }
            },
            {
                "equipment": {
                    "name": "Bearbeitungszentrum",
                    "equipmentid": "108",
                    "inventoryid": "i108",
                    "constructiondate": "2015",
                    "manufacturerserialnumber": "her2314",
                    "memo": "t",
                    "image": {
                        "fileid": "108a58a5-9aec-43df-9591-f8816014d542/108a58a5-9aec-43df-9591-f8816014d543.jpg",
                        "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                        "mimetype": "image/jpeg",
                        "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq108/108a58a5-9aec-43df-9591-f8816014d542/108a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=bfab1690e406a6f7fee4871d0aada9d1d7f6966a5fb18f575bf516dd996a7328"
                    },
                    "nodeid": "247fn://247uptime.io/abc-eq108",
                    "hasmaintenancetask": [
                        {
                            "maintenancetask": {
                                "title": "test cost 22",
                                "description": null,
                                "reminder": "1w",
                                "repetitioninterval": "6m",
                                "startingfrom": 1706227200000,
                                "specifier": null,
                                "created": 0,
                                "nodeid": "247fn://247uptime.io/7c2a49ba-6f19-4e97-a61d-b253c475fac5",
                                "hascategory": [
                                    {
                                        "maintenancecategory": {
                                            "name": "Kundendienst",
                                            "colorcode": "#e36a0e",
                                            "nodeid": "247fn://247uptime.io/abc-maintenancecategory3"
                                        }
                                    }
                                ]
                            }
                        }
                    ],
                    "hasnotification": [
                        {
                            "notification": {
                                "created": 1706278552820,
                                "progressstarted": 0,
                                "closed": 0,
                                "status": 0,
                                "type": 6,
                                "title": "test cost 22",
                                "description": "",
                                "nodeid": "247fn://247uptime.io/301cfe24-7402-49de-95bc-7b69c469dd36"
                            }
                        }
                    ],
                    "hasequipmenttype": [
                        {
                            "equipmenttype": {
                                "model": "C 400",
                                "nodeid": "247fn://247uptime.io/96f02979-e47d-42a9-9be6-6985c0cac1b3",
                                "isequipmenttypeof": [
                                    {
                                        "brand": {
                                            "name": "Hedelius",
                                            "nodeid": "247fn://247uptime.io/994010e1-4167-4703-82a5-630040b548d6"
                                        }
                                    }
                                ],
                                "hasequipmentclass": [
                                    {
                                        "equipmentclass": {
                                            "name": "Drehmaschine",
                                            "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                        }
                                    }
                                ]
                            }
                        }
                    ]
                }
            },
            {
                "equipment": {
                    "name": "Deckelbearbeitung 1",
                    "equipmentid": "105",
                    "inventoryid": "i105",
                    "constructiondate": "2019",
                    "manufacturerserialnumber": "hell12345",
                    "memo": "",
                    "image": {
                        "fileid": "105a58a5-9aec-43df-9591-f8816014d542/105a58a5-9aec-43df-9591-f8816014d543.jpg",
                        "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                        "mimetype": "image/jpeg",
                        "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq105/105a58a5-9aec-43df-9591-f8816014d542/105a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=29e1eb13e8e34f12c2bd91dea7bb5b872d4a0ec0c16b93775988b11089b148e0"
                    },
                    "nodeid": "247fn://247uptime.io/abc-eq105",
                    "hasequipmenttype": [
                        {
                            "equipmenttype": {
                                "model": "H2000",
                                "nodeid": "247fn://247uptime.io/74c53868-a29e-45e5-b0ef-a7441c60d787",
                                "isequipmenttypeof": [
                                    {
                                        "brand": {
                                            "name": "Heller",
                                            "nodeid": "247fn://247uptime.io/c61cbcf2-b7c9-4365-a1b9-77ccd6f8a3c0"
                                        }
                                    }
                                ],
                                "hasequipmentclass": [
                                    {
                                        "equipmentclass": {
                                            "name": "Drehmaschine",
                                            "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                        }
                                    }
                                ]
                            }
                        }
                    ]
                }
            },
            {
                "equipment": {
                    "name": "Gehäusedeckel",
                    "equipmentid": "106",
                    "inventoryid": "i106",
                    "constructiondate": "2019",
                    "manufacturerserialnumber": "hell98765",
                    "memo": "",
                    "image": {
                        "fileid": "106a58a5-9aec-43df-9591-f8816014d542/106a58a5-9aec-43df-9591-f8816014d543.jpg",
                        "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                        "mimetype": "image/jpeg",
                        "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq106/106a58a5-9aec-43df-9591-f8816014d542/106a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=e78b5614be4fe1232b149df860aa7491cda298f40aa98d7cfcb4f5eed17a46b6"
                    },
                    "nodeid": "247fn://247uptime.io/abc-eq106",
                    "hasequipmenttype": [
                        {
                            "equipmenttype": {
                                "model": "H2000",
                                "nodeid": "247fn://247uptime.io/74c53868-a29e-45e5-b0ef-a7441c60d787",
                                "isequipmenttypeof": [
                                    {
                                        "brand": {
                                            "name": "Heller",
                                            "nodeid": "247fn://247uptime.io/c61cbcf2-b7c9-4365-a1b9-77ccd6f8a3c0"
                                        }
                                    }
                                ],
                                "hasequipmentclass": [
                                    {
                                        "equipmentclass": {
                                            "name": "Drehmaschine",
                                            "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                        }
                                    }
                                ]
                            }
                        }
                    ]
                }
            },
            {
                "equipment": {
                    "name": "Fräsmaschine",
                    "equipmentid": "107",
                    "inventoryid": "i107",
                    "constructiondate": "2017",
                    "manufacturerserialnumber": "Grob54321",
                    "memo": "wird z.Zt. nur Spätschicht genutzt",
                    "image": {
                        "fileid": "107a58a5-9aec-43df-9591-f8816014d542/107a58a5-9aec-43df-9591-f8816014d543.jpg",
                        "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                        "mimetype": "image/jpeg",
                        "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq107/107a58a5-9aec-43df-9591-f8816014d542/107a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=bfc6e9cc701292e0b9e80cec69cc91c3a0840960911c644f5c68c60103b64f0b"
                    },
                    "nodeid": "247fn://247uptime.io/abc-eq107",
                    "hasequipmenttype": [
                        {
                            "equipmenttype": {
                                "model": "G350",
                                "nodeid": "247fn://247uptime.io/58ff6083-739d-4871-88d6-56d52eb97e40",
                                "isequipmenttypeof": [
                                    {
                                        "brand": {
                                            "name": "Grob",
                                            "nodeid": "247fn://247uptime.io/b787211a-80ea-4861-a4c3-efab55106cf0"
                                        }
                                    }
                                ],
                                "hasequipmentclass": [
                                    {
                                        "equipmentclass": {
                                            "name": "Drehmaschine",
                                            "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                        }
                                    }
                                ]
                            }
                        }
                    ]
                }
            },
            {
                "equipment": {
                    "name": "Nachbearbeitung",
                    "equipmentid": "109",
                    "inventoryid": "i109",
                    "constructiondate": "2013",
                    "manufacturerserialnumber": "hed12345",
                    "memo": "zur Nachbarbeit",
                    "image": {
                        "fileid": "109a58a5-9aec-43df-9591-f8816014d542/109a58a5-9aec-43df-9591-f8816014d543.jpg",
                        "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                        "mimetype": "image/jpeg",
                        "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq109/109a58a5-9aec-43df-9591-f8816014d542/109a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=6f976082ff72834a2188dbb56546bb45b9836904cde2e69e7d5307f7d4c7eb6b"
                    },
                    "nodeid": "247fn://247uptime.io/abc-eq109",
                    "hasequipmenttype": [
                        {
                            "equipmenttype": {
                                "model": "Forte 50",
                                "nodeid": "247fn://247uptime.io/7199a3aa-9390-45b5-9c67-c6b998722052",
                                "isequipmenttypeof": [
                                    {
                                        "brand": {
                                            "name": "Hedelius",
                                            "nodeid": "247fn://247uptime.io/994010e1-4167-4703-82a5-630040b548d6"
                                        }
                                    }
                                ],
                                "hasequipmentclass": [
                                    {
                                        "equipmentclass": {
                                            "name": "Drehmaschine",
                                            "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                        }
                                    }
                                ]
                            }
                        }
                    ]
                }
            },
            {
                "equipment": {
                    "name": "Prototypenbau",
                    "equipmentid": "110",
                    "inventoryid": "i110",
                    "constructiondate": "2010",
                    "manufacturerserialnumber": "weil12345",
                    "memo": "ehemals Lehrwerkstadt",
                    "image": {
                        "fileid": "110a58a5-9aec-43df-9591-f8816014d542/110a58a5-9aec-43df-9591-f8816014d543.jpg",
                        "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                        "mimetype": "image/jpeg",
                        "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq110/110a58a5-9aec-43df-9591-f8816014d542/110a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=55c11ef67dd0df4602fa053692da19b183c89a2f5b87410bef756400d0b54887"
                    },
                    "nodeid": "247fn://247uptime.io/abc-eq110",
                    "hasequipmenttype": [
                        {
                            "equipmenttype": {
                                "model": "Condor 81",
                                "nodeid": "247fn://247uptime.io/cc2347d2-8d19-49a2-b72a-0b09db902a82",
                                "isequipmenttypeof": [
                                    {
                                        "brand": {
                                            "name": "Weiler",
                                            "nodeid": "247fn://247uptime.io/6ac947df-48fe-4841-845f-1637e476ad54"
                                        }
                                    }
                                ],
                                "hasequipmentclass": [
                                    {
                                        "equipmentclass": {
                                            "name": "Drehmaschine",
                                            "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                        }
                                    }
                                ]
                            }
                        }
                    ]
                }
            },
            {
                "equipment": {
                    "name": "Kegelradschleifen",
                    "equipmentid": "201",
                    "inventoryid": "i201",
                    "constructiondate": "2013",
                    "manufacturerserialnumber": "Kling12345",
                    "memo": "",
                    "image": {
                        "fileid": "201a58a5-9aec-43df-9591-f8816014d542/201a58a5-9aec-43df-9591-f8816014d543.jpg",
                        "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                        "mimetype": "image/jpeg",
                        "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq201/201a58a5-9aec-43df-9591-f8816014d542/201a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=233f2d02837b5a199c5dc5bc7de812d8fc84af7f006763424b16dc33daa11b6e"
                    },
                    "nodeid": "247fn://247uptime.io/abc-eq201",
                    "hasequipmenttype": [
                        {
                            "equipmenttype": {
                                "model": "WNC 80",
                                "nodeid": "247fn://247uptime.io/8dc7ec1b-f5fa-4548-8dee-b85d4a68c07d",
                                "isequipmenttypeof": [
                                    {
                                        "brand": {
                                            "name": "Klingelnberg",
                                            "nodeid": "247fn://247uptime.io/30da53b9-9580-4763-aa4e-f7aefe83c8f7"
                                        }
                                    }
                                ],
                                "hasequipmentclass": [
                                    {
                                        "equipmentclass": {
                                            "name": "Drehmaschine",
                                            "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                        }
                                    }
                                ]
                            }
                        }
                    ]
                }
            },
            {
                "equipment": {
                    "name": "Zahnradfräsen",
                    "equipmentid": "202",
                    "inventoryid": "i202",
                    "constructiondate": "2012",
                    "manufacturerserialnumber": "Lieb123456",
                    "memo": "",
                    "image": {
                        "fileid": "202a58a5-9aec-43df-9591-f8816014d542/202a58a5-9aec-43df-9591-f8816014d543.jpg",
                        "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                        "mimetype": "image/jpeg",
                        "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq202/202a58a5-9aec-43df-9591-f8816014d542/202a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=1014c27613e091be616e5069188f42505bf520ea78558d379152b1ffec556ff6"
                    },
                    "nodeid": "247fn://247uptime.io/abc-eq202",
                    "hasequipmenttype": [
                        {
                            "equipmenttype": {
                                "model": "LC502",
                                "nodeid": "247fn://247uptime.io/259b5267-3cd7-4b32-9e21-1959b0522888",
                                "isequipmenttypeof": [
                                    {
                                        "brand": {
                                            "name": "Liebherr",
                                            "nodeid": "247fn://247uptime.io/1569942f-e445-4571-b75e-4da84e5fb993"
                                        }
                                    }
                                ],
                                "hasequipmentclass": [
                                    {
                                        "equipmentclass": {
                                            "name": "Drehmaschine",
                                            "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                        }
                                    }
                                ]
                            }
                        }
                    ]
                }
            },
            {
                "equipment": {
                    "name": "Kegelradfräsen",
                    "equipmentid": "203",
                    "inventoryid": "i203",
                    "constructiondate": "2002",
                    "manufacturerserialnumber": "gle1234567",
                    "memo": "",
                    "image": {
                        "fileid": "203a58a5-9aec-43df-9591-f8816014d542/203a58a5-9aec-43df-9591-f8816014d543.jpg",
                        "fileversion": "101a58a5-9aec-43df-9591-f8816014d542",
                        "mimetype": "image/jpeg",
                        "url": "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq203/203a58a5-9aec-43df-9591-f8816014d542/203a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111733Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=8f64bd99b0567e97fe568919c0dc0757ad7862243848ef04a912c115460528f4"
                    },
                    "nodeid": "247fn://247uptime.io/abc-eq203",
                    "hasequipmenttype": [
                        {
                            "equipmenttype": {
                                "model": "114",
                                "nodeid": "247fn://247uptime.io/d0ce0d59-d70d-4ccd-8fa4-29358127c201",
                                "isequipmenttypeof": [
                                    {
                                        "brand": {
                                            "name": "Gleason",
                                            "nodeid": "247fn://247uptime.io/2728a232-fe86-4c21-81eb-a47c6651c1e9"
                                        }
                                    }
                                ],
                                "hasequipmentclass": [
                                    {
                                        "equipmentclass": {
                                            "name": "Drehmaschine",
                                            "nodeid": "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39"
                                        }
                                    }
                                ]
                            }
                        }
                    ]
                }
            }
        ]
    }
}`);

const data = [
  {
    notification: {
      created: 1706522889519,
      progressstarted: 0,
      closed: 0,
      dueuntil: 1714348800000,
      status: 0,
      type: 6,
      title: {
        de: "test44",
      },
      description: {
        de: "",
      },
      nodeid: "247fn://247uptime.io/bee6925c-2265-459b-afdd-feae88c5edb0",
      hasmaintenancetask: [
        {
          maintenancetask: {
            nodeid: "247fn://247uptime.io/f16ae4da-14a3-4699-9d2c-dfdf121cb06b",
            hascategory: [
              {
                maintenancecategory: {
                  name: {
                    de: "Kundendienst",
                  },
                  colorcode: "#e36a0e",
                  nodeid: "247fn://247uptime.io/abc-maintenancecategory3",
                },
              },
            ],
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1706522890356,
            title: {},
            description: {},
            nodeid: "247fn://247uptime.io/d67cbc56-258c-48a7-befb-3ed7ac02cc6a",
            hasauthor: [
              {
                user: {
                  givenname: "Robert",
                  middlename: "",
                  surname: "Schuster",
                  email: "robert.schuster@abc.com",
                  mobilephone: "+491761223456",
                  landlinephone: "+49176123456",
                  image: null,
                  nodeid: "247fn://247uptime.io/abc-user1",
                },
              },
            ],
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 1706522890356,
                  title: {},
                  description: {
                    de: "sefs",
                  },
                  nodeid:
                    "247fn://247uptime.io/b6c3c92a-20c0-47aa-9eed-8dd025a96bdb",
                },
              },
            ],
          },
        },
      ],
      haschatroom: [
        {
          chatroom: {
            nodeid: "247fn://247uptime.io/f51d94d0-efa6-4e4c-a581-a0b5136c6b7b",
          },
        },
      ],
      isnotificationof: [
        {
          equipment: {
            name: {
              de: "Nachbearbeitung Drehteile",
              en: "Machine 3",
            },
            nodeid: "247fn://247uptime.io/abc-eq103",
            isequipmentof: [
              {
                equipmentpool: {
                  name: {
                    de: "Zerspanung",
                    en: "Milling machines",
                  },
                  equipmentpoolid: "4711-1",
                  nodeid: "247fn://247uptime.io/abc-equipmentpool1",
                },
              },
              {
                area: {
                  name: {
                    de: "Gehäusefertigung",
                    en: "Housing Production",
                  },
                  areaid: "DEMUCWZB",
                  nodeid: "247fn://247uptime.io/abc-area1",
                  isareaof: [
                    {
                      site: {
                        name: {
                          de: "Werk 1",
                          en: "Site 1",
                        },
                        city: {
                          de: "Manching",
                          en: "Manching",
                        },
                        zipcode: "89312",
                        street: "Am Flugplatz",
                        streetnumber: "42",
                        siteid: "DEMUC1",
                        nodeid: "247fn://247uptime.io/abc-site1",
                      },
                    },
                  ],
                },
              },
            ],
            hasequipmenttype: [
              {
                equipmenttype: {
                  model: "Hyperturn 65",
                  nodeid:
                    "247fn://247uptime.io/06d58ae8-274d-420f-b063-d3dd85533105",
                  hasequipmentclass: [
                    {
                      equipmentclass: {
                        name: {
                          de: "Drehmaschine",
                        },
                        nodeid:
                          "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39",
                      },
                    },
                  ],
                  isequipmenttypeof: [
                    {
                      brand: {
                        name: "Emco",
                        nodeid:
                          "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091",
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    notification: {
      created: 1706284661485,
      progressstarted: 1703154984204,
      closed: "2024-01-26T15:59:54.009Z",
      dueuntil: 1721952000000,
      status: 2,
      type: 6,
      title: {
        de: "gema cost test",
      },
      description: {
        de: "",
      },
      nodeid: "247fn://247uptime.io/c82215a2-2484-4652-99e2-80f58d26b5b4",
      hasmaintenancetask: [
        {
          maintenancetask: {
            nodeid: "247fn://247uptime.io/a0650736-4c59-4c5f-ba1e-2d04b8cc7692",
            hascategory: [
              {
                maintenancecategory: {
                  name: {
                    de: "Kundendienst",
                  },
                  colorcode: "#e36a0e",
                  nodeid: "247fn://247uptime.io/abc-maintenancecategory3",
                },
              },
            ],
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1706284661236,
            title: {},
            description: {},
            nodeid: "247fn://247uptime.io/980e8e4d-c3bd-482f-ad85-fb2cf1210504",
            hasauthor: [
              {
                user: {
                  givenname: "Robert",
                  middlename: "",
                  surname: "Schuster",
                  email: "robert.schuster@abc.com",
                  mobilephone: "+491761223456",
                  landlinephone: "+49176123456",
                  image: null,
                  nodeid: "247fn://247uptime.io/abc-user1",
                },
              },
            ],
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 1706284661236,
                  title: {},
                  description: {
                    de: "test",
                  },
                  nodeid:
                    "247fn://247uptime.io/8acefd9f-d491-4e6d-a774-9631832d06a3",
                },
              },
            ],
          },
        },
      ],
      haschatroom: [
        {
          chatroom: {
            nodeid: "247fn://247uptime.io/39c20103-ed29-4f3b-8750-64a5338a3515",
          },
        },
      ],
      isnotificationof: [
        {
          equipment: {
            name: {
              de: "Nachbearbeitung Drehteile",
              en: "Machine 3",
            },
            nodeid: "247fn://247uptime.io/abc-eq103",
            isequipmentof: [
              {
                equipmentpool: {
                  name: {
                    de: "Zerspanung",
                    en: "Milling machines",
                  },
                  equipmentpoolid: "4711-1",
                  nodeid: "247fn://247uptime.io/abc-equipmentpool1",
                },
              },
              {
                area: {
                  name: {
                    de: "Gehäusefertigung",
                    en: "Housing Production",
                  },
                  areaid: "DEMUCWZB",
                  nodeid: "247fn://247uptime.io/abc-area1",
                  isareaof: [
                    {
                      site: {
                        name: {
                          de: "Werk 1",
                          en: "Site 1",
                        },
                        city: {
                          de: "Manching",
                          en: "Manching",
                        },
                        zipcode: "89312",
                        street: "Am Flugplatz",
                        streetnumber: "42",
                        siteid: "DEMUC1",
                        nodeid: "247fn://247uptime.io/abc-site1",
                      },
                    },
                  ],
                },
              },
            ],
            hasequipmenttype: [
              {
                equipmenttype: {
                  model: "Hyperturn 65",
                  nodeid:
                    "247fn://247uptime.io/06d58ae8-274d-420f-b063-d3dd85533105",
                  hasequipmentclass: [
                    {
                      equipmentclass: {
                        name: {
                          de: "Drehmaschine",
                        },
                        nodeid:
                          "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39",
                      },
                    },
                  ],
                  isequipmenttypeof: [
                    {
                      brand: {
                        name: "Emco",
                        nodeid:
                          "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091",
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    notification: {
      created: 1706283912729,
      progressstarted: 1703154984204,
      closed: "2024-01-26T15:46:01.214Z",
      dueuntil: 1721952000000,
      status: 2,
      type: 6,
      title: {
        de: "new last test",
      },
      description: {
        de: "",
      },
      nodeid: "247fn://247uptime.io/4aec7886-580e-47ad-b0c4-acaa28d471dd",
      hasmaintenancetask: [
        {
          maintenancetask: {
            nodeid: "247fn://247uptime.io/c2671c17-a7ad-4286-a666-24dc4abead0a",
            hascategory: [
              {
                maintenancecategory: {
                  name: {
                    de: "Kundendienst",
                  },
                  colorcode: "#e36a0e",
                  nodeid: "247fn://247uptime.io/abc-maintenancecategory3",
                },
              },
            ],
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1706283912426,
            title: {},
            description: {},
            nodeid: "247fn://247uptime.io/865f33f6-0191-4257-b4cc-d52062429091",
            hasauthor: [
              {
                user: {
                  givenname: "Robert",
                  middlename: "",
                  surname: "Schuster",
                  email: "robert.schuster@abc.com",
                  mobilephone: "+491761223456",
                  landlinephone: "+49176123456",
                  image: null,
                  nodeid: "247fn://247uptime.io/abc-user1",
                },
              },
            ],
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 1706283912426,
                  title: {},
                  description: {
                    de: "test",
                  },
                  nodeid:
                    "247fn://247uptime.io/6500bf5e-75bb-4b28-908e-4950af94a89b",
                },
              },
            ],
          },
        },
      ],
      haschatroom: [
        {
          chatroom: {
            nodeid: "247fn://247uptime.io/208bce79-30c0-4c4e-ab7f-ccec1f99eb91",
          },
        },
      ],
      isnotificationof: [
        {
          equipment: {
            name: {
              de: "Nachbearbeitung Drehteile",
              en: "Machine 3",
            },
            nodeid: "247fn://247uptime.io/abc-eq103",
            isequipmentof: [
              {
                equipmentpool: {
                  name: {
                    de: "Zerspanung",
                    en: "Milling machines",
                  },
                  equipmentpoolid: "4711-1",
                  nodeid: "247fn://247uptime.io/abc-equipmentpool1",
                },
              },
              {
                area: {
                  name: {
                    de: "Gehäusefertigung",
                    en: "Housing Production",
                  },
                  areaid: "DEMUCWZB",
                  nodeid: "247fn://247uptime.io/abc-area1",
                  isareaof: [
                    {
                      site: {
                        name: {
                          de: "Werk 1",
                          en: "Site 1",
                        },
                        city: {
                          de: "Manching",
                          en: "Manching",
                        },
                        zipcode: "89312",
                        street: "Am Flugplatz",
                        streetnumber: "42",
                        siteid: "DEMUC1",
                        nodeid: "247fn://247uptime.io/abc-site1",
                      },
                    },
                  ],
                },
              },
            ],
            hasequipmenttype: [
              {
                equipmenttype: {
                  model: "Hyperturn 65",
                  nodeid:
                    "247fn://247uptime.io/06d58ae8-274d-420f-b063-d3dd85533105",
                  hasequipmentclass: [
                    {
                      equipmentclass: {
                        name: {
                          de: "Drehmaschine",
                        },
                        nodeid:
                          "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39",
                      },
                    },
                  ],
                  isequipmenttypeof: [
                    {
                      brand: {
                        name: "Emco",
                        nodeid:
                          "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091",
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    notification: {
      created: 1706283407201,
      progressstarted: 1703154984204,
      closed: "2024-01-26T15:37:26.254Z",
      dueuntil: 1721952000000,
      status: 2,
      type: 6,
      title: {
        de: "test cost 99",
      },
      description: {
        de: "",
      },
      nodeid: "247fn://247uptime.io/1a2644d0-07e1-4d1a-ab7c-d33f98e744f7",
      hasmaintenancetask: [
        {
          maintenancetask: {
            nodeid: "247fn://247uptime.io/cd67678c-f01d-4e74-ac64-5f251179e3c5",
            hascategory: [
              {
                maintenancecategory: {
                  name: {
                    de: "Routinewartung",
                  },
                  colorcode: "#d40ee6",
                  nodeid: "247fn://247uptime.io/abc-maintenancecategory2",
                },
              },
            ],
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1706283406925,
            title: {},
            description: {},
            nodeid: "247fn://247uptime.io/b48a78b9-a945-464b-b81b-5897d4dc32f6",
            hasauthor: [
              {
                user: {
                  givenname: "Robert",
                  middlename: "",
                  surname: "Schuster",
                  email: "robert.schuster@abc.com",
                  mobilephone: "+491761223456",
                  landlinephone: "+49176123456",
                  image: null,
                  nodeid: "247fn://247uptime.io/abc-user1",
                },
              },
            ],
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 1706283406925,
                  title: {},
                  description: {
                    de: "test",
                  },
                  nodeid:
                    "247fn://247uptime.io/c3f5e10a-8979-4d86-a4a9-69a7682af04b",
                },
              },
            ],
          },
        },
      ],
      haschatroom: [
        {
          chatroom: {
            nodeid: "247fn://247uptime.io/84805a87-8aec-4ae2-b1b4-6de47f439510",
          },
        },
      ],
      isnotificationof: [
        {
          equipment: {
            name: {
              de: "5Achs Bearbeitungszentrum",
              en: "Machine 1",
            },
            nodeid: "247fn://247uptime.io/abc-eq101",
            isequipmentof: [
              {
                equipmentpool: {
                  name: {
                    de: "Zerspanung",
                    en: "Milling machines",
                  },
                  equipmentpoolid: "4711-1",
                  nodeid: "247fn://247uptime.io/abc-equipmentpool1",
                },
              },
              {
                area: {
                  name: {
                    de: "Gehäusefertigung",
                    en: "Housing Production",
                  },
                  areaid: "DEMUCWZB",
                  nodeid: "247fn://247uptime.io/abc-area1",
                  isareaof: [
                    {
                      site: {
                        name: {
                          de: "Werk 1",
                          en: "Site 1",
                        },
                        city: {
                          de: "Manching",
                          en: "Manching",
                        },
                        zipcode: "89312",
                        street: "Am Flugplatz",
                        streetnumber: "42",
                        siteid: "DEMUC1",
                        nodeid: "247fn://247uptime.io/abc-site1",
                      },
                    },
                  ],
                },
              },
            ],
            hasequipmenttype: [
              {
                equipmenttype: {
                  model: "DMU 100",
                  nodeid:
                    "247fn://247uptime.io/0b7135e8-56e6-47a5-b891-9e1471d3a2c5",
                  hasequipmentclass: [
                    {
                      equipmentclass: {
                        name: {
                          de: "Drehmaschine",
                        },
                        nodeid:
                          "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39",
                      },
                    },
                  ],
                  isequipmenttypeof: [
                    {
                      brand: {
                        name: "Deckel Maho",
                        nodeid:
                          "247fn://247uptime.io/2132d959-981e-468c-85fa-303ccbce3dd5",
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    notification: {
      created: 1706280641902,
      progressstarted: 1703154984204,
      closed: "2024-01-26T15:35:53.517Z",
      dueuntil: 1721952000000,
      status: 2,
      type: 6,
      title: {
        de: "test cost 8899",
      },
      description: {
        de: "",
      },
      nodeid: "247fn://247uptime.io/718dcf0b-463c-4762-b1c6-1623dcb44798",
      hasmaintenancetask: [
        {
          maintenancetask: {
            nodeid: "247fn://247uptime.io/6d06837a-6ece-49d8-b472-d2c0c8f03922",
            hascategory: [
              {
                maintenancecategory: {
                  name: {
                    de: "Routineinspektion",
                  },
                  colorcode: "#1172d4",
                  nodeid: "247fn://247uptime.io/abc-maintenancecategory1",
                },
              },
            ],
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1706280641728,
            title: {},
            description: {},
            nodeid: "247fn://247uptime.io/beeef351-173e-44a6-8e33-af1393353c47",
            hasauthor: [
              {
                user: {
                  givenname: "Robert",
                  middlename: "",
                  surname: "Schuster",
                  email: "robert.schuster@abc.com",
                  mobilephone: "+491761223456",
                  landlinephone: "+49176123456",
                  image: null,
                  nodeid: "247fn://247uptime.io/abc-user1",
                },
              },
            ],
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 1706280641728,
                  title: {},
                  description: {
                    de: "testing cost",
                  },
                  nodeid:
                    "247fn://247uptime.io/49d4386e-bd73-4d17-8e44-d1c75df18438",
                },
              },
            ],
          },
        },
      ],
      haschatroom: [
        {
          chatroom: {
            nodeid: "247fn://247uptime.io/828eb4ae-d049-4654-87e4-fd389859c91a",
          },
        },
      ],
      isnotificationof: [
        {
          equipment: {
            name: {
              de: "5Achs Bearbeitungszentrum",
              en: "Machine 2",
            },
            nodeid: "247fn://247uptime.io/abc-eq102",
            isequipmentof: [
              {
                equipmentpool: {
                  name: {
                    de: "Zerspanung",
                    en: "Milling machines",
                  },
                  equipmentpoolid: "4711-1",
                  nodeid: "247fn://247uptime.io/abc-equipmentpool1",
                },
              },
              {
                area: {
                  name: {
                    de: "Gehäusefertigung",
                    en: "Housing Production",
                  },
                  areaid: "DEMUCWZB",
                  nodeid: "247fn://247uptime.io/abc-area1",
                  isareaof: [
                    {
                      site: {
                        name: {
                          de: "Werk 1",
                          en: "Site 1",
                        },
                        city: {
                          de: "Manching",
                          en: "Manching",
                        },
                        zipcode: "89312",
                        street: "Am Flugplatz",
                        streetnumber: "42",
                        siteid: "DEMUC1",
                        nodeid: "247fn://247uptime.io/abc-site1",
                      },
                    },
                  ],
                },
              },
            ],
            hasequipmenttype: [
              {
                equipmenttype: {
                  model: "DMU 70",
                  nodeid:
                    "247fn://247uptime.io/3a4ddeaa-83a5-4d58-a9e1-69fd7f3f102f",
                  hasequipmentclass: [
                    {
                      equipmentclass: {
                        name: {
                          de: "Drehmaschine",
                        },
                        nodeid:
                          "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39",
                      },
                    },
                  ],
                  isequipmenttypeof: [
                    {
                      brand: {
                        name: "Deckel Maho",
                        nodeid:
                          "247fn://247uptime.io/2132d959-981e-468c-85fa-303ccbce3dd5",
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    notification: {
      created: 1706279170122,
      progressstarted: 1703154984204,
      closed: "2024-01-26T14:43:04.588Z",
      dueuntil: 1721952000000,
      status: 2,
      type: 6,
      title: {
        de: "testing new costs",
      },
      description: {
        de: "",
      },
      nodeid: "247fn://247uptime.io/53b7eb04-7ea2-4ee7-a306-7e1b906ce00b",
      hasmaintenancetask: [
        {
          maintenancetask: {
            nodeid: "247fn://247uptime.io/3f4ef7e7-d161-46a5-ac2f-4506eab07968",
            hascategory: [
              {
                maintenancecategory: {
                  name: {
                    de: "Routinewartung",
                  },
                  colorcode: "#d40ee6",
                  nodeid: "247fn://247uptime.io/abc-maintenancecategory2",
                },
              },
            ],
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1706279169825,
            title: {},
            description: {},
            nodeid: "247fn://247uptime.io/a48b9e9c-4377-4c5a-80c6-8b4528919e33",
            hasauthor: [
              {
                user: {
                  givenname: "Robert",
                  middlename: "",
                  surname: "Schuster",
                  email: "robert.schuster@abc.com",
                  mobilephone: "+491761223456",
                  landlinephone: "+49176123456",
                  image: null,
                  nodeid: "247fn://247uptime.io/abc-user1",
                },
              },
            ],
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 1706279169825,
                  title: {},
                  description: {
                    de: "test",
                  },
                  nodeid:
                    "247fn://247uptime.io/fcc6da33-ecfd-4415-904e-b97085c35fbe",
                },
              },
            ],
          },
        },
      ],
      haschatroom: [
        {
          chatroom: {
            nodeid: "247fn://247uptime.io/2d1e359b-e2d3-4dc4-a7d0-ab4a11a97205",
          },
        },
      ],
      isnotificationof: [
        {
          equipment: {
            name: {
              de: "Nachbearbeitung Drehteile",
              en: "Machine 3",
            },
            nodeid: "247fn://247uptime.io/abc-eq103",
            isequipmentof: [
              {
                equipmentpool: {
                  name: {
                    de: "Zerspanung",
                    en: "Milling machines",
                  },
                  equipmentpoolid: "4711-1",
                  nodeid: "247fn://247uptime.io/abc-equipmentpool1",
                },
              },
              {
                area: {
                  name: {
                    de: "Gehäusefertigung",
                    en: "Housing Production",
                  },
                  areaid: "DEMUCWZB",
                  nodeid: "247fn://247uptime.io/abc-area1",
                  isareaof: [
                    {
                      site: {
                        name: {
                          de: "Werk 1",
                          en: "Site 1",
                        },
                        city: {
                          de: "Manching",
                          en: "Manching",
                        },
                        zipcode: "89312",
                        street: "Am Flugplatz",
                        streetnumber: "42",
                        siteid: "DEMUC1",
                        nodeid: "247fn://247uptime.io/abc-site1",
                      },
                    },
                  ],
                },
              },
            ],
            hasequipmenttype: [
              {
                equipmenttype: {
                  model: "Hyperturn 65",
                  nodeid:
                    "247fn://247uptime.io/06d58ae8-274d-420f-b063-d3dd85533105",
                  hasequipmentclass: [
                    {
                      equipmentclass: {
                        name: {
                          de: "Drehmaschine",
                        },
                        nodeid:
                          "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39",
                      },
                    },
                  ],
                  isequipmenttypeof: [
                    {
                      brand: {
                        name: "Emco",
                        nodeid:
                          "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091",
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    notification: {
      created: 1706278552820,
      progressstarted: 0,
      closed: 0,
      dueuntil: 1721952000000,
      status: 0,
      type: 6,
      title: {
        de: "test cost 22",
      },
      description: {
        de: "",
      },
      nodeid: "247fn://247uptime.io/301cfe24-7402-49de-95bc-7b69c469dd36",
      hasmaintenancetask: [
        {
          maintenancetask: {
            nodeid: "247fn://247uptime.io/7c2a49ba-6f19-4e97-a61d-b253c475fac5",
            hascategory: [
              {
                maintenancecategory: {
                  name: {
                    de: "Kundendienst",
                  },
                  colorcode: "#e36a0e",
                  nodeid: "247fn://247uptime.io/abc-maintenancecategory3",
                },
              },
            ],
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1706278552575,
            title: {},
            description: {},
            nodeid: "247fn://247uptime.io/9c992fb9-744d-482f-ab57-b27099919c3f",
            hasauthor: [
              {
                user: {
                  givenname: "Robert",
                  middlename: "",
                  surname: "Schuster",
                  email: "robert.schuster@abc.com",
                  mobilephone: "+491761223456",
                  landlinephone: "+49176123456",
                  image: null,
                  nodeid: "247fn://247uptime.io/abc-user1",
                },
              },
            ],
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 1706278552575,
                  title: {},
                  description: {
                    de: "testing....",
                  },
                  nodeid:
                    "247fn://247uptime.io/8586b8c0-467c-4cf6-809c-2a9f06935038",
                },
              },
            ],
          },
        },
      ],
      haschatroom: [
        {
          chatroom: {
            nodeid: "247fn://247uptime.io/e64dd691-3bd3-4d5f-929d-26a1c1a85486",
          },
        },
      ],
      isnotificationof: [
        {
          equipment: {
            name: {
              de: "Bearbeitungszentrum",
              en: "Machine 3",
            },
            nodeid: "247fn://247uptime.io/abc-eq108",
            isequipmentof: [
              {
                equipmentpool: {
                  name: {
                    de: "Zerspanung",
                    en: "Milling machines",
                  },
                  equipmentpoolid: "4711-1",
                  nodeid: "247fn://247uptime.io/abc-equipmentpool1",
                },
              },
              {
                area: {
                  name: {
                    de: "Gehäusefertigung",
                    en: "Housing Production",
                  },
                  areaid: "DEMUCWZB",
                  nodeid: "247fn://247uptime.io/abc-area1",
                  isareaof: [
                    {
                      site: {
                        name: {
                          de: "Werk 1",
                          en: "Site 1",
                        },
                        city: {
                          de: "Manching",
                          en: "Manching",
                        },
                        zipcode: "89312",
                        street: "Am Flugplatz",
                        streetnumber: "42",
                        siteid: "DEMUC1",
                        nodeid: "247fn://247uptime.io/abc-site1",
                      },
                    },
                  ],
                },
              },
            ],
            hasequipmenttype: [
              {
                equipmenttype: {
                  model: "C 400",
                  nodeid:
                    "247fn://247uptime.io/96f02979-e47d-42a9-9be6-6985c0cac1b3",
                  hasequipmentclass: [
                    {
                      equipmentclass: {
                        name: {
                          de: "Drehmaschine",
                        },
                        nodeid:
                          "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39",
                      },
                    },
                  ],
                  isequipmenttypeof: [
                    {
                      brand: {
                        name: "Hedelius",
                        nodeid:
                          "247fn://247uptime.io/994010e1-4167-4703-82a5-630040b548d6",
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    notification: {
      created: 1706269518815,
      progressstarted: 1703154984204,
      closed: "2024-01-26T11:46:35.531Z",
      dueuntil: 1737849600000,
      status: 2,
      type: 6,
      title: {
        de: "new cost testing 2",
      },
      description: {
        de: "",
      },
      nodeid: "247fn://247uptime.io/f8845d8f-b57d-46a8-beb7-cf29e6351068",
      hasmaintenancetask: [
        {
          maintenancetask: {
            nodeid: "247fn://247uptime.io/7c08cca6-e985-415a-8403-5b88c6d6342e",
            hascategory: [
              {
                maintenancecategory: {
                  name: {
                    de: "Routinewartung",
                  },
                  colorcode: "#d40ee6",
                  nodeid: "247fn://247uptime.io/abc-maintenancecategory2",
                },
              },
            ],
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1706269518551,
            title: {},
            description: {},
            nodeid: "247fn://247uptime.io/02ba9b89-b097-46be-8165-eb78952f38ff",
            hasauthor: [
              {
                user: {
                  givenname: "Robert",
                  middlename: "",
                  surname: "Schuster",
                  email: "robert.schuster@abc.com",
                  mobilephone: "+491761223456",
                  landlinephone: "+49176123456",
                  image: null,
                  nodeid: "247fn://247uptime.io/abc-user1",
                },
              },
            ],
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 1706269518551,
                  title: {},
                  description: {
                    de: "test",
                  },
                  nodeid:
                    "247fn://247uptime.io/14fc7483-adf4-4b84-b358-7f5b36fb7acc",
                },
              },
            ],
          },
        },
      ],
      haschatroom: [
        {
          chatroom: {
            nodeid: "247fn://247uptime.io/fa70fd58-a944-4d9b-a663-5f8cca8b9042",
          },
        },
      ],
      isnotificationof: [
        {
          equipment: {
            name: {
              de: "Bolzenbearbeitung",
              en: "Machine 4",
            },
            nodeid: "247fn://247uptime.io/abc-eq104",
            isequipmentof: [
              {
                equipmentpool: {
                  name: {
                    de: "Zerspanung",
                    en: "Milling machines",
                  },
                  equipmentpoolid: "4711-1",
                  nodeid: "247fn://247uptime.io/abc-equipmentpool1",
                },
              },
              {
                area: {
                  name: {
                    de: "Gehäusefertigung",
                    en: "Housing Production",
                  },
                  areaid: "DEMUCWZB",
                  nodeid: "247fn://247uptime.io/abc-area1",
                  isareaof: [
                    {
                      site: {
                        name: {
                          de: "Werk 1",
                          en: "Site 1",
                        },
                        city: {
                          de: "Manching",
                          en: "Manching",
                        },
                        zipcode: "89312",
                        street: "Am Flugplatz",
                        streetnumber: "42",
                        siteid: "DEMUC1",
                        nodeid: "247fn://247uptime.io/abc-site1",
                      },
                    },
                  ],
                },
              },
            ],
            hasequipmenttype: [
              {
                equipmenttype: {
                  model: "Hyperturn 45",
                  nodeid:
                    "247fn://247uptime.io/a7cea051-d8d5-4a48-8b8f-795fcb6519b5",
                  hasequipmentclass: [
                    {
                      equipmentclass: {
                        name: {
                          de: "Drehmaschine",
                        },
                        nodeid:
                          "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39",
                      },
                    },
                  ],
                  isequipmenttypeof: [
                    {
                      brand: {
                        name: "Emco",
                        nodeid:
                          "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091",
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    notification: {
      created: 1706269125924,
      progressstarted: 1703154984204,
      closed: "2024-01-26T11:40:33.709Z",
      dueuntil: 1721952000000,
      status: 2,
      type: 6,
      title: {
        de: "new cost testing 1",
      },
      description: {
        de: "",
      },
      nodeid: "247fn://247uptime.io/207de920-08d4-4715-9a67-58e981874bbd",
      hasmaintenancetask: [
        {
          maintenancetask: {
            nodeid: "247fn://247uptime.io/c000677b-76fd-4320-bce7-23b6b6cf6f16",
            hascategory: [
              {
                maintenancecategory: {
                  name: {
                    de: "Kundendienst",
                  },
                  colorcode: "#e36a0e",
                  nodeid: "247fn://247uptime.io/abc-maintenancecategory3",
                },
              },
            ],
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1706269125632,
            title: {},
            description: {},
            nodeid: "247fn://247uptime.io/53aa5069-30dc-4c03-b15d-ea35e42fdd5f",
            hasauthor: [
              {
                user: {
                  givenname: "Robert",
                  middlename: "",
                  surname: "Schuster",
                  email: "robert.schuster@abc.com",
                  mobilephone: "+491761223456",
                  landlinephone: "+49176123456",
                  image: null,
                  nodeid: "247fn://247uptime.io/abc-user1",
                },
              },
            ],
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 1706269125632,
                  title: {},
                  description: {
                    de: "test",
                  },
                  nodeid:
                    "247fn://247uptime.io/598ae2c5-d0d0-49d0-a08f-00616f2e0e5b",
                },
              },
            ],
          },
        },
      ],
      haschatroom: [
        {
          chatroom: {
            nodeid: "247fn://247uptime.io/942fafb1-1ac8-42eb-88f8-f009a6ce7838",
          },
        },
      ],
      isnotificationof: [
        {
          equipment: {
            name: {
              de: "Bolzenbearbeitung",
              en: "Machine 4",
            },
            nodeid: "247fn://247uptime.io/abc-eq104",
            isequipmentof: [
              {
                equipmentpool: {
                  name: {
                    de: "Zerspanung",
                    en: "Milling machines",
                  },
                  equipmentpoolid: "4711-1",
                  nodeid: "247fn://247uptime.io/abc-equipmentpool1",
                },
              },
              {
                area: {
                  name: {
                    de: "Gehäusefertigung",
                    en: "Housing Production",
                  },
                  areaid: "DEMUCWZB",
                  nodeid: "247fn://247uptime.io/abc-area1",
                  isareaof: [
                    {
                      site: {
                        name: {
                          de: "Werk 1",
                          en: "Site 1",
                        },
                        city: {
                          de: "Manching",
                          en: "Manching",
                        },
                        zipcode: "89312",
                        street: "Am Flugplatz",
                        streetnumber: "42",
                        siteid: "DEMUC1",
                        nodeid: "247fn://247uptime.io/abc-site1",
                      },
                    },
                  ],
                },
              },
            ],
            hasequipmenttype: [
              {
                equipmenttype: {
                  model: "Hyperturn 45",
                  nodeid:
                    "247fn://247uptime.io/a7cea051-d8d5-4a48-8b8f-795fcb6519b5",
                  hasequipmentclass: [
                    {
                      equipmentclass: {
                        name: {
                          de: "Drehmaschine",
                        },
                        nodeid:
                          "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39",
                      },
                    },
                  ],
                  isequipmenttypeof: [
                    {
                      brand: {
                        name: "Emco",
                        nodeid:
                          "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091",
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    notification: {
      created: 1706268522473,
      progressstarted: 1703154984204,
      closed: "2024-01-26T11:29:53.202Z",
      dueuntil: 1721952000000,
      status: 2,
      type: 6,
      title: {
        de: "testing cost value",
      },
      description: {
        de: "",
      },
      nodeid: "247fn://247uptime.io/ffb861f6-5ea4-4d9e-a570-f7e7e34df7b8",
      hasmaintenancetask: [
        {
          maintenancetask: {
            nodeid: "247fn://247uptime.io/924c6953-61f8-4ff7-8168-d5977e5e46c7",
            hascategory: [
              {
                maintenancecategory: {
                  name: {
                    de: "Kundendienst",
                  },
                  colorcode: "#e36a0e",
                  nodeid: "247fn://247uptime.io/abc-maintenancecategory3",
                },
              },
            ],
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1706268522200,
            title: {},
            description: {},
            nodeid: "247fn://247uptime.io/9157e827-036f-4d87-a4e3-afd52695f0fc",
            hasauthor: [
              {
                user: {
                  givenname: "Robert",
                  middlename: "",
                  surname: "Schuster",
                  email: "robert.schuster@abc.com",
                  mobilephone: "+491761223456",
                  landlinephone: "+49176123456",
                  image: null,
                  nodeid: "247fn://247uptime.io/abc-user1",
                },
              },
            ],
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 1706268522200,
                  title: {},
                  description: {
                    de: "test description...",
                  },
                  nodeid:
                    "247fn://247uptime.io/6699259d-35a2-430b-8ae5-9e2ab5bdfdc4",
                },
              },
            ],
          },
        },
      ],
      haschatroom: [
        {
          chatroom: {
            nodeid: "247fn://247uptime.io/7174be83-e09e-4a0c-bf82-52552e35814d",
          },
        },
      ],
      isnotificationof: [
        {
          equipment: {
            name: {
              de: "5Achs Bearbeitungszentrum",
              en: "Machine 1",
            },
            nodeid: "247fn://247uptime.io/abc-eq101",
            isequipmentof: [
              {
                equipmentpool: {
                  name: {
                    de: "Zerspanung",
                    en: "Milling machines",
                  },
                  equipmentpoolid: "4711-1",
                  nodeid: "247fn://247uptime.io/abc-equipmentpool1",
                },
              },
              {
                area: {
                  name: {
                    de: "Gehäusefertigung",
                    en: "Housing Production",
                  },
                  areaid: "DEMUCWZB",
                  nodeid: "247fn://247uptime.io/abc-area1",
                  isareaof: [
                    {
                      site: {
                        name: {
                          de: "Werk 1",
                          en: "Site 1",
                        },
                        city: {
                          de: "Manching",
                          en: "Manching",
                        },
                        zipcode: "89312",
                        street: "Am Flugplatz",
                        streetnumber: "42",
                        siteid: "DEMUC1",
                        nodeid: "247fn://247uptime.io/abc-site1",
                      },
                    },
                  ],
                },
              },
            ],
            hasequipmenttype: [
              {
                equipmenttype: {
                  model: "DMU 100",
                  nodeid:
                    "247fn://247uptime.io/0b7135e8-56e6-47a5-b891-9e1471d3a2c5",
                  hasequipmentclass: [
                    {
                      equipmentclass: {
                        name: {
                          de: "Drehmaschine",
                        },
                        nodeid:
                          "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39",
                      },
                    },
                  ],
                  isequipmenttypeof: [
                    {
                      brand: {
                        name: "Deckel Maho",
                        nodeid:
                          "247fn://247uptime.io/2132d959-981e-468c-85fa-303ccbce3dd5",
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    notification: {
      created: 1706267903453,
      progressstarted: 1703154984204,
      closed: "2024-01-26T11:22:32.343Z",
      dueuntil: 1721952000000,
      status: 2,
      type: 6,
      title: {
        de: "test alpha 11222",
      },
      description: {
        de: "",
      },
      nodeid: "247fn://247uptime.io/3416ce81-faa2-472d-8823-589123efcf58",
      hasmaintenancetask: [
        {
          maintenancetask: {
            nodeid: "247fn://247uptime.io/f03e9745-c530-4ed8-b09f-0bfa3f741a89",
            hascategory: [
              {
                maintenancecategory: {
                  name: {
                    de: "Routineinspektion",
                  },
                  colorcode: "#1172d4",
                  nodeid: "247fn://247uptime.io/abc-maintenancecategory1",
                },
              },
            ],
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1706267903174,
            title: {},
            description: {},
            nodeid: "247fn://247uptime.io/328c01c6-665a-4412-82c8-fdfaac25fa54",
            hasauthor: [
              {
                user: {
                  givenname: "Robert",
                  middlename: "",
                  surname: "Schuster",
                  email: "robert.schuster@abc.com",
                  mobilephone: "+491761223456",
                  landlinephone: "+49176123456",
                  image: null,
                  nodeid: "247fn://247uptime.io/abc-user1",
                },
              },
            ],
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 1706267903174,
                  title: {},
                  description: {
                    de: "test attachment...",
                  },
                  nodeid:
                    "247fn://247uptime.io/5954d81f-efac-462f-b6d4-8ce05143396c",
                },
              },
            ],
          },
        },
      ],
      haschatroom: [
        {
          chatroom: {
            nodeid: "247fn://247uptime.io/20f3f885-cbc7-4e75-95dd-10b2db82529e",
          },
        },
      ],
      isnotificationof: [
        {
          equipment: {
            name: {
              de: "Nachbearbeitung Drehteile",
              en: "Machine 3",
            },
            nodeid: "247fn://247uptime.io/abc-eq103",
            isequipmentof: [
              {
                equipmentpool: {
                  name: {
                    de: "Zerspanung",
                    en: "Milling machines",
                  },
                  equipmentpoolid: "4711-1",
                  nodeid: "247fn://247uptime.io/abc-equipmentpool1",
                },
              },
              {
                area: {
                  name: {
                    de: "Gehäusefertigung",
                    en: "Housing Production",
                  },
                  areaid: "DEMUCWZB",
                  nodeid: "247fn://247uptime.io/abc-area1",
                  isareaof: [
                    {
                      site: {
                        name: {
                          de: "Werk 1",
                          en: "Site 1",
                        },
                        city: {
                          de: "Manching",
                          en: "Manching",
                        },
                        zipcode: "89312",
                        street: "Am Flugplatz",
                        streetnumber: "42",
                        siteid: "DEMUC1",
                        nodeid: "247fn://247uptime.io/abc-site1",
                      },
                    },
                  ],
                },
              },
            ],
            hasequipmenttype: [
              {
                equipmenttype: {
                  model: "Hyperturn 65",
                  nodeid:
                    "247fn://247uptime.io/06d58ae8-274d-420f-b063-d3dd85533105",
                  hasequipmentclass: [
                    {
                      equipmentclass: {
                        name: {
                          de: "Drehmaschine",
                        },
                        nodeid:
                          "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39",
                      },
                    },
                  ],
                  isequipmenttypeof: [
                    {
                      brand: {
                        name: "Emco",
                        nodeid:
                          "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091",
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    notification: {
      created: 1706058000030,
      progressstarted: 1703154984204,
      closed: "2024-01-26T10:34:42.779Z",
      dueuntil: 1713830400000,
      status: 2,
      type: 6,
      title: {
        de: "test maintenance tasks",
      },
      description: {
        de: "",
      },
      nodeid: "247fn://247uptime.io/051abaf8-7166-4cce-af73-c18f09be7b55",
      hasmaintenancetask: [
        {
          maintenancetask: {
            nodeid: "247fn://247uptime.io/599b98ec-57b4-42fe-92b8-0437a00f2e8b",
            hascategory: [
              {
                maintenancecategory: {
                  name: {
                    de: "Kundendienst",
                  },
                  colorcode: "#e36a0e",
                  nodeid: "247fn://247uptime.io/abc-maintenancecategory3",
                },
              },
            ],
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1705577436036,
            title: {},
            description: {},
            nodeid: "247fn://247uptime.io/0611fa9c-c152-4cbe-ae87-ba2a0e5ac0c5",
            hasauthor: [
              {
                user: {
                  givenname: "Robert",
                  middlename: "",
                  surname: "Schuster",
                  email: "robert.schuster@abc.com",
                  mobilephone: "+491761223456",
                  landlinephone: "+49176123456",
                  image: null,
                  nodeid: "247fn://247uptime.io/abc-user1",
                },
              },
            ],
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 1705577436036,
                  title: {},
                  description: {
                    de: "dsfsdf",
                  },
                  nodeid:
                    "247fn://247uptime.io/d54406cf-e12a-4f9e-a4a1-8a8c4b28a8b0",
                },
              },
            ],
          },
        },
      ],
      haschatroom: [
        {
          chatroom: {
            nodeid: "247fn://247uptime.io/f38319c1-b7fb-48ae-b9af-47c86a53f347",
          },
        },
      ],
      isnotificationof: [
        {
          equipment: {
            name: {
              de: "Nachbearbeitung Drehteile",
              en: "Machine 3",
            },
            nodeid: "247fn://247uptime.io/abc-eq103",
            isequipmentof: [
              {
                equipmentpool: {
                  name: {
                    de: "Zerspanung",
                    en: "Milling machines",
                  },
                  equipmentpoolid: "4711-1",
                  nodeid: "247fn://247uptime.io/abc-equipmentpool1",
                },
              },
              {
                area: {
                  name: {
                    de: "Gehäusefertigung",
                    en: "Housing Production",
                  },
                  areaid: "DEMUCWZB",
                  nodeid: "247fn://247uptime.io/abc-area1",
                  isareaof: [
                    {
                      site: {
                        name: {
                          de: "Werk 1",
                          en: "Site 1",
                        },
                        city: {
                          de: "Manching",
                          en: "Manching",
                        },
                        zipcode: "89312",
                        street: "Am Flugplatz",
                        streetnumber: "42",
                        siteid: "DEMUC1",
                        nodeid: "247fn://247uptime.io/abc-site1",
                      },
                    },
                  ],
                },
              },
            ],
            hasequipmenttype: [
              {
                equipmenttype: {
                  model: "Hyperturn 65",
                  nodeid:
                    "247fn://247uptime.io/06d58ae8-274d-420f-b063-d3dd85533105",
                  hasequipmentclass: [
                    {
                      equipmentclass: {
                        name: {
                          de: "Drehmaschine",
                        },
                        nodeid:
                          "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39",
                      },
                    },
                  ],
                  isequipmenttypeof: [
                    {
                      brand: {
                        name: "Emco",
                        nodeid:
                          "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091",
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    notification: {
      created: 1705971600075,
      progressstarted: 0,
      closed: 0,
      dueuntil: 1713830400000,
      status: 0,
      type: 6,
      title: {
        de: "test maintenance task",
      },
      description: {
        de: "",
      },
      nodeid: "247fn://247uptime.io/0f606789-9a27-42a0-86be-2ea17562263f",
      hasmaintenancetask: [
        {
          maintenancetask: {
            nodeid: "247fn://247uptime.io/461cedb8-6ed3-42e9-9ad1-3dcaefb9efdd",
            hascategory: [
              {
                maintenancecategory: {
                  name: {
                    de: "Kundendienst",
                  },
                  colorcode: "#e36a0e",
                  nodeid: "247fn://247uptime.io/abc-maintenancecategory3",
                },
              },
            ],
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1705577389401,
            title: {},
            description: {},
            nodeid: "247fn://247uptime.io/a0ce4296-dcbd-4da8-89de-8438ccffe1aa",
            hasauthor: [
              {
                user: {
                  givenname: "Robert",
                  middlename: "",
                  surname: "Schuster",
                  email: "robert.schuster@abc.com",
                  mobilephone: "+491761223456",
                  landlinephone: "+49176123456",
                  image: null,
                  nodeid: "247fn://247uptime.io/abc-user1",
                },
              },
            ],
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 1705577389401,
                  title: {},
                  description: {
                    de: "ssadfsdf",
                  },
                  nodeid:
                    "247fn://247uptime.io/7595457a-a14c-4577-b74b-8ef99a4cbde5",
                },
              },
            ],
          },
        },
      ],
      haschatroom: [
        {
          chatroom: {
            nodeid: "247fn://247uptime.io/cea14bf4-4308-4d3a-b49c-4308b2d7b377",
          },
        },
      ],
      isnotificationof: [
        {
          equipment: {
            name: {
              de: "Nachbearbeitung Drehteile",
              en: "Machine 3",
            },
            nodeid: "247fn://247uptime.io/abc-eq103",
            isequipmentof: [
              {
                equipmentpool: {
                  name: {
                    de: "Zerspanung",
                    en: "Milling machines",
                  },
                  equipmentpoolid: "4711-1",
                  nodeid: "247fn://247uptime.io/abc-equipmentpool1",
                },
              },
              {
                area: {
                  name: {
                    de: "Gehäusefertigung",
                    en: "Housing Production",
                  },
                  areaid: "DEMUCWZB",
                  nodeid: "247fn://247uptime.io/abc-area1",
                  isareaof: [
                    {
                      site: {
                        name: {
                          de: "Werk 1",
                          en: "Site 1",
                        },
                        city: {
                          de: "Manching",
                          en: "Manching",
                        },
                        zipcode: "89312",
                        street: "Am Flugplatz",
                        streetnumber: "42",
                        siteid: "DEMUC1",
                        nodeid: "247fn://247uptime.io/abc-site1",
                      },
                    },
                  ],
                },
              },
            ],
            hasequipmenttype: [
              {
                equipmenttype: {
                  model: "Hyperturn 65",
                  nodeid:
                    "247fn://247uptime.io/06d58ae8-274d-420f-b063-d3dd85533105",
                  hasequipmentclass: [
                    {
                      equipmentclass: {
                        name: {
                          de: "Drehmaschine",
                        },
                        nodeid:
                          "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39",
                      },
                    },
                  ],
                  isequipmenttypeof: [
                    {
                      brand: {
                        name: "Emco",
                        nodeid:
                          "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091",
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    notification: {
      created: 1705577437056,
      progressstarted: 0,
      closed: 0,
      dueuntil: 1705968000000,
      status: 0,
      type: 6,
      title: {
        de: "test maintenance tasks",
      },
      description: {
        de: "",
      },
      nodeid: "247fn://247uptime.io/d3c21b78-64ee-4bc8-9b99-00694864a9f0",
      hasmaintenancetask: [
        {
          maintenancetask: {
            nodeid: "247fn://247uptime.io/599b98ec-57b4-42fe-92b8-0437a00f2e8b",
            hascategory: [
              {
                maintenancecategory: {
                  name: {
                    de: "Kundendienst",
                  },
                  colorcode: "#e36a0e",
                  nodeid: "247fn://247uptime.io/abc-maintenancecategory3",
                },
              },
            ],
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1705577436036,
            title: {},
            description: {},
            nodeid: "247fn://247uptime.io/0611fa9c-c152-4cbe-ae87-ba2a0e5ac0c5",
            hasauthor: [
              {
                user: {
                  givenname: "Robert",
                  middlename: "",
                  surname: "Schuster",
                  email: "robert.schuster@abc.com",
                  mobilephone: "+491761223456",
                  landlinephone: "+49176123456",
                  image: null,
                  nodeid: "247fn://247uptime.io/abc-user1",
                },
              },
            ],
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 1705577436036,
                  title: {},
                  description: {
                    de: "dsfsdf",
                  },
                  nodeid:
                    "247fn://247uptime.io/d54406cf-e12a-4f9e-a4a1-8a8c4b28a8b0",
                },
              },
            ],
          },
        },
      ],
      haschatroom: [
        {
          chatroom: {
            nodeid: "247fn://247uptime.io/c25beb24-beb4-43fd-8ebb-20f08793b7f4",
          },
        },
      ],
      isnotificationof: [
        {
          equipment: {
            name: {
              de: "Nachbearbeitung Drehteile",
              en: "Machine 3",
            },
            nodeid: "247fn://247uptime.io/abc-eq103",
            isequipmentof: [
              {
                equipmentpool: {
                  name: {
                    de: "Zerspanung",
                    en: "Milling machines",
                  },
                  equipmentpoolid: "4711-1",
                  nodeid: "247fn://247uptime.io/abc-equipmentpool1",
                },
              },
              {
                area: {
                  name: {
                    de: "Gehäusefertigung",
                    en: "Housing Production",
                  },
                  areaid: "DEMUCWZB",
                  nodeid: "247fn://247uptime.io/abc-area1",
                  isareaof: [
                    {
                      site: {
                        name: {
                          de: "Werk 1",
                          en: "Site 1",
                        },
                        city: {
                          de: "Manching",
                          en: "Manching",
                        },
                        zipcode: "89312",
                        street: "Am Flugplatz",
                        streetnumber: "42",
                        siteid: "DEMUC1",
                        nodeid: "247fn://247uptime.io/abc-site1",
                      },
                    },
                  ],
                },
              },
            ],
            hasequipmenttype: [
              {
                equipmenttype: {
                  model: "Hyperturn 65",
                  nodeid:
                    "247fn://247uptime.io/06d58ae8-274d-420f-b063-d3dd85533105",
                  hasequipmentclass: [
                    {
                      equipmentclass: {
                        name: {
                          de: "Drehmaschine",
                        },
                        nodeid:
                          "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39",
                      },
                    },
                  ],
                  isequipmenttypeof: [
                    {
                      brand: {
                        name: "Emco",
                        nodeid:
                          "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091",
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    notification: {
      created: 1705577390403,
      progressstarted: 0,
      closed: 0,
      dueuntil: 1705968000000,
      status: 0,
      type: 6,
      title: {
        de: "test maintenance task",
      },
      description: {
        de: "",
      },
      nodeid: "247fn://247uptime.io/bd02a6ae-afb0-4085-aab8-5b6bffd4fea8",
      hasmaintenancetask: [
        {
          maintenancetask: {
            nodeid: "247fn://247uptime.io/461cedb8-6ed3-42e9-9ad1-3dcaefb9efdd",
            hascategory: [
              {
                maintenancecategory: {
                  name: {
                    de: "Kundendienst",
                  },
                  colorcode: "#e36a0e",
                  nodeid: "247fn://247uptime.io/abc-maintenancecategory3",
                },
              },
            ],
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1705577389401,
            title: {},
            description: {},
            nodeid: "247fn://247uptime.io/a0ce4296-dcbd-4da8-89de-8438ccffe1aa",
            hasauthor: [
              {
                user: {
                  givenname: "Robert",
                  middlename: "",
                  surname: "Schuster",
                  email: "robert.schuster@abc.com",
                  mobilephone: "+491761223456",
                  landlinephone: "+49176123456",
                  image: null,
                  nodeid: "247fn://247uptime.io/abc-user1",
                },
              },
            ],
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 1705577389401,
                  title: {},
                  description: {
                    de: "ssadfsdf",
                  },
                  nodeid:
                    "247fn://247uptime.io/7595457a-a14c-4577-b74b-8ef99a4cbde5",
                },
              },
            ],
          },
        },
      ],
      haschatroom: [
        {
          chatroom: {
            nodeid: "247fn://247uptime.io/942834ae-b62e-4089-a9bc-8a682585cadf",
          },
        },
      ],
      isnotificationof: [
        {
          equipment: {
            name: {
              de: "Nachbearbeitung Drehteile",
              en: "Machine 3",
            },
            nodeid: "247fn://247uptime.io/abc-eq103",
            isequipmentof: [
              {
                equipmentpool: {
                  name: {
                    de: "Zerspanung",
                    en: "Milling machines",
                  },
                  equipmentpoolid: "4711-1",
                  nodeid: "247fn://247uptime.io/abc-equipmentpool1",
                },
              },
              {
                area: {
                  name: {
                    de: "Gehäusefertigung",
                    en: "Housing Production",
                  },
                  areaid: "DEMUCWZB",
                  nodeid: "247fn://247uptime.io/abc-area1",
                  isareaof: [
                    {
                      site: {
                        name: {
                          de: "Werk 1",
                          en: "Site 1",
                        },
                        city: {
                          de: "Manching",
                          en: "Manching",
                        },
                        zipcode: "89312",
                        street: "Am Flugplatz",
                        streetnumber: "42",
                        siteid: "DEMUC1",
                        nodeid: "247fn://247uptime.io/abc-site1",
                      },
                    },
                  ],
                },
              },
            ],
            hasequipmenttype: [
              {
                equipmenttype: {
                  model: "Hyperturn 65",
                  nodeid:
                    "247fn://247uptime.io/06d58ae8-274d-420f-b063-d3dd85533105",
                  hasequipmentclass: [
                    {
                      equipmentclass: {
                        name: {
                          de: "Drehmaschine",
                        },
                        nodeid:
                          "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39",
                      },
                    },
                  ],
                  isequipmenttypeof: [
                    {
                      brand: {
                        name: "Emco",
                        nodeid:
                          "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091",
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    notification: {
      created: 1705422122176,
      progressstarted: 0,
      closed: 0,
      dueuntil: 1736985600000,
      status: 0,
      type: 6,
      title: {
        de: "test 2",
      },
      description: {
        de: "",
      },
      nodeid: "247fn://247uptime.io/c1744c58-96a8-487b-a912-d48749a5e4f0",
      hasmaintenancetask: [
        {
          maintenancetask: {
            nodeid: "247fn://247uptime.io/d88a60e9-96b0-46e8-b2bb-93e902315c58",
            hascategory: [
              {
                maintenancecategory: {
                  name: {
                    de: "Kundendienst",
                  },
                  colorcode: "#e36a0e",
                  nodeid: "247fn://247uptime.io/abc-maintenancecategory3",
                },
              },
            ],
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1705422121918,
            title: {},
            description: {},
            nodeid: "247fn://247uptime.io/787fb58b-f8c2-43ae-9cbf-0d001e9e5f41",
            hasauthor: [
              {
                user: {
                  givenname: "Robert",
                  middlename: "",
                  surname: "Schuster",
                  email: "robert.schuster@abc.com",
                  mobilephone: "+491761223456",
                  landlinephone: "+49176123456",
                  image: null,
                  nodeid: "247fn://247uptime.io/abc-user1",
                },
              },
            ],
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 1705422121918,
                  title: {},
                  description: {
                    de: "test1111",
                  },
                  nodeid:
                    "247fn://247uptime.io/6751ae9b-743b-432a-bce2-4a5fe6e37699",
                },
              },
            ],
          },
        },
      ],
      haschatroom: [
        {
          chatroom: {
            nodeid: "247fn://247uptime.io/687e3f62-9da7-4ea8-b7c4-e5eb715b0a58",
          },
        },
      ],
      isnotificationof: [
        {
          equipment: {
            name: {
              de: "Nachbearbeitung Drehteile",
              en: "Machine 3",
            },
            nodeid: "247fn://247uptime.io/abc-eq103",
            isequipmentof: [
              {
                equipmentpool: {
                  name: {
                    de: "Zerspanung",
                    en: "Milling machines",
                  },
                  equipmentpoolid: "4711-1",
                  nodeid: "247fn://247uptime.io/abc-equipmentpool1",
                },
              },
              {
                area: {
                  name: {
                    de: "Gehäusefertigung",
                    en: "Housing Production",
                  },
                  areaid: "DEMUCWZB",
                  nodeid: "247fn://247uptime.io/abc-area1",
                  isareaof: [
                    {
                      site: {
                        name: {
                          de: "Werk 1",
                          en: "Site 1",
                        },
                        city: {
                          de: "Manching",
                          en: "Manching",
                        },
                        zipcode: "89312",
                        street: "Am Flugplatz",
                        streetnumber: "42",
                        siteid: "DEMUC1",
                        nodeid: "247fn://247uptime.io/abc-site1",
                      },
                    },
                  ],
                },
              },
            ],
            hasequipmenttype: [
              {
                equipmenttype: {
                  model: "Hyperturn 65",
                  nodeid:
                    "247fn://247uptime.io/06d58ae8-274d-420f-b063-d3dd85533105",
                  hasequipmentclass: [
                    {
                      equipmentclass: {
                        name: {
                          de: "Drehmaschine",
                        },
                        nodeid:
                          "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39",
                      },
                    },
                  ],
                  isequipmenttypeof: [
                    {
                      brand: {
                        name: "Emco",
                        nodeid:
                          "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091",
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    notification: {
      created: 1705194000007,
      progressstarted: 1703154984204,
      closed: "2024-01-16T13:04:19.077Z",
      dueuntil: 1708383600000,
      status: 2,
      type: 6,
      title: {
        de: "Kundendienst - Jahreswartung",
      },
      description: {
        de: "",
      },
      nodeid: "247fn://247uptime.io/de21c29a-72d4-4ee4-a02d-1af174c595f2",
      hasmaintenancetask: [
        {
          maintenancetask: {
            nodeid: "247fn://247uptime.io/abc-maintenancetask4",
            hascategory: [
              {
                maintenancecategory: {
                  name: {
                    de: "Kundendienst",
                  },
                  colorcode: "#e36a0e",
                  nodeid: "247fn://247uptime.io/abc-maintenancecategory3",
                },
              },
            ],
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1619647200000,
            title: {},
            description: {},
            nodeid: "247fn://247uptime.io/abc-workflow4",
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 0,
                  title: {},
                  description: {
                    de: "Durchführung durch Kundendienst",
                  },
                  nodeid: "247fn://247uptime.io/abc-workflowstep4",
                },
              },
            ],
          },
        },
      ],
      haschatroom: [
        {
          chatroom: {
            nodeid: "247fn://247uptime.io/e445b418-cd3b-4dba-b784-1ae6e862e491",
          },
        },
      ],
      isnotificationof: [
        {
          equipment: {
            name: {
              de: "Nachbearbeitung Drehteile",
              en: "Machine 3",
            },
            nodeid: "247fn://247uptime.io/abc-eq103",
            isequipmentof: [
              {
                equipmentpool: {
                  name: {
                    de: "Zerspanung",
                    en: "Milling machines",
                  },
                  equipmentpoolid: "4711-1",
                  nodeid: "247fn://247uptime.io/abc-equipmentpool1",
                },
              },
              {
                area: {
                  name: {
                    de: "Gehäusefertigung",
                    en: "Housing Production",
                  },
                  areaid: "DEMUCWZB",
                  nodeid: "247fn://247uptime.io/abc-area1",
                  isareaof: [
                    {
                      site: {
                        name: {
                          de: "Werk 1",
                          en: "Site 1",
                        },
                        city: {
                          de: "Manching",
                          en: "Manching",
                        },
                        zipcode: "89312",
                        street: "Am Flugplatz",
                        streetnumber: "42",
                        siteid: "DEMUC1",
                        nodeid: "247fn://247uptime.io/abc-site1",
                      },
                    },
                  ],
                },
              },
            ],
            hasequipmenttype: [
              {
                equipmenttype: {
                  model: "Hyperturn 65",
                  nodeid:
                    "247fn://247uptime.io/06d58ae8-274d-420f-b063-d3dd85533105",
                  hasequipmentclass: [
                    {
                      equipmentclass: {
                        name: {
                          de: "Drehmaschine",
                        },
                        nodeid:
                          "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39",
                      },
                    },
                  ],
                  isequipmenttypeof: [
                    {
                      brand: {
                        name: "Emco",
                        nodeid:
                          "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091",
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    notification: {
      created: 1705021200003,
      progressstarted: 0,
      closed: 0,
      dueuntil: 1707174000000,
      status: 0,
      type: 6,
      title: {
        de: "Allgemeine Inspektion der Gesamtmaschine",
      },
      description: {
        de: "",
      },
      nodeid: "247fn://247uptime.io/4802720c-63e1-463f-bbfd-1da90442706e",
      hasmaintenancetask: [
        {
          maintenancetask: {
            nodeid: "247fn://247uptime.io/abc-maintenancetask1",
            hascategory: [
              {
                maintenancecategory: {
                  name: {
                    de: "Routineinspektion",
                  },
                  colorcode: "#1172d4",
                  nodeid: "247fn://247uptime.io/abc-maintenancecategory1",
                },
              },
            ],
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1619647200000,
            title: {},
            description: {},
            nodeid: "247fn://247uptime.io/abc-workflow1",
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 0,
                  title: {},
                  description: {
                    de: "1. Maschine ausschalten, Maschine öffnen und Verkleidungen abnehmen, Sichtkontrolle.\n2. Probelauf\n3. Dokumentation",
                  },
                  nodeid: "247fn://247uptime.io/abc-workflowstep1",
                },
              },
            ],
          },
        },
      ],
      haschatroom: [
        {
          chatroom: {
            nodeid: "247fn://247uptime.io/d77559cb-5ada-405f-bc77-1f5878f531d7",
          },
        },
      ],
      isnotificationof: [
        {
          equipment: {
            name: {
              de: "Nachbearbeitung Drehteile",
              en: "Machine 3",
            },
            nodeid: "247fn://247uptime.io/abc-eq103",
            isequipmentof: [
              {
                equipmentpool: {
                  name: {
                    de: "Zerspanung",
                    en: "Milling machines",
                  },
                  equipmentpoolid: "4711-1",
                  nodeid: "247fn://247uptime.io/abc-equipmentpool1",
                },
              },
              {
                area: {
                  name: {
                    de: "Gehäusefertigung",
                    en: "Housing Production",
                  },
                  areaid: "DEMUCWZB",
                  nodeid: "247fn://247uptime.io/abc-area1",
                  isareaof: [
                    {
                      site: {
                        name: {
                          de: "Werk 1",
                          en: "Site 1",
                        },
                        city: {
                          de: "Manching",
                          en: "Manching",
                        },
                        zipcode: "89312",
                        street: "Am Flugplatz",
                        streetnumber: "42",
                        siteid: "DEMUC1",
                        nodeid: "247fn://247uptime.io/abc-site1",
                      },
                    },
                  ],
                },
              },
            ],
            hasequipmenttype: [
              {
                equipmenttype: {
                  model: "Hyperturn 65",
                  nodeid:
                    "247fn://247uptime.io/06d58ae8-274d-420f-b063-d3dd85533105",
                  hasequipmentclass: [
                    {
                      equipmentclass: {
                        name: {
                          de: "Drehmaschine",
                        },
                        nodeid:
                          "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39",
                      },
                    },
                  ],
                  isequipmenttypeof: [
                    {
                      brand: {
                        name: "Emco",
                        nodeid:
                          "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091",
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    notification: {
      created: 1704934800038,
      progressstarted: 0,
      closed: 0,
      dueuntil: 1708383600000,
      status: 0,
      type: 6,
      title: {
        de: "DGUV V3 Prüfung elektrische Betriebsmittel",
      },
      description: {
        de: "",
      },
      nodeid: "247fn://247uptime.io/66fa0b6f-79ec-4a71-bd93-3341535ed00a",
      hasmaintenancetask: [
        {
          maintenancetask: {
            nodeid: "247fn://247uptime.io/abc-maintenancetask3",
            hascategory: [
              {
                maintenancecategory: {
                  name: {
                    de: "Routinewartung",
                  },
                  colorcode: "#d40ee6",
                  nodeid: "247fn://247uptime.io/abc-maintenancecategory2",
                },
              },
            ],
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1619647200000,
            title: {},
            description: {},
            nodeid: "247fn://247uptime.io/abc-workflow3",
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 0,
                  title: {},
                  description: {
                    de: "1. Vorgehen gemäß Wartungsanleitung\n2. Dokumentation",
                  },
                  nodeid: "247fn://247uptime.io/abc-workflowstep3",
                },
              },
            ],
          },
        },
      ],
      haschatroom: [
        {
          chatroom: {
            nodeid: "247fn://247uptime.io/203565b5-97c1-426d-8a5f-728bf549039c",
          },
        },
      ],
      isnotificationof: [
        {
          equipment: {
            name: {
              de: "Nachbearbeitung Drehteile",
              en: "Machine 3",
            },
            nodeid: "247fn://247uptime.io/abc-eq103",
            isequipmentof: [
              {
                equipmentpool: {
                  name: {
                    de: "Zerspanung",
                    en: "Milling machines",
                  },
                  equipmentpoolid: "4711-1",
                  nodeid: "247fn://247uptime.io/abc-equipmentpool1",
                },
              },
              {
                area: {
                  name: {
                    de: "Gehäusefertigung",
                    en: "Housing Production",
                  },
                  areaid: "DEMUCWZB",
                  nodeid: "247fn://247uptime.io/abc-area1",
                  isareaof: [
                    {
                      site: {
                        name: {
                          de: "Werk 1",
                          en: "Site 1",
                        },
                        city: {
                          de: "Manching",
                          en: "Manching",
                        },
                        zipcode: "89312",
                        street: "Am Flugplatz",
                        streetnumber: "42",
                        siteid: "DEMUC1",
                        nodeid: "247fn://247uptime.io/abc-site1",
                      },
                    },
                  ],
                },
              },
            ],
            hasequipmenttype: [
              {
                equipmenttype: {
                  model: "Hyperturn 65",
                  nodeid:
                    "247fn://247uptime.io/06d58ae8-274d-420f-b063-d3dd85533105",
                  hasequipmentclass: [
                    {
                      equipmentclass: {
                        name: {
                          de: "Drehmaschine",
                        },
                        nodeid:
                          "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39",
                      },
                    },
                  ],
                  isequipmenttypeof: [
                    {
                      brand: {
                        name: "Emco",
                        nodeid:
                          "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091",
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    notification: {
      created: 1704848400142,
      progressstarted: 0,
      closed: 0,
      dueuntil: 1708383600000,
      status: 0,
      type: 6,
      title: {
        de: "Austausch Schmiermittel",
      },
      description: {
        de: "",
      },
      nodeid: "247fn://247uptime.io/b40d6a3d-bb81-452b-8e0a-c03f5bfb05a4",
      hasmaintenancetask: [
        {
          maintenancetask: {
            nodeid: "247fn://247uptime.io/abc-maintenancetask2",
            hascategory: [
              {
                maintenancecategory: {
                  name: {
                    de: "Routinewartung",
                  },
                  colorcode: "#d40ee6",
                  nodeid: "247fn://247uptime.io/abc-maintenancecategory2",
                },
              },
            ],
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1619647200000,
            title: {},
            description: {},
            nodeid: "247fn://247uptime.io/abc-workflow2",
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 0,
                  title: {},
                  description: {
                    de: "1. Überprüfung Zustand Schmiermittel\n2. Entfernen den alten Schmiermittels\n3. Befüllung neues Schmiermittel\n4. Probelauf\n5. Dokumentstaion",
                  },
                  nodeid: "247fn://247uptime.io/abc-workflowstep2",
                },
              },
            ],
          },
        },
      ],
      haschatroom: [
        {
          chatroom: {
            nodeid: "247fn://247uptime.io/c55bb2ea-5e4c-4208-8990-014fb6993ac6",
          },
        },
      ],
      isnotificationof: [
        {
          equipment: {
            name: {
              de: "Nachbearbeitung Drehteile",
              en: "Machine 3",
            },
            nodeid: "247fn://247uptime.io/abc-eq103",
            isequipmentof: [
              {
                equipmentpool: {
                  name: {
                    de: "Zerspanung",
                    en: "Milling machines",
                  },
                  equipmentpoolid: "4711-1",
                  nodeid: "247fn://247uptime.io/abc-equipmentpool1",
                },
              },
              {
                area: {
                  name: {
                    de: "Gehäusefertigung",
                    en: "Housing Production",
                  },
                  areaid: "DEMUCWZB",
                  nodeid: "247fn://247uptime.io/abc-area1",
                  isareaof: [
                    {
                      site: {
                        name: {
                          de: "Werk 1",
                          en: "Site 1",
                        },
                        city: {
                          de: "Manching",
                          en: "Manching",
                        },
                        zipcode: "89312",
                        street: "Am Flugplatz",
                        streetnumber: "42",
                        siteid: "DEMUC1",
                        nodeid: "247fn://247uptime.io/abc-site1",
                      },
                    },
                  ],
                },
              },
            ],
            hasequipmenttype: [
              {
                equipmenttype: {
                  model: "Hyperturn 65",
                  nodeid:
                    "247fn://247uptime.io/06d58ae8-274d-420f-b063-d3dd85533105",
                  hasequipmentclass: [
                    {
                      equipmentclass: {
                        name: {
                          de: "Drehmaschine",
                        },
                        nodeid:
                          "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39",
                      },
                    },
                  ],
                  isequipmenttypeof: [
                    {
                      brand: {
                        name: "Emco",
                        nodeid:
                          "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091",
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    notification: {
      created: 1675064430000,
      progressstarted: 0,
      closed: 0,
      dueuntil: 0,
      status: 0,
      type: 1,
      title: {
        de: "Ungewöhnliches Geräusch an der Spindel",
        en: "",
      },
      description: {
        de: "klingt wie ein schleifen, aber man erkennt keine beeinträchtigung. War gestern noch nicht",
        en: "",
      },
      nodeid: "247fn://247uptime.io/abc-notification3",
      hasworkflow: [
        {
          workflow: {
            created: 1705422181756,
            title: {
              de: "test",
            },
            description: {},
            nodeid: "247fn://247uptime.io/9c22905c-fe45-41ad-a58f-d7cc1532d02d",
            hasauthor: [
              {
                user: {
                  givenname: "Robert",
                  middlename: "",
                  surname: "Schuster",
                  email: "robert.schuster@abc.com",
                  mobilephone: "+491761223456",
                  landlinephone: "+49176123456",
                  image: null,
                  nodeid: "247fn://247uptime.io/abc-user1",
                },
              },
            ],
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 1705422181756,
                  title: {},
                  description: {
                    de: "solution",
                  },
                  nodeid:
                    "247fn://247uptime.io/f529bfaa-9f99-4236-9ff6-e2c427feada7",
                },
              },
            ],
          },
        },
      ],
      hasauthor: [
        {
          user: {
            givenname: "Frank",
            middlename: "",
            surname: "Hanauer",
            email: "frank.hanauer@abc.com",
            mobilephone: "+49176123456",
            landlinephone: "+49176123456",
            image: null,
            nodeid: "247fn://247uptime.io/abc-user3",
          },
        },
      ],
      haschatroom: [
        {
          chatroom: {
            nodeid: "247fn://247uptime.io/abc-chatroom3",
          },
        },
      ],
      isnotificationof: [
        {
          equipment: {
            name: {
              de: "Nachbearbeitung Drehteile",
              en: "Machine 3",
            },
            nodeid: "247fn://247uptime.io/abc-eq103",
            isequipmentof: [
              {
                equipmentpool: {
                  name: {
                    de: "Zerspanung",
                    en: "Milling machines",
                  },
                  equipmentpoolid: "4711-1",
                  nodeid: "247fn://247uptime.io/abc-equipmentpool1",
                },
              },
              {
                area: {
                  name: {
                    de: "Gehäusefertigung",
                    en: "Housing Production",
                  },
                  areaid: "DEMUCWZB",
                  nodeid: "247fn://247uptime.io/abc-area1",
                  isareaof: [
                    {
                      site: {
                        name: {
                          de: "Werk 1",
                          en: "Site 1",
                        },
                        city: {
                          de: "Manching",
                          en: "Manching",
                        },
                        zipcode: "89312",
                        street: "Am Flugplatz",
                        streetnumber: "42",
                        siteid: "DEMUC1",
                        nodeid: "247fn://247uptime.io/abc-site1",
                      },
                    },
                  ],
                },
              },
            ],
            hasequipmenttype: [
              {
                equipmenttype: {
                  model: "Hyperturn 65",
                  nodeid:
                    "247fn://247uptime.io/06d58ae8-274d-420f-b063-d3dd85533105",
                  hasequipmentclass: [
                    {
                      equipmentclass: {
                        name: {
                          de: "Drehmaschine",
                        },
                        nodeid:
                          "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39",
                      },
                    },
                  ],
                  isequipmenttypeof: [
                    {
                      brand: {
                        name: "Emco",
                        nodeid:
                          "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091",
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    notification: {
      created: 1674027630000,
      progressstarted: 1674459630000,
      closed: 1674718830000,
      dueuntil: 0,
      status: 2,
      type: 0,
      title: {
        de: "Störung am Antrieb Achse 1",
        en: "",
      },
      description: {
        de: "Achse verfährt nicht mehr, scheint blockiert zu sein - nach Werkzeugwechsel",
        en: "My first entry",
      },
      nodeid: "247fn://247uptime.io/abc-notification2",
      hasworkflow: [
        {
          workflow: {
            created: 1705421872363,
            title: {
              de: "test",
            },
            description: {},
            nodeid: "247fn://247uptime.io/7863fd70-a8ec-4296-9202-0cf830319a95",
            hasauthor: [
              {
                user: {
                  givenname: "Robert",
                  middlename: "",
                  surname: "Schuster",
                  email: "robert.schuster@abc.com",
                  mobilephone: "+491761223456",
                  landlinephone: "+49176123456",
                  image: null,
                  nodeid: "247fn://247uptime.io/abc-user1",
                },
              },
            ],
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 1705421872363,
                  title: {},
                  description: {
                    de: "test solution",
                  },
                  nodeid:
                    "247fn://247uptime.io/e69c9d40-d79b-4123-9efd-cd5ea6e5fb8c",
                },
              },
            ],
          },
        },
        {
          workflow: {
            created: 1705424449645,
            title: {
              de: "test 3",
            },
            description: {},
            nodeid: "247fn://247uptime.io/b350055a-fb6e-419f-aa75-daeafc5f8c38",
            hasauthor: [
              {
                user: {
                  givenname: "Robert",
                  middlename: "",
                  surname: "Schuster",
                  email: "robert.schuster@abc.com",
                  mobilephone: "+491761223456",
                  landlinephone: "+49176123456",
                  image: null,
                  nodeid: "247fn://247uptime.io/abc-user1",
                },
              },
            ],
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 1705424449645,
                  title: {},
                  description: {
                    de: "new testing solution",
                  },
                  nodeid:
                    "247fn://247uptime.io/e4b65df1-ad99-4e81-b34f-b58ddfc78e15",
                },
              },
            ],
          },
        },
      ],
      hasauthor: [
        {
          user: {
            givenname: "Franz",
            middlename: "",
            surname: "Pichler",
            email: "franz.pichler@abc.com",
            mobilephone: "+49176123456",
            landlinephone: "+49176123456",
            image: null,
            nodeid: "247fn://247uptime.io/abc-user2",
          },
        },
      ],
      hasattachment: [
        {
          attachment: {
            file: {
              fileid:
                "n20a58a5-9aec-43df-9591-f8816014d542/n20a58a5-9aec-43df-9591-f8816014d543.jpg",
              fileversion: "101a58a5-9aec-43df-9591-f8816014d542",
              mimetype: "image/jpeg",
              url: "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-attachment3/n20a58a5-9aec-43df-9591-f8816014d542/n20a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111836Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=94f906e4c0a63a62d40bbeabbf09f5cfee9ac202e2e9818657870cd336726e87",
            },
            description: {},
            nodeid: "247fn://247uptime.io/abc-attachment3",
          },
        },
        {
          attachment: {
            file: {
              fileid:
                "n21a58a5-9aec-43df-9591-f8816014d542/n21a58a5-9aec-43df-9591-f8816014d543.jpg",
              fileversion: "101a58a5-9aec-43df-9591-f8816014d542",
              mimetype: "image/jpeg",
              url: "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-attachment4/n21a58a5-9aec-43df-9591-f8816014d542/n21a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111836Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=c1a0b89ca4f4e5d3460e1aca497feeae9fa173e9f582498931c40c07acd5c326",
            },
            description: {},
            nodeid: "247fn://247uptime.io/abc-attachment4",
          },
        },
      ],
      haschatroom: [
        {
          chatroom: {
            nodeid: "247fn://247uptime.io/abc-chatroom2",
          },
        },
      ],
      isnotificationof: [
        {
          equipment: {
            name: {
              de: "Nachbearbeitung Drehteile",
              en: "Machine 3",
            },
            nodeid: "247fn://247uptime.io/abc-eq103",
            isequipmentof: [
              {
                equipmentpool: {
                  name: {
                    de: "Zerspanung",
                    en: "Milling machines",
                  },
                  equipmentpoolid: "4711-1",
                  nodeid: "247fn://247uptime.io/abc-equipmentpool1",
                },
              },
              {
                area: {
                  name: {
                    de: "Gehäusefertigung",
                    en: "Housing Production",
                  },
                  areaid: "DEMUCWZB",
                  nodeid: "247fn://247uptime.io/abc-area1",
                  isareaof: [
                    {
                      site: {
                        name: {
                          de: "Werk 1",
                          en: "Site 1",
                        },
                        city: {
                          de: "Manching",
                          en: "Manching",
                        },
                        zipcode: "89312",
                        street: "Am Flugplatz",
                        streetnumber: "42",
                        siteid: "DEMUC1",
                        nodeid: "247fn://247uptime.io/abc-site1",
                      },
                    },
                  ],
                },
              },
            ],
            hasequipmenttype: [
              {
                equipmenttype: {
                  model: "Hyperturn 65",
                  nodeid:
                    "247fn://247uptime.io/06d58ae8-274d-420f-b063-d3dd85533105",
                  hasequipmentclass: [
                    {
                      equipmentclass: {
                        name: {
                          de: "Drehmaschine",
                        },
                        nodeid:
                          "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39",
                      },
                    },
                  ],
                  isequipmenttypeof: [
                    {
                      brand: {
                        name: "Emco",
                        nodeid:
                          "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091",
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    notification: {
      created: 1667979630000,
      progressstarted: 1668066030000,
      closed: 1668152430000,
      dueuntil: 0,
      status: 2,
      type: 2,
      title: {
        de: "Umbau des Werkzeugwechslers",
        en: "Anual inspection",
      },
      description: {
        de: "Umsetzung gemäß neuem Standard",
        en: "My first entry",
      },
      nodeid: "247fn://247uptime.io/abc-notification6",
      hasauthor: [
        {
          user: {
            givenname: "Frank",
            middlename: "",
            surname: "Hanauer",
            email: "frank.hanauer@abc.com",
            mobilephone: "+49176123456",
            landlinephone: "+49176123456",
            image: null,
            nodeid: "247fn://247uptime.io/abc-user3",
          },
        },
      ],
      haschatroom: [
        {
          chatroom: {
            nodeid: "247fn://247uptime.io/abc-chatroom6",
          },
        },
      ],
      isnotificationof: [
        {
          equipment: {
            name: {
              de: "Nachbearbeitung Drehteile",
              en: "Machine 3",
            },
            nodeid: "247fn://247uptime.io/abc-eq103",
            isequipmentof: [
              {
                equipmentpool: {
                  name: {
                    de: "Zerspanung",
                    en: "Milling machines",
                  },
                  equipmentpoolid: "4711-1",
                  nodeid: "247fn://247uptime.io/abc-equipmentpool1",
                },
              },
              {
                area: {
                  name: {
                    de: "Gehäusefertigung",
                    en: "Housing Production",
                  },
                  areaid: "DEMUCWZB",
                  nodeid: "247fn://247uptime.io/abc-area1",
                  isareaof: [
                    {
                      site: {
                        name: {
                          de: "Werk 1",
                          en: "Site 1",
                        },
                        city: {
                          de: "Manching",
                          en: "Manching",
                        },
                        zipcode: "89312",
                        street: "Am Flugplatz",
                        streetnumber: "42",
                        siteid: "DEMUC1",
                        nodeid: "247fn://247uptime.io/abc-site1",
                      },
                    },
                  ],
                },
              },
            ],
            hasequipmenttype: [
              {
                equipmenttype: {
                  model: "Hyperturn 65",
                  nodeid:
                    "247fn://247uptime.io/06d58ae8-274d-420f-b063-d3dd85533105",
                  hasequipmentclass: [
                    {
                      equipmentclass: {
                        name: {
                          de: "Drehmaschine",
                        },
                        nodeid:
                          "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39",
                      },
                    },
                  ],
                  isequipmenttypeof: [
                    {
                      brand: {
                        name: "Emco",
                        nodeid:
                          "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091",
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    notification: {
      created: 1666683630000,
      progressstarted: 1666770030000,
      closed: 1666942830000,
      dueuntil: 0,
      status: 2,
      type: 6,
      title: {
        de: "Jahresinspektion",
        en: "Anual inspection",
      },
      description: {
        de: "Vorgehen gemäß Inspektionsanweiseung. Dauer ca. 8 Stunden",
        en: "My first entry",
      },
      nodeid: "247fn://247uptime.io/abc-notification1",
      hasmaintenancetask: [
        {
          maintenancetask: {
            nodeid: "247fn://247uptime.io/abc-maintenancetask3",
            hascategory: [
              {
                maintenancecategory: {
                  name: {
                    de: "Routinewartung",
                  },
                  colorcode: "#d40ee6",
                  nodeid: "247fn://247uptime.io/abc-maintenancecategory2",
                },
              },
            ],
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1619647200000,
            title: {},
            description: {},
            nodeid: "247fn://247uptime.io/abc-workflow3",
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 0,
                  title: {},
                  description: {
                    de: "1. Vorgehen gemäß Wartungsanleitung\n2. Dokumentation",
                  },
                  nodeid: "247fn://247uptime.io/abc-workflowstep3",
                },
              },
            ],
          },
        },
      ],
      hasauthor: [
        {
          user: {
            givenname: "Frank",
            middlename: "",
            surname: "Hanauer",
            email: "frank.hanauer@abc.com",
            mobilephone: "+49176123456",
            landlinephone: "+49176123456",
            image: null,
            nodeid: "247fn://247uptime.io/abc-user3",
          },
        },
      ],
      hasattachment: [
        {
          attachment: {
            file: {
              fileid:
                "n10a58a5-9aec-43df-9591-f8816014d542/n10a58a5-9aec-43df-9591-f8816014d543.jpg",
              fileversion: "101a58a5-9aec-43df-9591-f8816014d542",
              mimetype: "image/jpeg",
              url: "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-attachment1/n10a58a5-9aec-43df-9591-f8816014d542/n10a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111836Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=70b1a85b393ce0ed08f6579ba50b1e4ffa4e97beef6e759044ca81913fc2f45a",
            },
            description: {},
            nodeid: "247fn://247uptime.io/abc-attachment1",
          },
        },
        {
          attachment: {
            file: {
              fileid:
                "n11a58a5-9aec-43df-9591-f8816014d542/n11a58a5-9aec-43df-9591-f8816014d543.pdf",
              fileversion: "101a58a5-9aec-43df-9591-f8816014d542",
              mimetype: "application/pdf",
              url: "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-attachment2/n11a58a5-9aec-43df-9591-f8816014d542/n11a58a5-9aec-43df-9591-f8816014d543.pdf?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111836Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=1df2534e3901ec25c06c9afb80cbfc23972623952aaa8e95acbbf47a897f5830",
            },
            description: {},
            nodeid: "247fn://247uptime.io/abc-attachment2",
          },
        },
      ],
      haschatroom: [
        {
          chatroom: {
            nodeid: "247fn://247uptime.io/abc-chatroom1",
          },
        },
      ],
      isnotificationof: [
        {
          equipment: {
            name: {
              de: "Nachbearbeitung Drehteile",
              en: "Machine 3",
            },
            nodeid: "247fn://247uptime.io/abc-eq103",
            isequipmentof: [
              {
                equipmentpool: {
                  name: {
                    de: "Zerspanung",
                    en: "Milling machines",
                  },
                  equipmentpoolid: "4711-1",
                  nodeid: "247fn://247uptime.io/abc-equipmentpool1",
                },
              },
              {
                area: {
                  name: {
                    de: "Gehäusefertigung",
                    en: "Housing Production",
                  },
                  areaid: "DEMUCWZB",
                  nodeid: "247fn://247uptime.io/abc-area1",
                  isareaof: [
                    {
                      site: {
                        name: {
                          de: "Werk 1",
                          en: "Site 1",
                        },
                        city: {
                          de: "Manching",
                          en: "Manching",
                        },
                        zipcode: "89312",
                        street: "Am Flugplatz",
                        streetnumber: "42",
                        siteid: "DEMUC1",
                        nodeid: "247fn://247uptime.io/abc-site1",
                      },
                    },
                  ],
                },
              },
            ],
            hasequipmenttype: [
              {
                equipmenttype: {
                  model: "Hyperturn 65",
                  nodeid:
                    "247fn://247uptime.io/06d58ae8-274d-420f-b063-d3dd85533105",
                  hasequipmentclass: [
                    {
                      equipmentclass: {
                        name: {
                          de: "Drehmaschine",
                        },
                        nodeid:
                          "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39",
                      },
                    },
                  ],
                  isequipmenttypeof: [
                    {
                      brand: {
                        name: "Emco",
                        nodeid:
                          "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091",
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    notification: {
      created: 1665474030000,
      progressstarted: 1665560430000,
      closed: 1665646830000,
      dueuntil: 0,
      status: 2,
      type: 6,
      title: {
        de: "Wartung durch Hersteller Service",
        en: "Anual inspection",
      },
      description: {
        de: "bitte Protokoll anhängen",
        en: "My first entry",
      },
      nodeid: "247fn://247uptime.io/abc-notification7",
      hasmaintenancetask: [
        {
          maintenancetask: {
            nodeid: "247fn://247uptime.io/abc-maintenancetask4",
            hascategory: [
              {
                maintenancecategory: {
                  name: {
                    de: "Kundendienst",
                  },
                  colorcode: "#e36a0e",
                  nodeid: "247fn://247uptime.io/abc-maintenancecategory3",
                },
              },
            ],
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1619647200000,
            title: {},
            description: {},
            nodeid: "247fn://247uptime.io/abc-workflow4",
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 0,
                  title: {},
                  description: {
                    de: "Durchführung durch Kundendienst",
                  },
                  nodeid: "247fn://247uptime.io/abc-workflowstep4",
                },
              },
            ],
          },
        },
      ],
      hasauthor: [
        {
          user: {
            givenname: "Frank",
            middlename: "",
            surname: "Hanauer",
            email: "frank.hanauer@abc.com",
            mobilephone: "+49176123456",
            landlinephone: "+49176123456",
            image: null,
            nodeid: "247fn://247uptime.io/abc-user3",
          },
        },
      ],
      hasattachment: [
        {
          attachment: {
            file: {
              fileid:
                "n70a58a5-9aec-43df-9591-f8816014d542/n70a58a5-9aec-43df-9591-f8816014d543.pdf",
              fileversion: "101a58a5-9aec-43df-9591-f8816014d542",
              mimetype: "application/pdf",
              url: "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-attachment5/n70a58a5-9aec-43df-9591-f8816014d542/n70a58a5-9aec-43df-9591-f8816014d543.pdf?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240130T111836Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=b0196f2f3b27395fbea4b5a55cdab5a5c6aeba7bfe3d0460ec6d34be9fabd1f3",
            },
            description: {},
            nodeid: "247fn://247uptime.io/abc-attachment5",
          },
        },
      ],
      haschatroom: [
        {
          chatroom: {
            nodeid: "247fn://247uptime.io/abc-chatroom7",
          },
        },
      ],
      isnotificationof: [
        {
          equipment: {
            name: {
              de: "Nachbearbeitung Drehteile",
              en: "Machine 3",
            },
            nodeid: "247fn://247uptime.io/abc-eq103",
            isequipmentof: [
              {
                equipmentpool: {
                  name: {
                    de: "Zerspanung",
                    en: "Milling machines",
                  },
                  equipmentpoolid: "4711-1",
                  nodeid: "247fn://247uptime.io/abc-equipmentpool1",
                },
              },
              {
                area: {
                  name: {
                    de: "Gehäusefertigung",
                    en: "Housing Production",
                  },
                  areaid: "DEMUCWZB",
                  nodeid: "247fn://247uptime.io/abc-area1",
                  isareaof: [
                    {
                      site: {
                        name: {
                          de: "Werk 1",
                          en: "Site 1",
                        },
                        city: {
                          de: "Manching",
                          en: "Manching",
                        },
                        zipcode: "89312",
                        street: "Am Flugplatz",
                        streetnumber: "42",
                        siteid: "DEMUC1",
                        nodeid: "247fn://247uptime.io/abc-site1",
                      },
                    },
                  ],
                },
              },
            ],
            hasequipmenttype: [
              {
                equipmenttype: {
                  model: "Hyperturn 65",
                  nodeid:
                    "247fn://247uptime.io/06d58ae8-274d-420f-b063-d3dd85533105",
                  hasequipmentclass: [
                    {
                      equipmentclass: {
                        name: {
                          de: "Drehmaschine",
                        },
                        nodeid:
                          "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39",
                      },
                    },
                  ],
                  isequipmenttypeof: [
                    {
                      brand: {
                        name: "Emco",
                        nodeid:
                          "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091",
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    notification: {
      created: 1664523630000,
      progressstarted: 1664869230000,
      closed: 1665042030000,
      dueuntil: 0,
      status: 2,
      type: 0,
      title: {
        de: "Hydraulikzylinder undicht",
        en: "",
      },
      description: {
        de: "Hydrauliköl tritt aus - musste Maschine abschalten",
        en: "My first entry",
      },
      nodeid: "247fn://247uptime.io/abc-notification4",
      hasauthor: [
        {
          user: {
            givenname: "Franz",
            middlename: "",
            surname: "Pichler",
            email: "franz.pichler@abc.com",
            mobilephone: "+49176123456",
            landlinephone: "+49176123456",
            image: null,
            nodeid: "247fn://247uptime.io/abc-user2",
          },
        },
      ],
      haschatroom: [
        {
          chatroom: {
            nodeid: "247fn://247uptime.io/abc-chatroom4",
          },
        },
      ],
      isnotificationof: [
        {
          equipment: {
            name: {
              de: "Nachbearbeitung Drehteile",
              en: "Machine 3",
            },
            nodeid: "247fn://247uptime.io/abc-eq103",
            isequipmentof: [
              {
                equipmentpool: {
                  name: {
                    de: "Zerspanung",
                    en: "Milling machines",
                  },
                  equipmentpoolid: "4711-1",
                  nodeid: "247fn://247uptime.io/abc-equipmentpool1",
                },
              },
              {
                area: {
                  name: {
                    de: "Gehäusefertigung",
                    en: "Housing Production",
                  },
                  areaid: "DEMUCWZB",
                  nodeid: "247fn://247uptime.io/abc-area1",
                  isareaof: [
                    {
                      site: {
                        name: {
                          de: "Werk 1",
                          en: "Site 1",
                        },
                        city: {
                          de: "Manching",
                          en: "Manching",
                        },
                        zipcode: "89312",
                        street: "Am Flugplatz",
                        streetnumber: "42",
                        siteid: "DEMUC1",
                        nodeid: "247fn://247uptime.io/abc-site1",
                      },
                    },
                  ],
                },
              },
            ],
            hasequipmenttype: [
              {
                equipmenttype: {
                  model: "Hyperturn 65",
                  nodeid:
                    "247fn://247uptime.io/06d58ae8-274d-420f-b063-d3dd85533105",
                  hasequipmentclass: [
                    {
                      equipmentclass: {
                        name: {
                          de: "Drehmaschine",
                        },
                        nodeid:
                          "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39",
                      },
                    },
                  ],
                  isequipmenttypeof: [
                    {
                      brand: {
                        name: "Emco",
                        nodeid:
                          "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091",
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  },
  {
    notification: {
      created: 1646638830000,
      progressstarted: 1646725230000,
      closed: 1646811630000,
      dueuntil: 0,
      status: 2,
      type: 6,
      title: {
        de: "Überprüfung Schmiermittel",
        en: "Anual inspection",
      },
      description: {
        de: "Falls nötig bitte Austausch veranlassen",
        en: "My first entry",
      },
      nodeid: "247fn://247uptime.io/abc-notification5",
      hasmaintenancetask: [
        {
          maintenancetask: {
            nodeid: "247fn://247uptime.io/abc-maintenancetask2",
            hascategory: [
              {
                maintenancecategory: {
                  name: {
                    de: "Routinewartung",
                  },
                  colorcode: "#d40ee6",
                  nodeid: "247fn://247uptime.io/abc-maintenancecategory2",
                },
              },
            ],
          },
        },
      ],
      hasworkflow: [
        {
          workflow: {
            created: 1619647200000,
            title: {},
            description: {},
            nodeid: "247fn://247uptime.io/abc-workflow2",
            hasworkflowstep: [
              {
                workflowstep: {
                  created: 0,
                  title: {},
                  description: {
                    de: "1. Überprüfung Zustand Schmiermittel\n2. Entfernen den alten Schmiermittels\n3. Befüllung neues Schmiermittel\n4. Probelauf\n5. Dokumentstaion",
                  },
                  nodeid: "247fn://247uptime.io/abc-workflowstep2",
                },
              },
            ],
          },
        },
      ],
      hasauthor: [
        {
          user: {
            givenname: "Stefan",
            middlename: "",
            surname: "Vohburger",
            email: "stefan.vohburger@abc.com",
            mobilephone: "+49176123456",
            landlinephone: "+4917612345",
            image: null,
            nodeid: "247fn://247uptime.io/abc-user4",
          },
        },
      ],
      haschatroom: [
        {
          chatroom: {
            nodeid: "247fn://247uptime.io/abc-chatroom5",
          },
        },
      ],
      isnotificationof: [
        {
          equipment: {
            name: {
              de: "Nachbearbeitung Drehteile",
              en: "Machine 3",
            },
            nodeid: "247fn://247uptime.io/abc-eq103",
            isequipmentof: [
              {
                equipmentpool: {
                  name: {
                    de: "Zerspanung",
                    en: "Milling machines",
                  },
                  equipmentpoolid: "4711-1",
                  nodeid: "247fn://247uptime.io/abc-equipmentpool1",
                },
              },
              {
                area: {
                  name: {
                    de: "Gehäusefertigung",
                    en: "Housing Production",
                  },
                  areaid: "DEMUCWZB",
                  nodeid: "247fn://247uptime.io/abc-area1",
                  isareaof: [
                    {
                      site: {
                        name: {
                          de: "Werk 1",
                          en: "Site 1",
                        },
                        city: {
                          de: "Manching",
                          en: "Manching",
                        },
                        zipcode: "89312",
                        street: "Am Flugplatz",
                        streetnumber: "42",
                        siteid: "DEMUC1",
                        nodeid: "247fn://247uptime.io/abc-site1",
                      },
                    },
                  ],
                },
              },
            ],
            hasequipmenttype: [
              {
                equipmenttype: {
                  model: "Hyperturn 65",
                  nodeid:
                    "247fn://247uptime.io/06d58ae8-274d-420f-b063-d3dd85533105",
                  hasequipmentclass: [
                    {
                      equipmentclass: {
                        name: {
                          de: "Drehmaschine",
                        },
                        nodeid:
                          "247fn://247uptime.io/8da532fe-63fc-4bf6-bcf9-d7842ee50b39",
                      },
                    },
                  ],
                  isequipmenttypeof: [
                    {
                      brand: {
                        name: "Emco",
                        nodeid:
                          "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091",
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  },
];

const sideBarMenuItems = (lang) => {
  return [
    {
      title: i18n(lang)?.sideNav_quality_management,
      items: [
        {
          icon: <DashboardIcon />,
          title: "Dashboard",
          to: "/qualitymanagement",
        },
        {
          icon: <ReportsIcons />,
          title: i18n(lang)?.sideNav_geplante_reports,
          to: "/reports",
        },
        {
          icon: <ReportsIcons />,
          title: i18n(lang)?.sideNav_manual_reports,
          to: "/manual-reports",
        } /* ,
        {
          icon: <BackupIcon />,
          title: i18n(lang).sideNav_product_backup,
          to: "/backup",
        }, */,
      ],
    },
    {
      title: i18n(lang)?.sideNav_maintenance,
      items: [
        {
          icon: <DashboardIcon />,
          title: "Dashboard",
          to: "/maintenance",
        },
        {
          icon: <CalendarMonth />,
          title: i18n(lang)?.sideNav_maintenance_calender,
          to: "/wartungskalender",
        },
      ],
    },
    {
      title: i18n(lang)?.sideNav_sites,
      items: [
        {
          icon: <SmallWerke />,
          title: i18n(lang).sideNav_overview,
          to: "/sites",
        },
        {
          icon: <SmallWerke />,
          title: i18n(lang).create_new_site,
          to: "/create-site",
        },
      ],
    },
  ];
};

const SitesJSON = {
  "247fn://247uptime.io/abc-site1": {
    name: "Werk 1",
    city: "Manching",
    zipcode: "89312",
    street: "Am Flugplatz",
    siteid: "DEMUC1",
    country: "",
    nodeid: "247fn://247uptime.io/abc-site1",
    hasarea: [
      {
        area: {
          name: "Gehäusefertigung",
          areaid: "DEMUCWZB",
          nodeid: "247fn://247uptime.io/abc-area1",
          hasequipment: [
            {
              equipment: {
                name: "Nachbearbeitung Drehteile",
                equipmentid: "103",
                inventoryid: "i103",
                constructiondate: "2017",
                manufacturerserialnumber: "emco8765432",
                memo: "wird z.Zt. nur Spätschicht genutzt",
                image: {
                  fileid:
                    "103a58a5-9aec-43df-9591-f8816014d542/103a58a5-9aec-43df-9591-f8816014d543.jpg",
                  fileversion: "101a58a5-9aec-43df-9591-f8816014d542",
                  mimetype: "image/jpeg",
                  url: "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq103/103a58a5-9aec-43df-9591-f8816014d542/103a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240513%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240513T091344Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=d0a5ea5cbc16dfdd0e00f4b6231e0d4cf562761f7b66d0eab574b1d49dfd5d87",
                },
                nodeid: "247fn://247uptime.io/abc-eq103",
                hasmaintenancetask: [
                  {
                    maintenancetask: {
                      title: "Allgemeine Inspektion der Gesamtmaschine",
                      description: null,
                      reminder: "2w",
                      repetitioninterval: "3m",
                      startingfrom: 1675638000000,
                      specifier: "",
                      created: 0,
                      nodeid: "247fn://247uptime.io/abc-maintenancetask1",
                      hascategory: [
                        {
                          maintenancecategory: {
                            name: "Routineinspektion",
                            colorcode: "#1172d4",
                            nodeid:
                              "247fn://247uptime.io/abc-maintenancecategory1",
                          },
                        },
                      ],
                    },
                  },
                  {
                    maintenancetask: {
                      title: "DGUV V3 Prüfung elektrische Betriebsmittel",
                      description: null,
                      reminder: "2w",
                      repetitioninterval: "1y",
                      startingfrom: 1676847600000,
                      specifier: "",
                      created: 0,
                      nodeid: "247fn://247uptime.io/abc-maintenancetask3",
                      hascategory: [
                        {
                          maintenancecategory: {
                            name: "Routinewartung",
                            colorcode: "#d40ee6",
                            nodeid:
                              "247fn://247uptime.io/abc-maintenancecategory2",
                          },
                        },
                      ],
                    },
                  },
                  {
                    maintenancetask: {
                      title: "Austausch Schmiermittel",
                      description: null,
                      reminder: "2w",
                      repetitioninterval: "1y",
                      startingfrom: 1676847600000,
                      specifier: "",
                      created: 0,
                      nodeid: "247fn://247uptime.io/abc-maintenancetask2",
                      hascategory: [
                        {
                          maintenancecategory: {
                            name: "Routinewartung",
                            colorcode: "#d40ee6",
                            nodeid:
                              "247fn://247uptime.io/abc-maintenancecategory2",
                          },
                        },
                      ],
                    },
                  },
                  {
                    maintenancetask: {
                      title: "Kundendienst - Jahreswartung",
                      description: null,
                      reminder: "2w",
                      repetitioninterval: "1y",
                      startingfrom: 1676847600000,
                      specifier: "",
                      created: 0,
                      nodeid: "247fn://247uptime.io/abc-maintenancetask4",
                      hascategory: [
                        {
                          maintenancecategory: {
                            name: "Kundendienst",
                            colorcode: "#e36a0e",
                            nodeid:
                              "247fn://247uptime.io/abc-maintenancecategory3",
                          },
                        },
                      ],
                    },
                  },
                ],
                hasnotification: [
                  {
                    notification: {
                      created: 1675064430000,
                      progressstarted: 0,
                      closed: 0,
                      status: 0,
                      type: 1,
                      title: "Ungewöhnliches Geräusch an der Spindel",
                      description:
                        "klingt wie ein schleifen, aber man erkennt keine beeinträchtigung. War gestern noch nicht",
                      nodeid: "247fn://247uptime.io/abc-notification3",
                    },
                  },
                  {
                    notification: {
                      created: 1715043600005,
                      progressstarted: 0,
                      closed: 0,
                      status: 0,
                      type: 6,
                      title: "Allgemeine Inspektion der Gesamtmaschine",
                      description: null,
                      nodeid:
                        "247fn://247uptime.io/f57eeaea-5b50-46f4-ba00-09bdd425c5bf",
                    },
                  },
                  {
                    notification: {
                      created: 1715043600005,
                      progressstarted: 0,
                      closed: 0,
                      status: 0,
                      type: 6,
                      title: "Austausch Schmiermittel",
                      description: null,
                      nodeid:
                        "247fn://247uptime.io/2c37e427-cd73-40e5-8bf9-7c690d7a7de3",
                    },
                  },
                  {
                    notification: {
                      created: 1715043600005,
                      progressstarted: 0,
                      closed: 0,
                      status: 0,
                      type: 6,
                      title: "DGUV V3 Prüfung elektrische Betriebsmittel",
                      description: null,
                      nodeid:
                        "247fn://247uptime.io/80cbf655-e45f-4cf1-8820-3ee17bcb5acf",
                    },
                  },
                  {
                    notification: {
                      created: 1715043600005,
                      progressstarted: 0,
                      closed: 0,
                      status: 0,
                      type: 6,
                      title: "Kundendienst - Jahreswartung",
                      description: null,
                      nodeid:
                        "247fn://247uptime.io/0854d2bb-eec9-4542-af98-991e78fc4bf0",
                    },
                  },
                ],
                hasequipmenttype: [
                  {
                    equipmenttype: {
                      model: "Hyperturn 65",
                      nodeid:
                        "247fn://247uptime.io/06d58ae8-274d-420f-b063-d3dd85533105",
                      isequipmenttypeof: [
                        {
                          brand: {
                            name: "Emco",
                            nodeid:
                              "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091",
                          },
                        },
                      ],
                    },
                  },
                ],
              },
            },
            {
              equipment: {
                name: "5Achs Bearbeitungszentrum",
                equipmentid: "102",
                inventoryid: "i102",
                constructiondate: "2012",
                manufacturerserialnumber: "dmg87654321",
                memo: "Meine Notiz",
                image: {
                  fileid:
                    "102a58a5-9aec-43df-9591-f8816014d542/102a58a5-9aec-43df-9591-f8816014d543.jpg",
                  fileversion: "101a58a5-9aec-43df-9591-f8816014d542",
                  mimetype: "image/jpeg",
                  url: "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq102/102a58a5-9aec-43df-9591-f8816014d542/102a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240513%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240513T091344Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=5295df5c062de62470de51028a2dc738dacfb7863082ffd226b1b9a36ecd10c5",
                },
                nodeid: "247fn://247uptime.io/abc-eq102",
                hasequipmenttype: [
                  {
                    equipmenttype: {
                      model: "DMU 70",
                      nodeid:
                        "247fn://247uptime.io/3a4ddeaa-83a5-4d58-a9e1-69fd7f3f102f",
                      isequipmenttypeof: [
                        {
                          brand: {
                            name: "Deckel Maho",
                            nodeid:
                              "247fn://247uptime.io/2132d959-981e-468c-85fa-303ccbce3dd5",
                          },
                        },
                      ],
                    },
                  },
                ],
              },
            },
            {
              equipment: {
                name: "5Achs Bearbeitungszentrum",
                equipmentid: "101",
                inventoryid: "i101",
                constructiondate: "2017",
                manufacturerserialnumber: "dmg12345678",
                memo: "Die Maschine als Messemaschine gekauft",
                image: {
                  fileid:
                    "101a58a5-9aec-43df-9591-f8816014d542/101a58a5-9aec-43df-9591-f8816014d543.jpg",
                  fileversion: "101a58a5-9aec-43df-9591-f8816014d542",
                  mimetype: "image/jpeg",
                  url: "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq101/101a58a5-9aec-43df-9591-f8816014d542/101a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240513%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240513T091344Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=02ecee3e433fdb242c50ce69d7e090d220d7caeda0c5078641d6550431201ae7",
                },
                nodeid: "247fn://247uptime.io/abc-eq101",
                hasequipmenttype: [
                  {
                    equipmenttype: {
                      model: "DMU 100",
                      nodeid:
                        "247fn://247uptime.io/0b7135e8-56e6-47a5-b891-9e1471d3a2c5",
                      isequipmenttypeof: [
                        {
                          brand: {
                            name: "Deckel Maho",
                            nodeid:
                              "247fn://247uptime.io/2132d959-981e-468c-85fa-303ccbce3dd5",
                          },
                        },
                      ],
                    },
                  },
                ],
              },
            },
            {
              equipment: {
                name: "Bearbeitungszentrum",
                equipmentid: "108",
                inventoryid: "i108",
                constructiondate: "2015",
                manufacturerserialnumber: "her2314",
                memo: "t",
                image: {
                  fileid:
                    "108a58a5-9aec-43df-9591-f8816014d542/108a58a5-9aec-43df-9591-f8816014d543.jpg",
                  fileversion: "101a58a5-9aec-43df-9591-f8816014d542",
                  mimetype: "image/jpeg",
                  url: "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq108/108a58a5-9aec-43df-9591-f8816014d542/108a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240513%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240513T091344Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=c8f6cbd131593dc93395f8028e4d1b07006aec5ca78e291ee4d1ae4017ce6f9f",
                },
                nodeid: "247fn://247uptime.io/abc-eq108",
                hasequipmenttype: [
                  {
                    equipmenttype: {
                      model: "C 400",
                      nodeid:
                        "247fn://247uptime.io/96f02979-e47d-42a9-9be6-6985c0cac1b3",
                      isequipmenttypeof: [
                        {
                          brand: {
                            name: "Hedelius",
                            nodeid:
                              "247fn://247uptime.io/994010e1-4167-4703-82a5-630040b548d6",
                          },
                        },
                      ],
                    },
                  },
                ],
              },
            },
            {
              equipment: {
                name: "Bolzenbearbeitung",
                equipmentid: "104",
                inventoryid: "i104",
                constructiondate: "2019",
                manufacturerserialnumber: "emco1234567",
                memo: "Meine Notiz",
                image: {
                  fileid:
                    "104a58a5-9aec-43df-9591-f8816014d542/104a58a5-9aec-43df-9591-f8816014d543.jpg",
                  fileversion: "101a58a5-9aec-43df-9591-f8816014d542",
                  mimetype: "image/jpeg",
                  url: "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq104/104a58a5-9aec-43df-9591-f8816014d542/104a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240513%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240513T091344Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=ee1f53d53fab16cdc6e330d3edc3792d9850de1ac6221c183348d8933047590c",
                },
                nodeid: "247fn://247uptime.io/abc-eq104",
                hasequipmenttype: [
                  {
                    equipmenttype: {
                      model: "Hyperturn 45",
                      nodeid:
                        "247fn://247uptime.io/a7cea051-d8d5-4a48-8b8f-795fcb6519b5",
                      isequipmenttypeof: [
                        {
                          brand: {
                            name: "Emco",
                            nodeid:
                              "247fn://247uptime.io/ec28991e-4fcf-4bcd-8cb7-a9253a7ba091",
                          },
                        },
                      ],
                    },
                  },
                ],
              },
            },
            {
              equipment: {
                name: "Prototypenbau",
                equipmentid: "110",
                inventoryid: "i110",
                constructiondate: "2010",
                manufacturerserialnumber: "weil12345",
                memo: "ehemals Lehrwerkstadt",
                image: {
                  fileid:
                    "110a58a5-9aec-43df-9591-f8816014d542/110a58a5-9aec-43df-9591-f8816014d543.jpg",
                  fileversion: "101a58a5-9aec-43df-9591-f8816014d542",
                  mimetype: "image/jpeg",
                  url: "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq110/110a58a5-9aec-43df-9591-f8816014d542/110a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240513%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240513T091344Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=36a6f54f2eca10d4da90bd705d2235a7af3684fbfd01e3ba822479f91f090d6d",
                },
                nodeid: "247fn://247uptime.io/abc-eq110",
                hasequipmenttype: [
                  {
                    equipmenttype: {
                      model: "Condor 81",
                      nodeid:
                        "247fn://247uptime.io/cc2347d2-8d19-49a2-b72a-0b09db902a82",
                      isequipmenttypeof: [
                        {
                          brand: {
                            name: "Weiler",
                            nodeid:
                              "247fn://247uptime.io/6ac947df-48fe-4841-845f-1637e476ad54",
                          },
                        },
                      ],
                    },
                  },
                ],
              },
            },
          ],
        },
      },
      {
        area: {
          name: "Gehäusefertigung",
          areaid: "DEMUCGHF",
          nodeid: "247fn://247uptime.io/abc-area2",
          hasequipment: [
            {
              equipment: {
                name: "Kegelradschleifen",
                equipmentid: "201",
                inventoryid: "i201",
                constructiondate: "2013",
                manufacturerserialnumber: "Kling12345",
                memo: "My memo",
                image: {
                  fileid:
                    "201a58a5-9aec-43df-9591-f8816014d542/201a58a5-9aec-43df-9591-f8816014d543.jpg",
                  fileversion: "101a58a5-9aec-43df-9591-f8816014d542",
                  mimetype: "image/jpeg",
                  url: "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq201/201a58a5-9aec-43df-9591-f8816014d542/201a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240513%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240513T091344Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=c131cd8b70d8ff50e1bfd9135393541b9ce294c2b664dcee1b7c3564cd35b7ea",
                },
                nodeid: "247fn://247uptime.io/abc-eq201",
                hasequipmenttype: [
                  {
                    equipmenttype: {
                      model: "WNC 80",
                      nodeid:
                        "247fn://247uptime.io/8dc7ec1b-f5fa-4548-8dee-b85d4a68c07d",
                      isequipmenttypeof: [
                        {
                          brand: {
                            name: "Klingelnberg",
                            nodeid:
                              "247fn://247uptime.io/30da53b9-9580-4763-aa4e-f7aefe83c8f7",
                          },
                        },
                      ],
                    },
                  },
                ],
              },
            },
            {
              equipment: {
                name: "Zahnradfräsen",
                equipmentid: "202",
                inventoryid: "i202",
                constructiondate: "2012",
                manufacturerserialnumber: "Lieb123456",
                memo: "My memo",
                image: {
                  fileid:
                    "202a58a5-9aec-43df-9591-f8816014d542/202a58a5-9aec-43df-9591-f8816014d543.jpg",
                  fileversion: "101a58a5-9aec-43df-9591-f8816014d542",
                  mimetype: "image/jpeg",
                  url: "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq202/202a58a5-9aec-43df-9591-f8816014d542/202a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240513%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240513T091344Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=890a4fb100ac4e660c96c7e0bcacea47d86028536f94b41a864fa2cc79489272",
                },
                nodeid: "247fn://247uptime.io/abc-eq202",
                hasequipmenttype: [
                  {
                    equipmenttype: {
                      model: "LC502",
                      nodeid:
                        "247fn://247uptime.io/259b5267-3cd7-4b32-9e21-1959b0522888",
                      isequipmenttypeof: [
                        {
                          brand: {
                            name: "Liebherr",
                            nodeid:
                              "247fn://247uptime.io/1569942f-e445-4571-b75e-4da84e5fb993",
                          },
                        },
                      ],
                    },
                  },
                ],
              },
            },
            {
              equipment: {
                name: "Kegelradfräsen",
                equipmentid: "203",
                inventoryid: "i203",
                constructiondate: "2002",
                manufacturerserialnumber: "gle1234567",
                memo: "My memo",
                image: {
                  fileid:
                    "203a58a5-9aec-43df-9591-f8816014d542/203a58a5-9aec-43df-9591-f8816014d543.jpg",
                  fileversion: "101a58a5-9aec-43df-9591-f8816014d542",
                  mimetype: "image/jpeg",
                  url: "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq203/203a58a5-9aec-43df-9591-f8816014d542/203a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240513%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240513T091344Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=4a642840680025e0426bb5b48abdee156cc20601f979fd67e6b6d31bca86c506",
                },
                nodeid: "247fn://247uptime.io/abc-eq203",
                hasequipmenttype: [
                  {
                    equipmenttype: {
                      model: "114",
                      nodeid:
                        "247fn://247uptime.io/d0ce0d59-d70d-4ccd-8fa4-29358127c201",
                      isequipmenttypeof: [
                        {
                          brand: {
                            name: "Gleason",
                            nodeid:
                              "247fn://247uptime.io/2728a232-fe86-4c21-81eb-a47c6651c1e9",
                          },
                        },
                      ],
                    },
                  },
                ],
              },
            },
          ],
        },
      },
    ],
  },
  "247fn://247uptime.io/abc-site2": {
    name: "Werk 2",
    city: "Metzingen",
    zipcode: "76123",
    street: "Fabrikstrasse",
    siteid: "DEMUC2",
    country: "",
    nodeid: "247fn://247uptime.io/abc-site2",
    hasarea: [
      {
        area: {
          name: "Gehäusefertigung",
          areaid: "DEMUCGHF",
          nodeid: "247fn://247uptime.io/abc-area3",
          hasequipment: [
            {
              equipment: {
                name: "Deckelbearbeitung 1",
                equipmentid: "105",
                inventoryid: "i105",
                constructiondate: "2019",
                manufacturerserialnumber: "hell12345",
                memo: "My memo",
                image: {
                  fileid:
                    "105a58a5-9aec-43df-9591-f8816014d542/105a58a5-9aec-43df-9591-f8816014d543.jpg",
                  fileversion: "101a58a5-9aec-43df-9591-f8816014d542",
                  mimetype: "image/jpeg",
                  url: "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq105/105a58a5-9aec-43df-9591-f8816014d542/105a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240513%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240513T091344Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=b3f4bf9cce3c2b0ba4f30b06ead377bf3f6c174e2ba6c5dbd434834d14e97264",
                },
                nodeid: "247fn://247uptime.io/abc-eq105",
                hasequipmenttype: [
                  {
                    equipmenttype: {
                      model: "H2000",
                      nodeid:
                        "247fn://247uptime.io/74c53868-a29e-45e5-b0ef-a7441c60d787",
                      isequipmenttypeof: [
                        {
                          brand: {
                            name: "Heller",
                            nodeid:
                              "247fn://247uptime.io/c61cbcf2-b7c9-4365-a1b9-77ccd6f8a3c0",
                          },
                        },
                      ],
                    },
                  },
                ],
              },
            },
            {
              equipment: {
                name: "Gehäusedeckel",
                equipmentid: "106",
                inventoryid: "i106",
                constructiondate: "2019",
                manufacturerserialnumber: "hell98765",
                memo: "My memo",
                image: {
                  fileid:
                    "106a58a5-9aec-43df-9591-f8816014d542/106a58a5-9aec-43df-9591-f8816014d543.jpg",
                  fileversion: "101a58a5-9aec-43df-9591-f8816014d542",
                  mimetype: "image/jpeg",
                  url: "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq106/106a58a5-9aec-43df-9591-f8816014d542/106a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240513%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240513T091344Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=f2aabae0fcd81009178e0a9e3aa8b63ee4db3aa5e38bcf1f1ce36424266b39e5",
                },
                nodeid: "247fn://247uptime.io/abc-eq106",
                hasequipmenttype: [
                  {
                    equipmenttype: {
                      model: "H2000",
                      nodeid:
                        "247fn://247uptime.io/74c53868-a29e-45e5-b0ef-a7441c60d787",
                      isequipmenttypeof: [
                        {
                          brand: {
                            name: "Heller",
                            nodeid:
                              "247fn://247uptime.io/c61cbcf2-b7c9-4365-a1b9-77ccd6f8a3c0",
                          },
                        },
                      ],
                    },
                  },
                ],
              },
            },
            {
              equipment: {
                name: "Fräsmaschine",
                equipmentid: "107",
                inventoryid: "i107",
                constructiondate: "2017",
                manufacturerserialnumber: "Grob54321",
                memo: "wird z.Zt. nur Spätschicht genutzt",
                image: {
                  fileid:
                    "107a58a5-9aec-43df-9591-f8816014d542/107a58a5-9aec-43df-9591-f8816014d543.jpg",
                  fileversion: "101a58a5-9aec-43df-9591-f8816014d542",
                  mimetype: "image/jpeg",
                  url: "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq107/107a58a5-9aec-43df-9591-f8816014d542/107a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240513%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240513T091344Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=2e7f21dfc904e6ce510496fcd1b3dc56b8f8141191762c554f65f19c59e18301",
                },
                nodeid: "247fn://247uptime.io/abc-eq107",
                hasequipmenttype: [
                  {
                    equipmenttype: {
                      model: "G350",
                      nodeid:
                        "247fn://247uptime.io/58ff6083-739d-4871-88d6-56d52eb97e40",
                      isequipmenttypeof: [
                        {
                          brand: {
                            name: "Grob",
                            nodeid:
                              "247fn://247uptime.io/b787211a-80ea-4861-a4c3-efab55106cf0",
                          },
                        },
                      ],
                    },
                  },
                ],
              },
            },
            {
              equipment: {
                name: "Nachbearbeitung",
                equipmentid: "109",
                inventoryid: "i109",
                constructiondate: "2013",
                manufacturerserialnumber: "hed12345",
                memo: "zur Nachbarbeit",
                image: {
                  fileid:
                    "109a58a5-9aec-43df-9591-f8816014d542/109a58a5-9aec-43df-9591-f8816014d543.jpg",
                  fileversion: "101a58a5-9aec-43df-9591-f8816014d542",
                  mimetype: "image/jpeg",
                  url: "https://minio.service.staging.247uptime.io/clientabcgmbh/247uptime.io/abc-eq109/109a58a5-9aec-43df-9591-f8816014d542/109a58a5-9aec-43df-9591-f8816014d543.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hVkOdV7auMd7P0b9%2F20240513%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240513T091344Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=cbe40e610b2a514248ea37294a896c43ac8f398a3343899b2bc209e16e9e5346",
                },
                nodeid: "247fn://247uptime.io/abc-eq109",
                hasequipmenttype: [
                  {
                    equipmenttype: {
                      model: "Forte 50",
                      nodeid:
                        "247fn://247uptime.io/7199a3aa-9390-45b5-9c67-c6b998722052",
                      isequipmenttypeof: [
                        {
                          brand: {
                            name: "Hedelius",
                            nodeid:
                              "247fn://247uptime.io/994010e1-4167-4703-82a5-630040b548d6",
                          },
                        },
                      ],
                    },
                  },
                ],
              },
            },
          ],
        },
      },
    ],
  },
};

const manualReportsTable = [
  {
    report: {
      id: 1,
      created: 1730838537000,
      werk: "Werk Nürnberg",
      Gerät: "Machinen 1",
      actions: "",
      csvreport: true,
      pdfreport: true,
    }
  },
  {
    report: {
      id: 2,
      created: 1730838537000,
      werk: "Werk Nürnberg",
      Gerät: "Machinen 1",
      actions: "",
      csvreport: true,
      pdfreport: true,
    }
  },
  {
    report: {
      id: 3,
      created: 1730838537000,
      werk: "Werk Nürnberg",
      Gerät: "Machinen 1",
      actions: "",
      csvreport: true,
      pdfreport: true,
    }
  },
  {
    report: {
      id: 4,
      created: 1730838537000,
      werk: "Werk Nürnberg",
      Gerät: "Machinen 1",
      actions: "",
      csvreport: true,
      pdfreport: true,
    }
  },
  {
    report: {
      id: 5,
      created: 1730838537000,
      werk: "Werk Nürnberg",
      Gerät: "Machinen 1",
      actions: "",
      csvreport: true,
      pdfreport: true,
    }
  },
  {
    report: {
      id: 6,
      created: 1730838537000,
      werk: "Werk Nürnberg",
      Gerät: "Machinen 1",
      actions: "",
      csvreport: true,
      pdfreport: true,
    }
  },
  {
    report: {
      id: 7,
      created: 1730838537000,
      werk: "Werk Nürnberg",
      Gerät: "Machinen 1",
      actions: "",
      csvreport: true,
      pdfreport: true,
    }
  },
  {
    report: {
      id: 8,
      created: 1730838537000,
      werk: "Werk Nürnberg",
      Gerät: "Machinen 1",
      actions: "",
      csvreport: true,
      pdfreport: true,
    }
  },
  {
    report: {
      id: 9,
      created: 1730838537000,
      werk: "Werk Nürnberg",
      Gerät: "Machinen 1",
      actions: "",
      csvreport: true,
      pdfreport: true,
    }
  }
  ,
  {
    report: {
      id: 10,
      created: 1730838537000,
      werk: "Werk Nürnberg",
      Gerät: "Machinen 1",
      actions: "",
      csvreport: true,
      pdfreport: true,
    }
  },
  {
    report: {
      id: 11,
      created: 1730838537000,
      werk: "Werk Nürnberg",
      Gerät: "Machinen 1",
      actions: "",
      csvreport: true,
      pdfreport: true,
    }
  },
  {
    report: {
      id: 12,
      created: 1730838537000,
      werk: "Werk Nürnberg",
      Gerät: "Machinen 1",
      actions: "",
      csvreport: true,
      pdfreport: true,
    }
  },
  {
    report: {
      id: 13,
      created: 1730838537000,
      werk: "Werk Nürnberg",
      Gerät: "Machinen 1",
      actions: "",
      csvreport: true,
      pdfreport: true,
    }
  },
  {
    report: {
      id: 14,
      created: 1730838537000,
      werk: "Werk Nürnberg",
      Gerät: "Machinen 1",
      actions: "",
      csvreport: true,
      pdfreport: true,
    }
  },
  {
    report: {
      id: 15,
      created: 1730838537000,
      werk: "Werk Nürnberg",
      Gerät: "Machinen 1",
      actions: "",
      csvreport: true,
      pdfreport: true,
    }
  },
  {
    report: {
      id: 16,
      created: 1730838537000,
      werk: "Werk Nürnberg",
      Gerät: "Machinen 1",
      actions: "",
      csvreport: true,
      pdfreport: true,
    }
  },
  {
    report: {
      id: 17,
      created: 1730838537000,
      werk: "Werk Nürnberg",
      Gerät: "Machinen 1",
      actions: "",
      csvreport: true,
      pdfreport: true,
    }
  },
  {
    report: {
      id: 18,
      created: 1730838537000,
      werk: "Werk Nürnberg",
      Gerät: "Machinen 1",
      actions: "",
      csvreport: true,
      pdfreport: true,
    }
  },
  {
    report: {
      id: 19,
      created: 1730838537000,
      werk: "Werk Nürnberg",
      Gerät: "Machinen 1",
      actions: "",
      csvreport: true,
      pdfreport: true,
    }
  },
  {
    report: {
      id: 20,
      created: 1730838537000,
      werk: "Werk Nürnberg",
      Gerät: "Machinen 1",
      actions: "",
      csvreport: true,
      pdfreport: true,
    }
  },
  {
    report: {
      id: 21,
      created: 1730838537000,
      werk: "Werk Nürnberg",
      Gerät: "Machinen 1",
      actions: "",
      csvreport: true,
      pdfreport: true,
    }
  }
];

export {
  bannerJson,
  dashbaordMachineCardItem,
  backUpListing,
  faqData,
  maintenanceData,
  preImages,
  preVideos,
  preDocs,
  subscribedSites,
  subscribedAreas,
  subscribedEquipmentpools,
  data,
  sideBarMenuItems,
  SitesJSON,
  manualReportsTable,
};
